import React, { Component } from "react";
import $ from 'jquery';
import { saveAs } from 'file-saver';
import '../containers/App.css';
import 'bootstrap';
import config from "../config";
import Login from "./Login";
import MainHeader from "../component/Header/MainHeader";
import LeftPanel from "../component/LeftPanel/Fields";
import BuildDetails from "../component/RightPanel/BuildDetails";
import CopyFieldDetails from "../component/RightPanel/CopyFieldDetails";
import MainData from "../component/MainData/MainData";
import PdfData from "../component/MainData/PdfData";
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import {stateFromHTML} from 'draft-js-import-html';
import {convertToRaw, EditorState, convertFromHTML, convertFromRaw,ContentState} from 'draft-js';
import { TextField } from '@mui/material';
import axios from 'axios';
import { getConfigResponse } from '../Helpers/Common';
import guid from "../Helpers/GUID";
import { ulid } from 'ulid';
import { gapi } from 'gapi-script';
import { Form,Button } from 'react-bootstrap';
import Radio from '@mui/material/Radio';
import moment from 'moment';
import arrayMove from "./arrayMove";
import MongoUserManager from "./MongoUserManager";
import {DebounceInput} from 'react-debounce-input';
import { generatehtmlforFiled } from "../Helpers/FieldPreview";
import {sortableContainer,sortableElement,sortableHandle} from 'react-sortable-hoc';
import emailjs from 'emailjs-com';
import MongoDBMoveMdsManager from "./MongoDBMoveMdsManager";
import MongoDBMdsManager from "./MongoDBMdsManager";
import MongoDBLayoutManager from "./MongoDBLayoutManager";
import TestReviewManager from "./TestReviewManager";
import InstanceManager from "./InstanceManager";
import TranslationManager from "./TranslationManager";
import LookDataManager from "./MongoLookDataManager";
import SuggestFields from "./MongoSuggestFields";
import BasicUploadVideo from "../component/MainData/FlyingUpload.js";

class MdsBuilder extends Component {

    constructor(props) {
        super(props);
        this.state = {
			checkedInc:new Map(),
            checkedReq:new Map(),
			checkedKiosk:new Map(),
			delegateUsers:new Map(),
			delegateTypes:[],
			fieldReviews:[],
			fieldReviewData:[],
			types:[],
			deviceTypes:[],
			limitDeviceTypes:[],
			visitTypes:[],
			anatomyList:[],
			allData:[],
			sheetData:[],
			parentDataSets:[],
			mdsSheets:[],
			mdsSheetNames:[],
			childSheetNames:[],
			layoutSheetNames:[],
			textfields:[],
			basicfields:[],
			functionfields:[],
			gridfields:[],
			formattingfields:[],
			companies:[],
			groupId:[],
			facilityIds:[],
			responsibleRole:[],
			responsiblePerson:[],
			personEmail:'',
			statusType:[],
			statusByfacility:[],
			statusWithMail:[],
			statusWithPos:[],
			sendToPract:[],
			statusList:[],
			allfields:[],
			fileArray:[],
			savedResponse:[],
			savedResponseForm:[],
			selectedRForm:[],
			ogTags:[],
			persons:[],
			facilityData:[],
			uploadedImages:[],
			editOptionKey:[],
			filteredmdsSheets:[],
			preSugg:false,
			showOnlyRequired:false,
			showMdsList:false,
			showFieldEdit:false,
			showBuildEdit:false,
			changeQueType:false,
			showCompany:false,
			hasParentHeader:false,
			showImageUpload:false,
			showUpdate:false,
			showPrefix:false,
			instanceManager:true,
			trackerStatusManager:false,
			taskManager:false,
			workFlow:false,
			workFlowDetails:false,
			workFlowManger:false,
			workFlowProgress:false,
			scheduledworkFlow:false,
			showInlineVideo:true,
			showView:false,
			showFieldCopyView:false,
			showResponseForm:false,
			showResponseData:false,
			hasMdsChanged:false,
			reviewAppropriate:false,
			reviewBetter:false,
			reviewPresented:false,
			calFieldsId:new Map(),
			requiredFields:new Map(),
			optionalFields:new Map(),
			wcalFieldsId:'',
			sheetVisibility:new Map(),
			sheetApiName:new Map(),
			sheetLayoutType:new Map(),
			mdsSheetGuidName:new Map(),
			mdsJsonFilesVersion:new Map(),
			layoutJsonFilesVersion:new Map(),
			layoutTranslation:new Map(),
			sheetGuids:new Map(),
			sheetGuidName:new Map(),
			reasonNotes:new Map(),
			mdsHasFieldSet:new Map(),
			hiddenDimensions:new Map(),
			reviewSheetGuid:'',
			editorSourceHTML:'',
			suffix:'(Copy)',
			IncludeCopy:'Yes',
			asGroup:'',
			dueDate:'',
			imagePath:'',
			sliderMinText:'',
			sliderMaxText:'',
			validationTypefilter:'',
			validation1:'V1',
			validation2:'V1',
			validation3:'V1',
			arraignment:'provided',
			currentStatus:'',
			fieldId:'',
			loadDataSet:'',
			addToParentMds:true,
			hasNotCopy:true,
			selectedSheet:'',
			outputText:false,
			fieldView:false,
			dataMode:'',
			fieldPos:'',
			copyValue:[],
			apiPdfs:[],
			ogAutoTagsArray:[],
			trackerTableData:[],
			saveAs:'',
			fieldPrefix:'Temp-File',
			MDGroups:0,
			spreadsheetId:'',
			allDeviceTypesArray:[],
			trackerRow:[],
			practitioners:[],
			statusLogs:[],
			responseArray:[],
			trackerData:[],
			KeyOptionQ14:[],
			viewMode:'builder',
			delegateFilter:'',
			cFormUID:'',
			kioskResponse:new Map(),
			userClassResponse:new Map(),
			userResponseDate:new Map(),
			userReviewData:new Map(),
			checkedNeeds:new Map(),
			checkedCopyFields:new Map(),
			needsNote:new Map(),
			showTrackerTable:false,
			showTrackerDetails:true,
			showEditHeaders:false,
			trackerMode:false,
			redoOption:'',
			redoInformation:'',
			redoInfo:'',
			fieldDeactivated:'N',
			fieldRegistry:'N',
			addOpDetails:'N',
			Public:'Yes',
			mergeEdit:'Yes',
			autoPopulate:'',
			autoPopulateTags:'',
			formPriority:2,
			formRank:0,
			trackerTableUpdate:false,
			currentStatusChanged:false,
			statusDueDate:'No',
			fabPractitioner:'',
			fabPatientId:'',
			fabJobNumber:'',
			fabPractitionerEmail:'',
			patientFirstName:'',
			patientLastName:'',
			userGuid:localStorage.getItem('user_id'),
			CreatedBy:localStorage.getItem('username'),
			role:localStorage.getItem('role'),
			showAddNew:false,
			showMdsManageSection:false,
			showMongoMoveMdsSection:false,
			showMongoMdsSection:false,
			showTranslationManager:false,
			showLookDataManager:false,
			showSuggestManager:false,
			showMongoSection:false,
			showTestSection:false,
			instances:[],
			addInstanceName:'',
			addMdsSpreadsheetId:'',
			addChildSpreadsheetId:'',
			addLayoutSpreadsheetId:'',
			addMdsTempSheetId:'',
			addMdsTempSheetId:'',
			addChildTempSheetId:'',
			addTestFormSpreadsheetId:'',
			addCopyFieldSpreadsheetId:'',
			addCopyFieldSheetId:'',
			addformDataSheetId:'',
			copyMdsSheets:[],
			copyMdsSheetNames:[],
			destinations:[],
			copyAllData:[],
			copySheetData:[],
			copySelectedSheet:'',
			copyHeaderFiled:'single',
			copyFieldsNumber:'',
			mdsSprdSheets:[],
			mdsSpreadsheets:[],
			mdsSpreadSheetData:[],
			oldMdsSpreadsheetId:'',
			oldMdsTempSheetId:'',
			instanceId:'',
			selectedLayoutGuid:'',
			layoutLanguageData:[],
			combineArray:[],
			layoutData:[],
			originalData:[],
			originalData2:[],
			defaultLayoutFacility:config.defaultLayoutFacility,
			showUserSection:false,
			assignTracks:[],
			patients:[],
			flayoutTypes:[],
			fdeviceTypes:[],
			fvisitTypes:[],
			ftrack:[],
			delegateInFile:[],
			assigedLayouts:[],
			assInstances:[],
			assignInstances:[],
			videoList:[],
			filterVideo:[],
			videoTags:[],
			imageList:[],
			filterImage:[],
			imageTags:[],
			catList:[],
			workflows:[],
			dimensionTxtValue:[],
			childSheets:[],
			allVideoTags:[],
			reviewStatus:'acceptable',
			layoutCategory:'',
			mdsCreate:true,
			responseSaved:false,
			startWorkflow:false,
			JobInitiator:false,
			internalNoteBox:false,
			fieldInternalNoteBox:false,
			fieldRAGBox:false,
			FylesVideoPopup:false,
			suggestOp:false,
			workflowCategory:'',
			oldOptionKey:'',
			selectedKeyTxt:'',
			selectedKeyOpt:'',
			selectedKeyOptVal:'',
			associatedAnatomy:'',
			searchMDS:'',
			optionKeyEnum:'',
			addOpDetailsTxt:'',
			fieldIdentifier:'',
			staticFieldID:'',
			fieldAltText:'',
			suggest1:'',
			suggest2:'',
			suggest2a:'',
			suggest3:'',
			suggest4:'',
			suggest5:'',
			reviewSameForm:'',
			formMode:'Build',
			//SelectedKeyNamesArray:[],
			selectedSheetversion:'1.01',
			mdsHeaders:[["[Field Name]","[Field #]","[Parent #]","[Data Agg]","[Input Text]","[Field Type]","[Answer options]","[Conditional Field GUID]","[Conditional Option]","[Output Text]","[Position #]","[Parent GUID]","[Notes]","[Tags]","Include (default)","Required (default)","Position-Configuration","Action","[Modified-Note]","[Modified-Tags]","Reword-QueType","Reword-AnsOpt","Format-AnsType","Format-QuesType","Format-AnsType","Approved","Need-attention","Need Attention Notes","Modified Field #","Modified  Parent #","Modified Hierarchy","Modified Position ID #","Modified Include","Modified Required","Modified Position-Configuration","Custom Question-title-header GUID","Step Value","Delegate mode","language","PersistenceKey","Button Label","Label Values","OM Name","Description of Instrument","Outcome Type","Validated Populations","Level of Amputations","Time to administer","Validation","Unit","data low limit (min)","data high limit (max)","cut off scrore Population 1","Cut off scrore Population 2","cut off scrore Population 3","Cut off scrore Population 4","cut off scrore Population 5","Score Interpretation","T-scores","Version number","Deactivated","Static Field Name Identifier","Layout Friendly Name","Minimal Detectable Change (MDC) ","What does it mean for clinicians?","MDC Logic","Minimal Clinically Important Difference (MCID) or Minimal Important Change (MIC)","What does it mean for clinicians?","MCID Logic","Reference","last score","Associated Type (OM)","Associated Forms (OM)","Associated Device Types (OM)","Associated Visit Types (OM)","Associated Diagnosis Codes (OM)","Associated Research Projects (OM)","Freely available","Web link to resource","Metadata for FIHR or other standards","<<Industry>>","<<Profession>>","<<sub-specialty>>","<<Workplace setting>>","<<Parent data class>>","<<Parent Sub data class 1>>","<<Parent Sub data class 2>>","<<Parent Sub data class 3>>","<<Parent Sub data class 4>>","<<Parent Sub data class 5>>","<<Parent Sub data class 6>>","Master Data Set GUID","Associated Type (Form)","Associated Forms (Form)","Associated Device Types (Form)","Associated Visit Types (Form)","Associated Diagnosis Codes (Form)","Associated Research Projects (Form)","Date Field last updated","Image Location reference info","Type Master List","Device Type Master List","Visit Type Master List","Conditional Action","Conditonal Action Types master list","Conditional Action Requirements","autoPopulateValue","Response user","Response Date/Time","Response Data","Persistence ","Public Field Bank \"PFB\"","PFB=No Description","Calculation Type","Calculation Fields","Company Name","Custom Field Note","Field GUID","Master Data Set Name","All Delegate Types","MDS_Facility_ID","Group ID","Config_Facility_ID","API_Name","Parent Data Set GUID","Tracking Code","Parent Group","Header Group","\nVisibility","Parent MDS Guid","Parent Field Name","Parent Field Guid","Facility_ID","Group_ID","Branch_ID","USer_ID","Grid Columns","Grid Rows","Mode","Marks","Selected Delegates","Visible In Soogap","Required Fields ","Optional Fields ","OG Auto Tags","Data Provided by API","API Endpoint URL","Type of Data Returned"]],
		}
		
		this.selectMode = this.selectMode.bind(this);
		this.getInstances = this.getInstances.bind(this);
		this.getNotesTemplateUrl = this.getNotesTemplateUrl.bind(this);
		
    }
	
	openFullscreen() {
		$('.full-screen').hide();
		$('.close-screen').show();
		var elem = document.documentElement;
		if (elem.requestFullscreen) {
			elem.requestFullscreen();
		} else if (elem.webkitRequestFullscreen) { /* Safari */
			elem.webkitRequestFullscreen();
		} else if (elem.msRequestFullscreen) { /* IE11 */
			elem.msRequestFullscreen();
		}
	}
	
	closeFullscreen() {
		$('.close-screen').hide();
		$('.full-screen').show();
		var elem = document.documentElement;
		if (document.exitFullscreen) {
			document.exitFullscreen();
		} else if (document.webkitExitFullscreen) { /* Safari */
			document.webkitExitFullscreen();
		} else if (document.msExitFullscreen) { /* IE11 */
			document.msExitFullscreen();
		}
	}
	
	increaseFont(type) {
		if(type=='increase'){
			$(".comments div").children().each(function() {
			  var size = parseInt($(this).css("font-size"));
			  size = size + 2 + "px";
			  $(this).css({
				'font-size': size
			  });
			});
		}else{
			$(".comments div").children().each(function() {
			  var size = parseInt($(this).css("font-size"));
			  size = size - 2 + "px";
			  $(this).css({
				'font-size': size
			  });
			});
		}
	}
	
	loadScript() {
		
		$("body").on('hidden.bs.modal', function (e) {
			var id = e.target.id;
			$("#"+id+" iframe").attr("src", $("#"+id+" iframe").attr("src"));
		});
		var trigger2 = $('.fadeInRight'),
			overlay = $('.overlay'),
		   isClosed2 = false;
		   
	   var trigger3 = $('.imp-left'),
		overlay = $('.overlay'),
	   isClosed3 = false;
		
		function buttonSwitch2() {
			if (isClosed2 === true) {
				overlay.hide();
				trigger2.removeClass('is-open');
				trigger2.addClass('is-closed');
				isClosed2 = false;
			} else {
				overlay.show();
				trigger2.removeClass('is-closed');
				trigger2.addClass('is-open');
				isClosed2 = true;
			}
		}
		
		function buttonSwitch3() {
			if (isClosed3 === true) {
				overlay.hide();
				trigger3.removeClass('is-open');
				trigger3.addClass('is-closed');
				isClosed3 = false;
			} else {
				overlay.show();
				trigger3.removeClass('is-closed');
				trigger3.addClass('is-open');
				isClosed3 = true;
			}
		}
		
		trigger2.click(function () {
			buttonSwitch2();
		});
		
		trigger3.click(function () {
			buttonSwitch3();
		});

		$('[data-toggle="offcanvas-2"]').click(function () {
			$('#wrapper').toggleClass('toggled-2');
		});
		
		$('[data-toggle="offcanvas-3"]').click(function () {
			$('#wrapperImp').toggleClass('toggled-3');
		});
		
		$(function() {

		  'use strict';

		  $('.js-menu-toggle').click(function(e) {

			var $this = $(this);

			

			if ( $('#wrapper').hasClass('toggled') ) {
				$('#wrapper').removeClass('toggled');
				$this.removeClass('active');
			} else {
				$('#wrapper').addClass('toggled');	
				$this.addClass('active');
			}

			e.preventDefault();

		  });
		});
	}
    
    getUrlParameter(name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(window.location.search);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }
	
	componentDidMount() {
        this.loadScript();
		let ApiLibraryUrl = config.ApiLibraryUrl;
		let ApiUsername = config.ApiUsername;
		let ApiPassword = config.ApiPassword;
		this.setState({ApiLibraryUrl,ApiUsername,ApiPassword});
		let role = localStorage.getItem('role');
		let username = localStorage.getItem('username');
		
		this.getLookUpData();
		let that = this;
		setTimeout(function(){
			//gapi.load("client", that.initClient);
		}, 2000);
		
		that.getInstances();
		
		if(role == 'Administrator'){
			that.builderOption(null,'instance');
		}else if(role == 'Improve'){
			$('#wrapper').hide();
			$('.mds-view').hide();
			$('.instance-manager').hide();
			$("#select-view-option").val('test_manager').prop('selected', true);
			setTimeout(function(){
				that.builderOption(null,'test_manager');
			}, 1000);
			
		}else if(role == 'Builder' || role == 'MdsBuilder' || role == 'LayoutBuilder'){
			this.builderOption(null,'builder');
		}else if(role == 'Tester' || role == 'Reviewer' || role == 'NotesLetters' ){
			this.setState({dataMode:'TestForm'});
			this.builderOption(null,'mds_view');
			this.getPatient();
		}
		
		this.UserLayouts(username);
		
		that.getTrackMongo();
		
		this.getPdfFromApi().then(function(response) {
			that.setState({apiPdfs:response});
		}, function(error) {
		  console.error("Failed!", error);
		}) 
		
		this.getVideoFromApi();
		this.getImagesFromApi();
		
		let instanceID = this.getUrlParameter('instance');
		let mode = this.getUrlParameter('mode');
		let formName = this.getUrlParameter('form');
		
		if(instanceID && mode && formName){
			this.setState({selectedInstanceId:instanceID,dataMode:mode,selectedSheet:formName});
			$("#select-view-option").val('builder').prop('selected', true);
			$("#selectMode").val(mode).prop('selected', true);
			this.builderOption(null,'mds_view');
			this.selectModePreview(mode);
		}
    }
	
	initClient = () => {
		let apiKey = $('#apiKey').val();
		let clientId = $('#clientId').val();
		let that =this;
        gapi.client.init({
           'apiKey': apiKey,
           'clientId': clientId,
		   'plugin_name': "chat",
           'scope': 'https://www.googleapis.com/auth/spreadsheets',
           discoveryDocs: config.discoveryDocs,
        })
        .then(() => {
            gapi.auth.authorize({client_id:clientId, scope: 'https://www.googleapis.com/auth/spreadsheets', immediate: true});
        }).catch(error => {
			alert('error::'+ error.details);
		});
    };
	
	selectModePreview=(mode) => {
		$("#wrapper").removeClass('toggled-2');
		$('.custom-TestForm').css('backgroundColor','#ffffff');
		let that = this;
		setTimeout(function(){
			if(mode == 'MDS'){
				that.getMdsData();
			}else if(mode == 'Child'){
				that.getWorkflowData();
				that.getLayoutSheets(that.state.selectedInstanceId);
				that.getLayoutData();
			}
		}, 1000);
	}
	
	preViewModeOnLink=()=>{
		
		let href = window.location.href.split('?')[0];
		let instanceId = this.state.selectedInstanceId;
		let dataMode = this.state.dataMode;
		let selectedSheet = this.state.selectedSheet;
		let linkUrl = href+'?instance='+instanceId+'&mode='+dataMode+'&form='+selectedSheet;
		window.open(linkUrl);
	}
	
	unSelectAllIn=()=>{
		let checkedInc = this.state.checkedInc;
		this.setState({checkedInc:new Map()});
	}
	
	unSelectAllRq=()=>{
		let checkedReq = this.state.checkedReq;
		this.setState({checkedReq:new Map()});
	}
	
	getVideoFromApi=()=>{
		let ApiUrl = config.VideoApiUrl;
		let ApiKey = config.VideoApiKey;
		axios({
			method: 'GET',
			url: ApiUrl,
			headers: {
				'Content-Type': 'application/json',
				'x-api-key': ApiKey,
			}
		})
		.then(response => {
			const data = response.data;
			let videoTags = [];
			let modifyData = [];
			data.map((tgs,i) =>{
				if(tgs.tags){
					tgs.tags.map((val,n) =>{
						videoTags.push(val)
						this.setState({[val]:true});
					});
				}
				let iframeElement = $(tgs.embedCode);
				let src = iframeElement.attr('src');
				let newIfram = '<iframe src="'+src+'" width="480" height="360" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" title="Inline Video" allowfullscreen credentialless></iframe>';
				tgs.embedCode = newIfram;
				modifyData.push(tgs);

			});

			videoTags = this.uniqueArray2(videoTags);
			this.setState({videoList:modifyData,videoTags:videoTags});
			this.setState({FylesVideoPopup:false});
			this.filterVideoList();
			
		}).catch(error => {
			console.log('error::', error);
		})
	}
	
	allVideoTags=()=>{
		let ApiUrl = config.VideoTagApiUrl;
		let ApiKey = config.VideoApiKey;
		axios({
			method: 'GET',
			url: ApiUrl,
			headers: {
				'Content-Type': 'application/json',
				'x-api-key': ApiKey,
			}
		})
		.then(response => {
			const data = response.data;
			this.setState({allVideoTags:data});
			
		}).catch(error => {
			console.log('error::', error);
		})
	}
	
	getImagesFromApi=()=>{
		let ApiUrl = config.ImageApiUrl;
		let ApiKey = config.ImageApiKey;
		axios({
			method: 'GET',
			url: ApiUrl,
			headers: {
				'Content-Type': 'application/json',
				'x-api-key': ApiKey,
			}
		})
		.then(response => {
			const data = response.data;
			let imageTags = [];
			
			data.map((tgs,i) =>{
				if(tgs.tags){
					tgs.tags.map((val,n) =>{
						imageTags.push(val)
						this.setState({[val]:true});
					});
				}
			});
			imageTags = this.uniqueArray2(imageTags);
			this.setState({imageList:data,imageTags:imageTags});
			this.filterImageList();
			
		}).catch(error => {
			console.log('error::', error);
		})
	}
	
	getPdfFromApi = () => {
		let ApiLibraryUrl = config.ApiLibraryUrl;
		let ApiUsername = config.ApiUsername;
		let ApiPassword = config.ApiPassword;
		return new Promise((resolve, reject) => {
			let url = ApiLibraryUrl+'login';
			let formData = new FormData();
			formData.append('username', 'SOOGAP');
			formData.append('password', 'U?G}6!HU9~z}F');
			axios({
				method: 'POST',
				url: url,
				data: formData,
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			})
			.then(response => {
				let token = response.data.token;
				let url2 = ApiLibraryUrl+'pdfs';
				axios({
					method: 'GET',
					url: url2,
					headers: {
						'Authorization': 'Bearer '+token
					}
				})
				.then(response => {
					let pdfs = response.data;
					resolve(pdfs.data.pdfs);
				}).catch(error => {
					console.log('error::', error);

				})
			}).catch(error => {
				console.log('error::', error);

			})
		});
	}
	
	getInstances(){
		let mongoApiUrl = config.mongoApiUrl;
		let url = mongoApiUrl+'instances';
		let role = localStorage.getItem('role');
		let assignInstances = localStorage.getItem('assignInstances');
		let addMdsCapability = localStorage.getItem('addMdsCapability');
		
		let mdsCreate = true;
		let that = this;
		if(assignInstances){
			assignInstances = assignInstances.split(',');
			this.setState({assignInstances});
		}

		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
				const data = response.data;
				that.setState({instances:data,parentDataSets:[]});
				
				this.setState({selectedInstanceName:data[0].InstanceName,selectedInstanceId:data[0].InstanceGuild,selectedInstance:data[0].InstanceGuild});
				
				if(role == 'Tester' || role == 'Reviewer' || role == 'NotesLetters' ){
					this.getLayoutSheets(data[0].InstanceGuild);
				}
				
				if(role == 'Builder'  || role == 'MdsBuilder' || role == 'LayoutBuilder'){
					data.map((val,i) =>{
						if(val.InstanceGuild == assignInstances[0]){
							this.setState({selectedInstanceName:val.InstanceName,selectedInstanceId:val.InstanceGuild,selectedInstance:val.InstanceGuild});
							this.getMdsSheets(val.InstanceGuild);
						}
					});
					if(addMdsCapability == 'Off'){
						mdsCreate = false;
					}
				}else{
					this.getMdsSheets(data[0].InstanceGuild);
				}
				
			this.setState({mdsCreate});
			
		}).catch(error => {
			console.log('error::', error);
		})
	}
	
	UserLayouts=(user)=>{
		let ApiUrl = config.mongoApiUrl;
		let url = ApiUrl+'user-layouts/'+user;
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			const data = response.data;
			if(data){
				let Layouts = data.Layouts;
				let instances = data.assInstances;
				if(Layouts){
					let assigedLayouts = this.state.assigedLayouts;
					let assInstances = this.state.assInstances;
					let insArray = [];
					if(instances){
						
						instances.map((ins) =>{
							let str = ins.split('-');
							if(str[0]){
								insArray.push(str[0]);
							}
						}) 
					}
					
					let assts = this.uniqueArray2(insArray);
					
					this.setState({assigedLayouts:Layouts,assInstances:assts ? assts : []});
				}
			}
		}).catch(error => {
			console.log('error::', error);
		})
	}
	
	getPatient(){
		let mongoApiUrl = config.mongoApiUrl;
		let url = mongoApiUrl+'patient-forms';
		let that = this;
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
				const data = response.data;
				that.setState({patients:data});
				//console.log('data->',data);
		}).catch(error => {
			console.log('error::', error);
		})
	}
	
	resetInstance=() => {
		this.setState({mdsSheets:[],selectedInstance:'',parentDataSets:[]});
	}
	
	getMdsSheets=(selectedInstanceId) => {
		let ApiUrl = config.mongoApiUrl;
		let url = ApiUrl+'mds-files-ins/'+selectedInstanceId;
		let assignedMdsFiles = localStorage.getItem('assignedMdsFiles') ? localStorage.getItem('assignedMdsFiles').split(','): [];
		let data = [];
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
            const sheets = response.data;
			let mdsSheets = sheets.map((sheet) =>{
				let sheetTitle = sheet.MDSName;
				let role = localStorage.getItem('role');
				let username = localStorage.getItem('username');
				if(role == 'Administrator'){
					if(sheetTitle != 'Temp-File' && sheetTitle.indexOf('Temp-') == -1){
						return sheet;
					}
				}else{
					if((username == sheet.CreatedBy || assignedMdsFiles.indexOf(sheet.MDSGuid) != -1) && sheetTitle != 'Temp-File' && sheetTitle.indexOf('Temp-') == -1){
						return sheet;
					}
				}
			});
			
			mdsSheets = mdsSheets.filter(function(x) {
				 return x !== undefined;
			});
			this.setState({mdsSheets});
        })
	}
	
	getMdsSheetsWithfields=(selectedInstanceId) => {
		let ApiUrl = config.mongoApiUrl;
		let url = ApiUrl+'mds-files-ins-v2/'+selectedInstanceId;
		let assignedMdsFiles = localStorage.getItem('assignedMdsFiles') ? localStorage.getItem('assignedMdsFiles').split(','): [];
		let data = [];
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
            const sheets = response.data;
			let mdsSheets = sheets.map((sheet) =>{
				let sheetTitle = sheet.MDSName;
				let role = localStorage.getItem('role');
				let username = localStorage.getItem('username');
				if(role == 'Administrator'){
					if(sheetTitle != 'Temp-File' && sheetTitle.indexOf('Temp-') == -1){
						return sheet;
					}
				}else{
					if((username == sheet.CreatedBy || assignedMdsFiles.indexOf(sheet.MDSGuid) != -1) && sheetTitle != 'Temp-File' && sheetTitle.indexOf('Temp-') == -1){
						return sheet;
					}
				}
			});
			
			mdsSheets = mdsSheets.filter(function(x) {
				 return x !== undefined;
			});
			this.setState({mdsSheets});
        })
	}
	
	getLayoutSheets=(selectedInstanceId) => {
		let assignedLayoutFiles = localStorage.getItem('assignedLayoutFiles') ? localStorage.getItem('assignedLayoutFiles').split(','): [];
		let ApiUrl = config.mongoApiUrl;
		let url = ApiUrl+'layout-files-ins/'+selectedInstanceId;
		let data = [];
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
            const sheets = response.data;
			let role = localStorage.getItem('role');
			let username = localStorage.getItem('username');
			let childSheets = sheets.map((sheet) =>{
				let sheetTitle = sheet.LayoutName;
				if(role == 'Administrator'){
					if(sheetTitle != 'Temp-File' && sheetTitle.indexOf('Temp-') == -1){
						return sheet;
					}
				}else if(role == 'Builder' || role == 'LayoutBuilder'){
					let assigedLayouts = this.state.assigedLayouts;
					if((username == sheet.CreatedBy || assigedLayouts.indexOf(sheet.LayoutGuid) != -1 || assignedLayoutFiles.indexOf(sheet.LayoutGuid) != -1) && sheetTitle != 'Temp-File' && sheetTitle.indexOf('Temp-') == -1){
						return sheet;
					}
					
				}else{
					let assigedLayouts = this.state.assigedLayouts;
					if(assigedLayouts.indexOf(sheet.LayoutGuid) != -1 && sheetTitle != 'Temp-File' && sheetTitle.indexOf('Temp-') == -1){
						return sheet;
					}
				}
			});
			
			childSheets = childSheets.filter(function(x) {
				 return x !== undefined;
			});
			let childSheetNames = [];
			let flayoutTypes = [];
			let fdeviceTypes = [];
			let fvisitTypes = [];
			let ftrack = [];
			sheets.map((sheet, i) => {
				let user_id = this.state.userGuid;
				if(sheet.LayoutName != 'Temp-File-'+ user_id){
					let sht = {sheetId:sheet.LayoutGuid, name:sheet.LayoutName, mode:sheet.Mode, InstanceName:sheet.InstanceName};
					
					let role = localStorage.getItem('role');
					let assigedLayouts = this.state.assigedLayouts;
					if(role == 'Administrator'){
						if(sheet.Hide == false){
							childSheetNames.push(sht);
						}
						if(sheet.Types){
							flayoutTypes.push(sheet.Types.split(','));
						}
						if(sheet.DeviceTypes){
							fdeviceTypes.push(sheet.DeviceTypes.split(','));
						}
						if(sheet.VisitTypes){
							fvisitTypes.push(sheet.VisitTypes.split(','));
						}
						
						if(sheet.Track){
							ftrack.push(sheet.Track.split(','));
						}
					}else if(role == 'Builder'  || role == 'LayoutBuilder'){
						if(username == sheet.CreatedBy || assigedLayouts.indexOf(sheet.LayoutGuid) != -1 || assignedLayoutFiles.indexOf(sheet.LayoutGuid) != -1){
							if(sheet.Hide == false){
								childSheetNames.push(sht);
							}
							if(sheet.Types){
								flayoutTypes.push(sheet.Types.split(','));
							}
							if(sheet.DeviceTypes){
								fdeviceTypes.push(sheet.DeviceTypes.split(','));
							}
							if(sheet.VisitTypes){
								fvisitTypes.push(sheet.VisitTypes.split(','));
							}
							
							if(sheet.Track){
								ftrack.push(sheet.Track.split(','));
							}
						}
					}else{
						
						if(assigedLayouts.indexOf(sheet.LayoutGuid) != -1){
							if(sheet.Hide == false){
								childSheetNames.push(sht);
							}
							if(sheet.Types){
								flayoutTypes.push(sheet.Types.split(','));
							}
							if(sheet.DeviceTypes){
								fdeviceTypes.push(sheet.DeviceTypes.split(','));
							}
							if(sheet.VisitTypes){
								fvisitTypes.push(sheet.VisitTypes.split(','));
							}
							
							if(sheet.Track){
								ftrack.push(sheet.Track.split(','));
							}
						}
					}
				}
			});
				
			flayoutTypes = this.uniqueArray2(flayoutTypes.flat());
			fdeviceTypes = this.uniqueArray2(fdeviceTypes.flat());
			fvisitTypes = this.uniqueArray2(fvisitTypes.flat());
			ftrack = this.uniqueArray2(ftrack.flat());
			this.setState({childSheets,childSheetNames,flayoutTypes,fdeviceTypes,fvisitTypes,ftrack});
        })
		
	}
	
	getLayoutSheetsV2=(selectedInstanceId) => {
		
		let ApiUrl = config.mongoApiUrl;
		let url = ApiUrl+'layout-files-ins-v2/'+selectedInstanceId;
		let data = [];
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
            const sheets = response.data;
			let role = localStorage.getItem('role');
			let username = localStorage.getItem('username');
			let childSheets = sheets.map((sheet) =>{
				let sheetTitle = sheet.LayoutName;
				if(role == 'Administrator'){
					if(sheetTitle != 'Temp-File' && sheetTitle.indexOf('Temp-') == -1){
						return sheet;
					}
				}else if(role == 'Builder' || role == 'LayoutBuilder'){
					let assigedLayouts = this.state.assigedLayouts;
					if((username == sheet.CreatedBy || assigedLayouts.indexOf(sheet.LayoutGuid) != -1) && sheetTitle != 'Temp-File' && sheetTitle.indexOf('Temp-') == -1){
						return sheet;
					}
					
				}else{
					let assigedLayouts = this.state.assigedLayouts;
					if(assigedLayouts.indexOf(sheet.LayoutGuid) != -1 && sheetTitle != 'Temp-File' && sheetTitle.indexOf('Temp-') == -1){
						return sheet;
					}
				}
			});
			
			childSheets = childSheets.filter(function(x) {
				 return x !== undefined;
			});
			let childSheetNames = [];
			let flayoutTypes = [];
			let fdeviceTypes = [];
			let fvisitTypes = [];
			let ftrack = [];
			sheets.map((sheet, i) => {
				let user_id = this.state.userGuid;
				if(sheet.LayoutName != 'Temp-File-'+user_id){
					let sht = {sheetId:sheet.LayoutGuid, name:sheet.LayoutName};
					
					let role = localStorage.getItem('role');
					let assigedLayouts = this.state.assigedLayouts;
					if(role == 'Administrator'){
						if(sheet.Hide == false){
							childSheetNames.push(sht);
						}
						if(sheet.Types){
							flayoutTypes.push(sheet.Types.split(','));
						}
						if(sheet.DeviceTypes){
							fdeviceTypes.push(sheet.DeviceTypes.split(','));
						}
						if(sheet.VisitTypes){
							fvisitTypes.push(sheet.VisitTypes.split(','));
						}
						
						if(sheet.Track){
							ftrack.push(sheet.Track.split(','));
						}
					}else if(role == 'Builder'  || role == 'LayoutBuilder'){
						if(username == sheet.CreatedBy || assigedLayouts.indexOf(sheet.LayoutGuid) != -1){
							
							if(sheet.Hide == false){
								childSheetNames.push(sht);
							}
							if(sheet.Types){
								flayoutTypes.push(sheet.Types.split(','));
							}
							if(sheet.DeviceTypes){
								fdeviceTypes.push(sheet.DeviceTypes.split(','));
							}
							if(sheet.VisitTypes){
								fvisitTypes.push(sheet.VisitTypes.split(','));
							}
							
							if(sheet.Track){
								ftrack.push(sheet.Track.split(','));
							}
						}
					}else{
						
						if(assigedLayouts.indexOf(sheet.LayoutGuid) != -1){
							if(sheet.Hide == false){
								childSheetNames.push(sht);
							}
							if(sheet.Types){
								flayoutTypes.push(sheet.Types.split(','));
							}
							if(sheet.DeviceTypes){
								fdeviceTypes.push(sheet.DeviceTypes.split(','));
							}
							if(sheet.VisitTypes){
								fvisitTypes.push(sheet.VisitTypes.split(','));
							}
							
							if(sheet.Track){
								ftrack.push(sheet.Track.split(','));
							}
						}
					}
				
					
				}
			});
				
			flayoutTypes = this.uniqueArray2(flayoutTypes.flat());
			fdeviceTypes = this.uniqueArray2(fdeviceTypes.flat());
			fvisitTypes = this.uniqueArray2(fvisitTypes.flat());
			ftrack = this.uniqueArray2(ftrack.flat());
			this.setState({childSheets,childSheetNames,flayoutTypes,fdeviceTypes,fvisitTypes,ftrack});
        })
		
	}
	
	uniqueArray2(arr) {
		var a = [];
		for (var i=0, l=arr.length; i<l; i++)
			if (a.indexOf(arr[i]) === -1 && arr[i] !== '')
				a.push(arr[i]);
		return a;
	}
	
	/* clearTempFile=(dataMode) => {
		let mongoApiUrl = config.mongoApiUrl;
		let url = mongoApiUrl+'clear-temp-file/'+dataMode;
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			//console.log('response::', response);
		}).catch(error => {
			console.log('error::', error);
		})
	} */
	
	selectMode=(event) => {
		
		if((this.state.dataMode == 'MDS' || this.state.dataMode == 'Child') && this.state.allData.length > 0){
			
			if (window.confirm('Page will be cleared - Be sure to save your work.')){
				this.clearTempData();
			}else{
				this.setState({dataMode:this.state.dataMode});
				return false;
			}				
		}
		$("input[name='showHide']").prop('checked', false);
		$("#wrapper").removeClass('toggled-2');
		$('.custom-TestForm').css('backgroundColor','#ffffff');
		let mode = event.target.value;
		
		this.setState({sheetData:[],allData:[],showFieldEdit:false,showView:false,filteredmdsSheets:[],searchMDS:''});
		$("#loadSelectMds").val('');
		this.emptyState();
		
		this.setState({dataMode:mode,loadDataSet:'',selectedSheet:'',showTrackerDetails:false});
		let that = this;
		//setTimeout(function(){
			if(mode == 'MDS'){
				that.getMdsData(1);
			}else if(mode == 'Child'){
				that.getWorkflowData();
				that.getLayoutSheets(that.state.selectedInstanceId);
				that.getLayoutData();
			}else if(mode=='TestForm'){
				that.getPatient();
				that.builderOption(null,'mds_view');
				that.getLayoutSheets(that.state.selectedInstanceId);
			}else if(mode=='searchMode'){
				that.getMdsSheetsWithfields(that.state.selectedInstanceId);
			}
			
		//}, 1000);
	}
	
	loadMdsSheet=(event)=>{
		let name = event.target.name;
		let sheet = event.target.value;
		let dataMode = this.state.dataMode;
		this.setState({allData:[],sheetData:[],showResponseForm:false,showResponseData:false});
		$('#loadCopySelectMds').val('');
		this.emptyState();
		let Window = $(window);
		let windowsize = Window.width();
		
		if(windowsize <= '1024' && name && sheet != ''){
			$(".js-menu-toggle").trigger("click");
		}
		
		if(name == 'loadMds' && sheet != ''){
			$('.load-select-child').val('');
			
		}else if(name == 'loadChild' && sheet != ''){
			$("#loadSelectMds option:selected").prop("selected", false);
			$("#loadLayout option:selected").prop("selected", false);
		}else{
			name = '';
			sheet = '';
			this.setState({sheetData:[],allData:[]});
		}
		
		this.setState({loadDataSet:name,selectedSheet:sheet,requiredFields:new Map(),optionalFields:new Map(),outputText:false});
		let that = this;
		if(dataMode == 'MDS'){
			that.getMdsData(0,sheet);
		}else if(dataMode == 'Child' || dataMode == 'TestForm'){
			that.getLayoutData(sheet);
		}
		$("input[name='showOutputText']").prop('checked', false);
	}
	
	getLookUpData=() => {
		
		let mongoApiUrl = config.mongoApiUrl;
		let url = mongoApiUrl+'look-up-data';
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			let data = response.data;
			this.setState({delegateTypes:data[0]['delegateTypes'],types:data[0]['types'],deviceTypes:data[0]['deviceTypes'],visitTypes:data[0]['visitTypes'],textfields:data[0]['textfields'],basicfields:data[0]['basicfields'],functionfields:data[0]['functionfields'],gridfields:data[0]['gridfields'],formattingfields:data[0]['formattingfields'],allfields:data[0]['allfields'],companies:data[0]['companies'],groupId:data[0]['groupId'],statusList:data[0]['statusList'],anatomyList:data[0]['anatomy']});
			
			
		}).catch(error => {
			console.log('error::', error);
		})
		
		let url2 = mongoApiUrl+'tracker-data';
		axios({
			method: 'GET',
			url: url2,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			let trackerData = response.data[0]['trackerData'];
			let facilityIds = [];
			let facilityUid = [];
			let responsibleRole = [];
			let trackerPerson = [];
			let leadTechnician = [];
			let prostheticTechnicians = [];
			let plasticTechnicians = [];
			let orthoticTechnicians = [];
			let authorizationAgents = [];
			let schedulingAgents = [];
			let practitioners = [];
			let facilityData = [];
			trackerData[0].map(function(role,i) {
				if(i > 1){
					responsibleRole.push(role);
				}
			})
			trackerData.map(function(val,i) {
				if(i > 0){
					if(val[1]){
						let ids = val[0]+'|'+val[1]+'|original';
						if(!val[2]){
							ids = val[0]+'|'+val[1]+'|custom';
						}
						facilityIds.push(ids);
						facilityUid.push(val[1]);
					}
					if(val[2]){
						leadTechnician.push(val[2]);
					}
					
					if(val[3]){
						prostheticTechnicians.push(val[3]);
					}
					
					if(val[4]){
						plasticTechnicians.push(val[4]);
					}
					
					if(val[5]){
						orthoticTechnicians.push(val[5]);
					}
					
					if(val[6]){
						authorizationAgents.push(val[6]);
					}
					
					if(val[7]){
						schedulingAgents.push(val[7]);
					}
					
					if(val[8]){
						practitioners.push(val[8]);
					}
				}
			})
			
			facilityUid.map(function(uid,i) {
				facilityData[uid] = [facilityIds[i]]
				facilityData[uid]['Lead technician'] = leadTechnician[i] ? leadTechnician[i].split(',') : [];
				facilityData[uid]['Prosthetic technicians'] = prostheticTechnicians[i] ? prostheticTechnicians[i].split(',') : [];
				facilityData[uid]['Plastic technicians'] = plasticTechnicians[i] ? plasticTechnicians[i].split(',') : [];
				facilityData[uid]['Orthotic Technicians'] = orthoticTechnicians[i] ? orthoticTechnicians[i].split(',') : [];
				facilityData[uid]['Authorization agents'] = authorizationAgents[i] ? authorizationAgents[i].split(',') : [];
				facilityData[uid]['Scheduling agents'] = schedulingAgents[i] ? schedulingAgents[i].split(',') : [];
				facilityData[uid]['Practitioners'] = practitioners[i] ? practitioners[i].split(',') : [];
			})
			
			this.setState({trackerData,facilityData,facilityIds,responsibleRole});
			
			
		}).catch(error => {
			console.log('error::', error);
		})
		
		
		let url3 = mongoApiUrl+'autotag-data';
		axios({
			method: 'GET',
			url: url3,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			let ogTags = response.data[0]['tags'];
			this.setState({ogTags});
		}).catch(error => {
			console.log('error::', error);
		})
		
    }
	
	getPlaceholder=(val) => {
		let allfields = this.state.allfields;
		let pls = '';
		allfields.map((field,i) =>{
			let str = field.split(':');
			if(val.toLowerCase() == str[0].toLowerCase()){
				pls = str[1];
			}
		});
		return pls;
	}
	
	improveMode=(sheetGuid,sheetName)=>{
		//alert(sheetGuid);
		this.setState({selectedSheet:sheetName,dataMode:'Child',reviewSheetGuid:sheetGuid});
		this.builderOption(null,'improve');
		this.getFieldReview(sheetGuid);
		let that = this;
		setTimeout(function(){
			that.getLayoutData();
		}, 2000);
		
	}
	
	getFieldReview=(sheetGuid)=>{
		let mongoApiUrl = config.mongoApiUrl;
		let url = mongoApiUrl+'field-reviews/'+sheetGuid;
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			let res = response.data;
			this.setState({fieldReviews:res});
		}).catch(error => {
			console.log('error::', error);
		})
	}
	
	getMdsData=(type,sheet) => {
		let selectedSheet = this.state.selectedSheet;
		if(sheet){
			selectedSheet = sheet;
		}
		
        let user_id = this.state.userGuid;
        let sheetName = 'Temp-File-'+user_id;
		
		if(selectedSheet != '' && selectedSheet !== undefined){
			sheetName = selectedSheet;
		}

		if(this.state.mdsCreate == false && sheetName == 'Temp-File-'+user_id){
			return false;
		}
		let ApiUrl = config.mongoApiUrl;
		let url = ApiUrl+'mds-file/'+sheetName;
		let data = [];
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
            const data = response.data;
			let allData = [];
			let checkedInc = this.state.checkedInc;
			let checkedReq = this.state.checkedReq;
			let checkedKiosk = this.state.checkedKiosk;
			let delegateUsers = this.state.delegateUsers;
			let fields = data['Fields'];
			let formMode = data['Mode'];
			let selectedSheetversion = sheetName != 'Temp-File-'+user_id ? data['Version'] : '1.01';
			
			if(fields){
			fields.map((val,i)=>{
				
				if(i > 0){
					let fieldGuid = ulid();
					if(sheetName == 'Temp-File-'+user_id && type == 1){
						val[117] = fieldGuid;
					}
					
					allData.push(val);
					checkedInc.set(val[0], val[14]);
					checkedReq.set(val[0], val[15]);
					checkedKiosk.set(val[0], val[37]);
					let posData = val[16];
					if(posData && val[37] == 'Y'){
						posData = posData.split(',');
						let array = posData.slice(9);
						array = array.filter(function(x) {
							 return x !== '';
						});
						delegateUsers.set(val[0], array);
					}else{
						delegateUsers.set(val[0], ['CPO'])
					}
					
					if(this.state.loadDataSet == 'loadLayout' && (val[5] == 'image' || val[5] == 'inlinevideo')){
						this.getResponseValue(val[0],val[99]);
					}
				}
			});
			}
			
			if(this.state.loadDataSet == 'loadMds'){
				if(allData.length > 0){
					let fieldPrefix = allData[0][118];
					let mdsDataName = allData[0][118];
					let mdsCompany = allData[0][115];
					let mdsCompanyArray = allData[0][115] ? allData[0][115].split(',') : []; 
					let mdsFacility = allData[0][120] ? allData[0][120] : this.state.defaultLayoutFacility;
					let mdsGroupId = allData[0][121];
					let mdsGroupIdArray = allData[0][121] ? allData[0][121].split(',') : []; 
					let allDelegate = allData[0][119]; 
					let allDelegateArray = allData[0][119] ? allData[0][119].split(',') : []; 
					let allTypes = allData[0][92]; 
					let allTypesArray = allData[0][92] ? allData[0][92].split(',') : [];  
					let allDeviceTypes = allData[0][94]; 
					let allDeviceTypesArray = allData[0][94] ? allData[0][94].split(',') : []; 
					let allVisitTypes = allData[0][95]; 
					let allVisitTypesArray = allData[0][95] ? allData[0][95].split(',') : [];
					let layoutType = allData[0][138] ? allData[0][138] : '';
					
					let limitDeviceTypes = [];
					
					this.state.deviceTypes.map((val,i)=>{
						if(allTypes == val.type || allTypes == 'Orthotic,Prosthetic'){
							limitDeviceTypes.push(val.name);
						}
					})
					
					if(mdsDataName == ''){
						this.setState({hasNotCopy:false});
					}
					
					this.setState({limitDeviceTypes,fieldPrefix,addToParentMds:false,mdsDataName,mdsCompany,mdsFacility,mdsGroupId,allDelegate,allTypes,allDeviceTypes,allVisitTypes,mdsCompanyArray,mdsGroupIdArray,allDelegateArray,allDeviceTypesArray,allTypesArray,allVisitTypesArray,layoutType});
				}
			}else{
				if(allData.length > 0){
					let s = allData[0][0];
					let lastIndex = s.lastIndexOf("-")
					let fieldPrefix = s.substring(0, lastIndex);
					
					if(fieldPrefix == ''){
						fieldPrefix = 'Temp-File-'+user_id;
					}
					this.setState({fieldPrefix});
				}
				this.setState({addToParentMds:true,mdsDataName:'',mdsCompany:'',mdsFacility:'',mdsGroupId:'',allDelegate:'',allTypes:'',allDeviceTypes:'',allVisitTypes:'',mdsCompanyArray:[],mdsGroupIdArray:[],allTypesArray:[],allDelegateArray:[],allDeviceTypesArray:[],allVisitTypesArray:[],layoutType:'',showTrackerDetails:false});
			}
			
			let ids =[];
			let mainData =[];
			let copiedFields = 0;
			{allData.map((data,i)=>{
				var key = data[10];
				mainData[key] = data; 
				
				if(this.state.loadDataSet == 'loadLayout'){
					let needsNote = this.state.needsNote;
					if(data[27]){
						needsNote.set(data[0], data[27]);
					}else{
						needsNote.delete(data[0]); 
					}
					this.setState({needsNote});
				}
				
				if(data[134]){
					copiedFields = copiedFields+1;
				}
				
			})}
			
			let dbArray = this.checkKey2(mainData, '', ids, 2, 1);
			
			let MDGroups = this.state.MDGroups;
			let mdsDataLen = allData.length;
			let mdsDataLeft = mdsDataLen-copiedFields;
			let copyFieldsNumber = mdsDataLeft+'/'+mdsDataLen;
			this.setState({originalData:fields,originalData2:fields,sheetData:dbArray,allData,formMode,showUpdate:true,checkedInc:checkedInc,checkedReq:checkedReq,checkedKiosk:checkedKiosk,delegateUsers:delegateUsers,delegateFilter:'',MDGroups:0,fieldPos:'',copyFieldsNumber,selectedSheetversion});
			setTimeout(function(){
				$(".select-pos").prop('checked', false);
			}, 2000);
			
        })
		
    }
	
	getLayoutData=(sheet) => {
		let selectedSheet = this.state.selectedSheet;
		if(sheet){
			selectedSheet = sheet;
		}
        let user_id = this.state.userGuid;
        let sheetName = 'Temp-File-'+user_id;
        if(selectedSheet != '' && selectedSheet !== undefined){
			sheetName = selectedSheet;
		}
		$('.custom-TestForm').css('backgroundColor','#ffffff');
		let ApiUrl = config.mongoApiUrl;
		let url = ApiUrl+'layout-file/'+sheetName;
		let data = [];
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
            const data = response.data;
			let allData = [];
			let checkedInc = this.state.checkedInc;
			let checkedReq = this.state.checkedReq;
			let checkedKiosk = this.state.checkedKiosk;
			let delegateUsers = this.state.delegateUsers;
			let LayoutName = data['LayoutName'] != 'Temp-File-'+user_id ? data['LayoutName'] : '';
			let LayoutGuid = data['LayoutGuid'];
			let associatedAnatomy = data['AssociatedAnatomy']; 
			let layoutCategory = data['LayoutCategory'];
			let startWorkflow = data['startWorkflow'] ? data['startWorkflow'] : false;
			let JobInitiator = data['JobInitiator'] ? data['JobInitiator'] : false;
			let workflowCategory = data['workflowCategory'] ? data['workflowCategory'] : 1;
			let selectedSheetversion = sheetName != 'Temp-File-'+user_id ? data['Version'] : '1.01';
			let fields = data['Fields'];
			let formMode = data['Mode'];
			let deleg = ['CPO'];
			
			let internalNote = data['InternalNote'] != 'null' ? data['InternalNote'] : '';
			if(internalNote){
				this.setState({internalNoteBox:true});
			}else{
				this.setState({internalNoteBox:false});
			}
			
			
			if(fields){
				fields.map((val,i)=>{
					if(i > 0){
						allData.push(val);
						checkedInc.set(val[0], val[14]);
						checkedReq.set(val[0], val[15]);
						checkedKiosk.set(val[0], val[37]);
						let posData = val[16];
						if(posData && val[37] == 'Y'){
							posData = posData.split(',');
							let array = posData.slice(9);
							array = array.filter(function(x) {
								 return x !== '';
							});
							
							deleg.push(array);
							delegateUsers.set(val[0], array);
						}else{
							delegateUsers.set(val[0], ['CPO'])
						}
						
						if(val[5] == 'image' || val[5] == 'inlinevideo'){
							this.getResponseValue(val[0],val[99]);
						}
					}
				});
			}

			let ids =[];
			let mainData =[];
			let delegateInFile = this.uniqueArray2(deleg.flat());
			{allData.map((data,i)=>{
				var key = data[10];
				mainData[key] = data;
			})}
			
			if(allData.length > 0){
					
				let mdsCompany = allData[0][115];
				let layoutFriendlyName = allData[0][62];
				let mdsCompanyArray = allData[0][115] ? allData[0][115].split(',') : []; 
				let mdsFacility = allData[0][120] ? allData[0][120] : this.state.defaultLayoutFacility;
				let mdsGroupId = allData[0][121];
				let mdsGroupIdArray = allData[0][121] ? allData[0][121].split(',') : []; 
				let allDelegate = allData[0][119]; 
				let allDelegateArray = allData[0][119] ? allData[0][119].split(',') : []; 
				let allTypes = allData[0][92]; 
				let allTypesArray = allData[0][92] ? allData[0][92].split(',') : [];  
				let allDeviceTypes = allData[0][94]; 
				let allDeviceTypesArray = allData[0][94] ? allData[0][94].split(',') : []; 
				let allVisitTypes = allData[0][95]; 
				
				let allVisitTypesArray = allData[0][95] ? allData[0][95].split(',') : [];
				let layoutType = allData[0][138] ? allData[0][138] : '';
				
				let limitDeviceTypes = [];
				this.state.deviceTypes.map((val,i)=>{
					if(associatedAnatomy && associatedAnatomy != 'All'){
						if((allTypes == val.type || allTypes == 'Orthotic,Prosthetic') && associatedAnatomy == val.anatomy){
							limitDeviceTypes.push(val.name);
						}
					}else if(allTypes == val.type || allTypes == 'Orthotic,Prosthetic'){
						limitDeviceTypes.push(val.name);
					}
				})

				this.setState({layoutFriendlyName,limitDeviceTypes,mdsDataName:LayoutName,mdsCompany,mdsFacility,mdsGroupId,allDelegate,allTypes,associatedAnatomy,allDeviceTypes,allVisitTypes,mdsCompanyArray,mdsGroupIdArray,allDelegateArray,allDeviceTypesArray,allTypesArray,allVisitTypesArray,layoutType});
			}
			
			let dbArray = this.checkKey2(mainData, '', ids, 2, 1);

			this.setState({delegateInFile,originalData:fields,originalData2:fields,sheetData:dbArray,allData,formMode,showUpdate:true,checkedInc:checkedInc,checkedReq:checkedReq,checkedKiosk:checkedKiosk,delegateUsers:delegateUsers,delegateFilter:'',MDGroups:0,fieldPos:'',LayoutName,selectedLayoutGuid:LayoutGuid,selectedSheetversion,layoutCategory,startWorkflow,JobInitiator,workflowCategory,internalNote,reviewSameForm:ulid()});
			setTimeout(function(){
				$(".select-pos").prop('checked', false);
			}, 2000);
        })
    }
	
	updateDataKiosk=(fieldId) =>{
		let allData = this.state.allData;
		if(allData.length > 0){
			allData.map((rowDatas,i)=>{
				if(rowDatas[0] == fieldId){
					let checkedKiosk = this.state.checkedKiosk;
					let delegate = checkedKiosk.get(rowDatas[0]);
					let uArray = ['CPO'];
					if(this.state.delegateUsers.get(rowDatas[0])){
						uArray = this.state.delegateUsers.get(rowDatas[0]);
					}else{
						let posData = rowDatas[16];
						if(posData){
							posData = posData.split(',');
							uArray = posData.slice(9);
							uArray = uArray.filter(function(x) {
								 return x !== '';
							});
						}
					}
					let uType = [];
					let kioskType = this.state.delegateTypes;
					
					if(kioskType){
						kioskType.map(function(type,i) {
							type = type.split(':');
							uType.push(type[1]);
						})
					}else{
						uType = ['CPO']
					}
					
					let final_arr = uArray;
					let final_arr1 = uType;

					let array=[];
					if(final_arr){
						final_arr1.map((item,i)=>{
							if(final_arr.includes(item) == true){
								array.push(item)
							}else if(item == 'CPO'){
								array.push('CPO')
							}else{
								array.push('')
							}
						})
					}
					let userTypes = array.toString();
					if(userTypes == undefined){
						userTypes = 'CPO,,,,,,,,,,';
					}
					
					let delegateUsers = uArray.toString();
					delegateUsers = delegateUsers.replaceAll(',','|');
					
					if(delegate == 'N'){
						userTypes = 'CPO,,,,,,,,,,';
						delegateUsers = ['CPO']
					}
					
					let parentID = rowDatas[2];
					if(rowDatas[5].toLowerCase() == 'parent header'){
						parentID ='';
					}
					rowDatas[16] = rowDatas[0]+',,'+parentID+','+rowDatas[7]+','+rowDatas[8]+','+rowDatas[14]+','+rowDatas[15]+','+rowDatas[10]+','+delegate+','+userTypes;
					rowDatas[37] = delegate;
					rowDatas[140] = "["+delegateUsers+"]";
				}
			});
			//console.log('allData->',allData);
			this.updateKioskHeaders2(allData);
		}
	}
	
	updateKioskHeaders2=(fieldDataArray)=>{
		let data = this.state.originalData2;
		let dataArray = []; 
		data.map((rows, i) => {
			dataArray.push(rows);
		});	
		let reverse = dataArray.reverse();
		let checkedKiosk = this.state.checkedKiosk;
		let delegateUsers = this.state.delegateUsers;
		let currentDate = new Date().toLocaleString("en-US", {timeZone: "America/New_York"}).replace(',','');
		reverse.map((rows, i) => {
			let uArray = delegateUsers.get(rows[0]);
			fieldDataArray.map((rs, i) => {
				
				if(rows[11] == rs[117]){
					let uArrayParent = delegateUsers.get(rs[0]);
					let alldelegate = uArrayParent.concat(uArray);
					let aUnique = this.uniqueArray2(alldelegate);
					delegateUsers.set(rs[0], aUnique);
					let delegateAll = aUnique.toString();
					let dUsers = delegateAll.replaceAll(',','|');
					
					let uType = [];
					let kioskType = this.state.delegateTypes;
					
					if(kioskType){
						kioskType.map(function(type,i) {
							type = type.split(':');
							uType.push(type[1]);
						})
					}else{
						uType = ['CPO']
					}
					
					let final_arr = aUnique;
					let final_arr1 = uType;

					let array=[];
					if(final_arr){
						final_arr1.map((item,i)=>{
							if(final_arr.includes(item) == true){
								array.push(item)
							}else if(item == 'CPO'){
								array.push('CPO')
							}else{
								array.push('')
							}
						})
					}
					let userTypes = array.toString();
					
					if(aUnique.length > 1){
						rs[37] = "Y";
						checkedKiosk.set(rs[0], "Y");
						rs[16] = rs[0]+',,'+rs[1]+','+rs[7]+','+rs[8]+','+rs[14]+','+rs[15]+','+rs[10]+',Y,'+userTypes;
					}
					rs[140] = "["+dUsers+"]";
					rs[98] = currentDate;
				}
			});
		});
		//console.log('fieldDataArray->',fieldDataArray);
		this.setState({allData:fieldDataArray,checkedKiosk,delegateUsers});
	}
	
	updateData=(msg=false) =>{
		let allData = this.state.allData;
		if(allData.length > 0){
			let spreadsheetId = this.state.spreadsheetId;
			let selectedSheet = this.state.selectedSheet;
			let mdsGuid = ulid();
			let user_id = this.state.userGuid;
			var sheetName = 'Temp-File-'+user_id;
			if(selectedSheet != '' && selectedSheet !== undefined){
				mdsGuid = allData[0][91];
				sheetName = selectedSheet;
			}
			let fieldID = '';
			let j = 0;
			let n = 0;
			let s = 0;
			let q = 0;
			let parent1 = '';
			let parent2 = '';
			let parent3 = '';
			let parentID = '';
			let parentGuid = '';
			let parentGuid1 = '';
			let parentGuid2 = '';
			let parentGuid3 = '';
			
			let characters = "abcdefghijklmnopqrstuvwxyz";
			let length = 3;
			let randomStr = "";

			for (let i = 0; i < length; i++) {
			  const randomNum = Math.floor(Math.random() * characters.length);
			  randomStr += characters[randomNum];
			}
			
			let fieldPrefix = this.state.fieldPrefix;
			
			//let version = allData[0][59] ? allData[0][59] : '1.01';
			let version = this.state.selectedSheetversion;
			if(sheetName != 'Temp-File' && version != '' && msg && msg != 'pos' && msg != 'del' && msg != 'kiosk'){
				//version = parseFloat(version) + parseFloat(0.01);
			}
			
			allData[0][59] = version != '2.0' ? parseFloat(version).toFixed(2) : version;
			
			let mdsName = allData[0][118];
			let chtr = 0;
			allData.map((field,i)=>{
				let id = i+1;
				if(this.state.dataMode == 'MDS'){
					allData[i][0] = fieldPrefix+'-'+id;
				}else{
					allData[i][0] = sheetName+'-'+id;
				}
				allData[i][10] = id;
				if(field[5].toLowerCase() == 'parent header'){
					
					if(field[4]){
						fieldID = field[4].substring(0, 3)+characters[chtr];
					}else if(field[1] == ''){
						fieldID = randomStr
					}
					
					allData[i][1] = fieldID;
					allData[i][2] = 'MDS';
					parentID = fieldID;
					parent1 = fieldID;
					parentGuid = field[117];
					parentGuid1 = field[117];
					j = 0;
					n = 0;
					s = 0;
					chtr++;
				}else if(field[5].toLowerCase() == 'child header 1'){
					j = j+1
					let child = 'c'+j;
					allData[i][1] = fieldID+child;
					allData[i][2] = parent1;
					allData[i][11] = parentGuid1;
					parentID = fieldID+child
					parent2 = fieldID+child
					parentGuid = field[117];
					parentGuid2 = field[117];
					//n = 0;
				}else if(field[5].toLowerCase() == 'child header 2'){
					n = n+1
					let child = 'cc'+n;
					allData[i][1] = fieldID+child;
					allData[i][2] = parent2 ? parent2 : parentID;
					allData[i][11] = parentGuid2 ? parentGuid2 : parentGuid;
					parentID = fieldID+child
					parent3 = fieldID+child
					parentGuid = field[117];
					parentGuid3 = field[117];
				}else if(field[5].toLowerCase() == 'child header 3'){
					s = s+1
					let child = 'ccc'+s;
					allData[i][1] = fieldID+child;
					allData[i][2] = parent3 ? parent3 : parentID;
					allData[i][11] = parentGuid3 ? parentGuid3 : parentGuid;
					parentID = fieldID+child
					parentGuid = field[117];
				}else{
					q = q+1
					allData[i][1] = 'q'+q;
					allData[i][2] = parentID;
					allData[i][11] = parentGuid;
				}
			});
			
			let updateRows=[];
			let dates=[];
			let rowId='';
			
			let checkedInc = this.state.checkedInc;
			let checkedReq = this.state.checkedReq;
			let checkedKiosk = this.state.checkedKiosk;
			
			allData.map((rowDatas, i) => {
				rowId = (i+2);
				let include = checkedInc.get(rowDatas[0]);
				if(include == undefined || msg == 'pos' || msg == 'del'){
					include = rowDatas[14];
				}
				let required = checkedReq.get(rowDatas[0]);
				if(required == undefined || msg == 'pos' || msg == 'del'){
					required = rowDatas[15];
				}
				let delegate = checkedKiosk.get(rowDatas[0]);
				if(delegate == undefined || msg == 'pos' || msg == 'del'){
					delegate = rowDatas[37];
				}
				let uArray = ['CPO'];
				
				if(this.state.delegateUsers.get(rowDatas[0]) && msg != 'pos' && msg == 'kiosk'){
					uArray = this.state.delegateUsers.get(rowDatas[0]);
				}else{
					let posData = rowDatas[16];
					if(posData){
						posData = posData.split(',');
						uArray = posData.slice(9);
						uArray = uArray.filter(function(x) {
							 return x !== '';
						});
					}
				}
				let uType = [];
				let kioskType = this.state.delegateTypes;
				
				if(kioskType){
					kioskType.map(function(type,i) {
						type = type.split(':');
						uType.push(type[1]);
					})
				}else{
					uType = ['CPO']
				}
				
				let final_arr = uArray;
				let final_arr1 = uType;

				let array=[];
				if(final_arr){
					final_arr1.map((item,i)=>{
						if(final_arr.includes(item) == true){
							array.push(item)
						}else if(item == 'CPO'){
							array.push('CPO')
						}else{
							array.push('')
						}
					})
				}
				let userTypes = array.toString();
				if(userTypes == undefined){
					userTypes = 'CPO,,,,,,,,,,';
				}
				
				let delegateUsers = uArray.toString();
				delegateUsers = delegateUsers.replaceAll(',','|');
				
				if(delegate == 'N'){
					userTypes = 'CPO,,,,,,,,,,';
					delegateUsers = ['CPO']
				}
				
				
				
				let parentID = rowDatas[2];
				if(rowDatas[5].toLowerCase() == 'parent header'){
					parentID ='';
				}
				rowDatas[16] = rowDatas[0]+',,'+parentID+','+rowDatas[7]+','+rowDatas[8]+','+include+','+required+','+rowDatas[10]+','+delegate+','+userTypes;
				rowDatas[14] = include;
				rowDatas[15] = required;
				rowDatas[37] = delegate;
				rowDatas[140] = "["+delegateUsers+"]";
				rowDatas[91] = mdsGuid;
				if(this.state.dataMode == 'MDS'){
					rowDatas[118] = mdsName;
				}
				let date = new Date(rowDatas[98]);
				if(date != 'Invalid Date'){
					dates.push(date);
				}
			});
			
			let arr1 = this.state.mdsHeaders;
			let allMdsData = arr1.concat(allData);
			
			//console.log('allMdsData->',allMdsData);
			
			let maximumDate = new Date(Math.max.apply(null, dates));
			let modifiedDate = new Date(maximumDate).toLocaleString("en-US").replace(',','');
			
			let fieldData = {
				"MDSName": sheetName,
				"MDSGuid": mdsGuid,
				"Version": version != '2.0' ? parseFloat(version).toFixed(2) : version,
				"ModifiedDate":  moment(modifiedDate).format('YYYY-MM-DD HH:mm:ss'),
				"Fields": allMdsData,
			}
			
			if(this.state.dataMode == 'Child'){
				fieldData = {
					"LayoutName": sheetName,
					"LayoutGuid": mdsGuid,
					"Version": version != '2.0' ? parseFloat(version).toFixed(2) : version,
					"ModifiedDate":  moment(modifiedDate).format('YYYY-MM-DD HH:mm:ss'),
					"Fields": allMdsData,
				}
			}
			
			this.mongoUpdateData(fieldData,sheetName,msg);
			
			$('.btn-undo-data').hide();
		}
	}
	
/* 	clearGuidData=() =>{
		let allData = this.state.allData;
		if(allData.length > 0){
			let spreadsheetId = this.state.spreadsheetId;
			let selectedSheet = this.state.selectedSheet;
			let mdsGuid = ulid();
			var sheetName = 'Temp-File';
			allData.map((field,i)=>{
				let id = i+1;
				let fieldGuid = ulid();
				allData[i][117] = fieldGuid;

			});
			
			let arr1 = this.state.mdsHeaders;
			let allMdsData = arr1.concat(allData);
			
			let fieldData = {
				"MDSName": sheetName,
				"MDSGuid": mdsGuid,
				"Version": '1.01',
				"Fields": allMdsData,
			}
			
			if(this.state.dataMode == 'Child'){
				fieldData = {
					"LayoutName": sheetName,
					"LayoutGuid": mdsGuid,
					"ModifiedDate": '',
					"Version": '1.01',
					"Fields": allMdsData,
				}
			}
			this.updateData();
		}
	} */
	
	mongoUpdateData=(fieldData,sheetName,msg)=>{
		if(msg == 'kiosk'){
			this.updateKioskHeaders(fieldData);
		}
		let dataMode = this.state.dataMode;
		let mongoApiUrl = config.mongoApiUrl;
		let url = mongoApiUrl+'update-mds-field';
		if(dataMode == 'Child'){
			url = mongoApiUrl+'update-layout-field';
		}
		axios({
			method: 'POST',
			url: url,
			data: JSON.stringify(fieldData),
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			let res = response.data;
			
			if(res == true){
				
				if(msg && msg != 'pos' && msg != 'del' && msg != 'kiosk' && msg != 'field-update'){
					alert('Update Data Successfully!');
				}else if(msg == 'pos'){
					alert('Field added Successfully in the chosen position!');
				}else if(msg == 'del'){
					alert('Field deleted Successfully!');
				}
				
				if(dataMode == 'MDS'){
					/* if(msg != 'del'){
						this.getMdsSheets(this.state.selectedInstanceId);
					} */
					this.getMdsData(0);
					
					if(sheetName && msg != 'del'){
						this.uploadMdsJsonMongoDb(sheetName);
					}
				}else{
					this.getLayoutData();
					//if(msg && msg != 'pos' && msg != 'del' && msg != 'kiosk'){
						if(sheetName && msg != 'del'){
							this.uploadLayoutJsonMongoDb(sheetName,'update');
						}
					//}
				}
			}
			
			if(msg == 'field-update'){
				$(".fadeInRight").trigger("click");
				alert('Field Updated successfully!');
			}
			
		}).catch(error => {
			console.log('error::', error);
		})
	}
	
	updateKioskHeaders=(fieldData)=>{
		let data = this.state.originalData2;
		let dataArray = []; 
		data.map((rows, i) => {
			dataArray.push(rows);
		});	
		let reverse = dataArray.reverse();
		
		let fieldDataArray = fieldData['Fields'];
		let delegateUsers = this.state.delegateUsers;
		let currentDate = new Date().toLocaleString("en-US", {timeZone: "America/New_York"}).replace(',','');
		reverse.map((rows, i) => {
			let uArray = delegateUsers.get(rows[0]);
			fieldDataArray.map((rs, i) => {
				
				if(rows[11] == rs[117]){
					let uArrayParent = delegateUsers.get(rs[0]);
					let alldelegate = uArrayParent.concat(uArray);
					let aUnique = this.uniqueArray2(alldelegate);
					delegateUsers.set(rs[0], aUnique);
					let delegateAll = aUnique.toString();
					let dUsers = delegateAll.replaceAll(',','|');
					
					let uType = [];
					let kioskType = this.state.delegateTypes;
					
					if(kioskType){
						kioskType.map(function(type,i) {
							type = type.split(':');
							uType.push(type[1]);
						})
					}else{
						uType = ['CPO']
					}
					
					let final_arr = aUnique;
					let final_arr1 = uType;

					let array=[];
					if(final_arr){
						final_arr1.map((item,i)=>{
							if(final_arr.includes(item) == true){
								array.push(item)
							}else if(item == 'CPO'){
								array.push('CPO')
							}else{
								array.push('')
							}
						})
					}
					let userTypes = array.toString();
					
					if(aUnique.length > 1){
						rs[37] = "Y";
						rs[16] = rs[0]+',,'+rs[1]+','+rs[7]+','+rs[8]+','+rs[14]+','+rs[15]+','+rs[10]+',Y,'+userTypes;
					}
					rs[140] = "["+dUsers+"]";
					rs[98] = currentDate;
				}
			});
		});
	}
	
	getValue=(event)=>{
		
		let name = event.target.name;
		let res = event.target.value;
		
		if(name == 'formRating'){
			
			if(res < 1 || res > 5){
				$('#formRatingInput').val('');
			}
			
		}
		if(res){
			$('#'+name).removeClass('error');
		}
		
		this.setState({[event.target.name]:event.target.value});
		
		
		/* if(name == 'preserveOrder'){
			if($("input[name='preserveOrder']").prop("checked") == true){
				this.setState({preserveOrder:true});
			}else{
				this.setState({preserveOrder:false});
			}
		} */
		
		if(name == 'preserveOrder' || name == 'randomize' || name == 'alphaNum'){
			if($("input[name='"+name+"']").prop("checked") == true){
				this.setState({optionSorting:name});
			}
		}
		
		if(name == 'JobInitiator'){
			if($("input[name='JobInitiator']").prop("checked") == true){
				this.setState({JobInitiator:true});
			}else{
				this.setState({JobInitiator:false});
			}
		}
		
		if(name == 'startWorkflow'){
			if($("input[name='startWorkflow']").prop("checked") == true){
				this.setState({startWorkflow:true});
			}else{
				this.setState({startWorkflow:false});
			}
		}
		
		if(name == 'internalNoteBox'){
			if($("input[name='internalNoteBox']").prop("checked") == true){
				this.setState({internalNoteBox:true});
			}else{
				this.setState({internalNoteBox:false});
			}
		}
		
		if(name == 'fieldInternalNoteBox'){
			if($("input[name='fieldInternalNoteBox']").prop("checked") == true){
				this.setState({fieldInternalNoteBox:true});
			}else{
				this.setState({fieldInternalNoteBox:false});
			}
		}
		
		if(name == 'fieldRAGBox'){
			if($("input[name='fieldRAGBox']").prop("checked") == true){
				this.setState({fieldRAGBox:true});
			}else{
				this.setState({fieldRAGBox:false});
			}
		}
		
		
	
		if(name == 'selectedInstance'){
			let selectedInstanceName = $('#selectedInstance').find("option:selected").text();
			this.setState({parentDataSets:[],mdsSheets:[],childSheets:[],childSheetNames:[],selectedInstanceName,selectedInstanceId:res});
			this.getMdsSheets(res);
			this.getLayoutSheets(res);
		}
		
		if(name == 'autoPopulate'){
			if($("input[name='autoPopulate']").prop("checked") == false){
				this.setState({autoPopulate:'',autoPopulateTags:''});
			}
		}
		
		if(name == 'fieldDeactivated'){
			if($("input[name='fieldDeactivated']").prop("checked") == false){
				this.setState({fieldDeactivated:'N'});
			}
		}
		
		if(name == 'fieldRegistry'){
			if($("input[name='fieldRegistry']").prop("checked") == false){
				this.setState({fieldRegistry:'N'});
			}
		}
		
		if(name == 'addOpDetails'){
			if($("input[name='addOpDetails']").prop("checked") == false){
				this.setState({addOpDetails:'N'});
			}
		}
		
		if(name == 'mdsDataName'){
			res = res.replaceAll(" ", "-");
			this.setState({[name]:res,fieldPrefix:res});
		}
		
		if(name == 'saveAs' && res == 'parentMds'){
			this.setState({showPrefix:true});
		}else if(name == 'saveAs' && res != 'parentMds'){
			this.setState({showPrefix:false});
		}
		if(name == 'mdsCompany' || name == 'mdsGroupId' || name == 'allTypes' || name == 'allDelegate' || name == 'allDeviceTypes' || name == 'allVisitTypes' || name == 'chooseTracking' || name == 'ogAutoTags' || name == 'SelectedKeyNames'){
			res = Array.from(event.target.selectedOptions, (item) => item.value).join();
			let newArray = name+'Array';
			this.setState({[event.target.name]:res,[newArray]:Array.from(event.target.selectedOptions, (item) => item.value)});
		}
		
		if(name == 'allDeviceTypes'){
			res = Array.from(event.target.selectedOptions, (item) => item.value).join();
			let newArray = name+'Array';
			this.setState({[event.target.name]:res,[newArray]:Array.from(event.target.selectedOptions, (item) => item.value)});
		}
		
		if(name == 'inlineVideoLink'){
			//let path = '<iframe src="'+res+'" width="480" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="Inline Video"></iframe>';
			let path = '<iframe src="'+res+'" width="480" height="360" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" title="Inline Video" allowfullscreen credentialless></iframe>';
			this.setState({inlineVideo:path});
			$("#inlineVideo").html(path);
		}
		
		if($("input[name='noneAbove']").prop("checked") == false){
			this.setState({noneAbove:''});
		}
		
		if($("input[name='dataAgg']").prop("checked") == false){
			this.setState({dataAgg:''});
		}
		
		if($("input[name='legacyData']").prop("checked") == false){
			this.setState({legacyData:''});
		}
		
		if($("input[name='dataElement']").prop("checked") == true){
			this.setState({dataElement:true});
		}
		
		if($("input[name='dataElement']").prop("checked") == false){
			this.setState({dataElement:false});
		}

		if(name == 'Public' && res == 'Yes'){
			this.setState({showCompany:false});
		}else if(name == 'Public' && res == 'No'){
			this.setState({showCompany:true});
		}
		
		let that = this;
		let date = new Date().toLocaleString("en-US", {timeZone: "America/New_York"}).split(',')[0];
		if(name == 'validationType' && (res == 'V3' || res == 'V4' || res == 'V5' || res == 'V6' || res == 'V9' || res == 'V11'  || res == 'V12' || res == 'V13' || res == 'V14' || res == 'V15' || res == 'V16' || res == 'V17' || res == 'V20' || res == 'V21' || res == 'V22' || res == 'V23')){
			
			that.setState({showMinMax:true});
			setTimeout(function(){
				if(res == 'V9'){
					//$('.min-val').val('01/01/1920');
					//$('.max-val').val(date);
					//that.setState({minValue:'01/01/1920',maxValue:date});
				}else if(res == 'V11'){
					//$('.max-val').val('01/01/2050');
					//$('.min-val').val(date);
					//that.setState({maxValue:'01/01/2050',minValue:date});
				}else if(res == 'V12'){
					$('.max-val').val('00:00:00');
					$('.min-val').val('00:00:00');
					that.setState({maxValue:'00:00:00',minValue:'00:00:00'});
				}else if(res == 'V13'){
					$('.max-val').val('00:00');
					$('.min-val').val('00:00');
					that.setState({maxValue:'00:00',minValue:'00:00'});
				}else{
					$('.max-val').val('');
					$('.min-val').val('');
				}
			}, 2000);
			
		}else if(name == 'validationType' && (res == 'V1' || res == 'V2' || res == 'V7' || res == 'V8' || res == 'V10' || res == 'V18' || res == 'V19' || res == 'V24' || res == 'V25')){
			this.setState({showMinMax:false});
			that.setState({maxValue:'',minValue:''});
		}
		
		if(name == 'validation1' && res == 'V9'){
			$('.vmin1').val('01/01/1920');
			$('.vmax1').val(date);
			that.setState({vmin1:'01/01/1920',vmax1:date});
		}
		
		for (let i = 1; i <= 10; i++) {
			if(name == 'validation'+i && res == 'V9'){
				$('.vmin'+i).val('01/01/1920');
				$('.vmax'+i).val(date);
				that.setState({['vmin'+i]:'01/01/1920',['vmax'+i]:date});
			}else if(name == 'validation'+i && res == 'V11'){
				$('.vmin'+i).val(date);
				$('.vmax'+i).val('01/01/2050');
				that.setState({['vmax'+i]:'01/01/2050',['vmin'+i]:date});
			}else if(name == 'validation'+i && res == 'V12'){
				$('.vmin'+i).val('00:00:00');
				$('.vmax'+i).val('00:00:00');
				that.setState({['vmax'+i]:'00:00:00',['vmin'+i]:'00:00:00'});
			}else if(name == 'validation'+i && (res != 'V9' || res != 'V11' || res != 'V12')){
				that.setState({['vmin'+i]:'',['vmax'+i]:''});
			}
	
		}
		
		for (let i = 1; i <= 10; i++) {
			if(name == 'columnOption'+i && res == 'limited'){
				that.setState({['limited'+i]:true});
			}else if(name == 'columnOption'+i && res == 'free'){
				that.setState({['limited'+i]:false});
			}
		}
		
		
		if(name == 'numberOfColumn'){
			$('.column-input').css('display','none');
			$('.dropdown-col3').css('display','none');
			for(let i = 1; i <= res; i++){
				$('.column-'+i).css('display','block');
			}
			if(res == 3){
				$('.dropdown-col3').css('display','block');
			}
		}
		
		if(name == 'numberOfGrid'){
			$('.column-input').css('display','none');
			for(let i = 1; i <= res; i++){
				$('.column-'+i).css('display','block');
			}
		}
		
		if(name == 'numberRows'){
			$('.row-input').css('display','none');
			for(let i = 1; i <= res; i++){
				$('.row-'+i).css('display','block');
			}
		}
		
		if(name == 'sameAllC2'){
			let c2 = $('.r1c2').val();
			let numberRows = this.state.numberRows;
			for(let i=2; i <= numberRows; i++ ){
				this.setState({['R'+i+'C2']:c2});
			}
			//this.setState({R2C2:c2,R3C2:c2});
			if($("input[name='sameAllC2']").prop("checked") == false){
				for(let i=2; i <= numberRows; i++ ){
					this.setState({['R'+i+'C2']:''});
				}
			}
		}
		
		if(name == 'sameAllC3' && this.state.numberOfColumn > 2){
			let c3 = $('.r1c3').val();
			let numberRows = this.state.numberRows;
			for(let i=2; i <= numberRows; i++ ){
				this.setState({['R'+i+'C3']:c3});
			}
			//this.setState({R2C3:c3,R3C3:c3});
			if($("input[name='sameAllC3']").prop("checked") == false){
				for(let i=2; i <= numberRows; i++ ){
					this.setState({['R'+i+'C3']:''});
				}
			}
		}
		
		if(name == 'personRole'){
			let trackingFacility = this.state.trackingFacility;
			let roleName = this.state.responsibleRole;
			let facilityData = this.state.facilityData;
			roleName.map((val, i) => {
				if(val === res){
					let persons = facilityData[trackingFacility][val];
					let personName = [];
					persons.map((name, i) => {
						name = name.split('|');
						personName.push(name[0]);
					})
					
					this.setState({persons,responsiblePerson:personName});
				}
			})
		}
		
		if(name == 'currentStatus'){
			this.setState({currentStatusChanged:true});
		}
		
		if(name == 'personName'){
			let persons = this.state.persons;
			let email = '';
			persons.map((name, i) => {
				name = name.split('|');
				if(name[0] == res){
					email = name[1];
				}
			})
			this.setState({personEmail:email});
		}
		
		if($("input[name='redoInfo']").prop("checked") == false){
			this.setState({redoInfo:'N'});
		}
		
		if($("input[name='markCompleted']").prop("checked") == false){
			this.setState({markCompleted:'N'});
		}
		
		if($("input[name='fabCompleted']").prop("checked") == false){
			this.setState({fabCompleted:'N'});
		}
		
		if($("input[name='allParts']").prop("checked") == false){
			this.setState({allParts:'N'});
		}
		
		
		if(name == 'redoOption'){
			if(res){
				$('#redoInfo').show();
			}else{
				$('#redoInfo').hide();
			}
		}
		
		if(name == 'fabFacility'){
			let facilityData = this.state.facilityData;
			let practitioners = [];
			if(res){
				practitioners = facilityData[res]['Practitioners'];
			}
			this.setState({practitioners:practitioners});
		}
		
		if(name == 'allTypes'){
			
			let limitDeviceTypes = [];
			this.state.deviceTypes.map((val,i)=>{
				if((res == val.type || res == 'Orthotic,Prosthetic') && this.state.associatedAnatomy !='' && this.state.associatedAnatomy == val.anatomy && this.state.associatedAnatomy != 'All'){
					limitDeviceTypes.push(val.name);
				}else if((res == val.type || res == 'Orthotic,Prosthetic') && this.state.associatedAnatomy ==''){
					limitDeviceTypes.push(val.name);
				}
			})
			this.setState({limitDeviceTypes});
			
		}
		
		if(name == 'suggest2' && res == 'Other'){
			this.setState({suggestOp:true});
		}else{
			this.setState({suggestOp:false});
		}
			
		
    }
	
	editField(filed,ftype,data){
		$("#wrapper").addClass('toggled-2');
		$(".fadeInRight").addClass('is-open');
		$(".fadeInRight").removeClass('is-closed');
		let showAddMds = true;
		let type = ftype.toLowerCase();
		let changeQueInpText = data[4];
		let changeAnsInpText = data[6];
		let changeOutInpText = data[9];
		let valType = data[48];
		let responseDataFormat = data[102];
		let LeftGridLabel = data[53];
		let minValue = data[50];
		let maxValue = data[51];
		let path = data[99];
		let addTagsText = data[13];
		let fieldIdentifier = data[61];
		let staticFieldID = data[63];
		let fieldAltText = data[64];
		let altTextBox = data[64] ? 'Y' : '';
		let chooseTracking = data[125] ? data[125] : '';
		let trackingName = data[125] ? data[125].split(',') : [];
		let companyName = data[115] ? data[115] : '';
		let dataPersistence = data[110] ? data[110] : '';
		let exPersistencekey = data[42] ? data[42] : '';
		let persistencekey = data[39] ? data[39] : '';
		let asGroup = data[127] ? data[127] : '';
		let websiteLink = data[78] ? data[78] : '';
		let responseAction = data[44] ? data[44] : '';
		let calculationType = data[113] ? data[113] : '';
		let labelValue = data[41] ? data[41] : '';
		let visibleTxtLabel = data[45] ? data[45] : '';
		let outputTxtLabel = data[46] ? data[46] : '';
		let dataAgg = data[3] ? data[3] : '';
		let legacyData = data[65] ? data[65] : '';
		let dataElement = data[100] ? data[100] : '';
		let dataElementOption = data[101] ? data[101] : 'Public';
		let styleQ4 = data[138] ? data[138] : 'checkbox';
		let analysisVideo = data[59] ? data[59] : '';
		//let reportPdf = data[60] ? data[60] : '';
		let reportPdf = '';
		let autoPopulateTags = data[106] ? data[106] : '';
		let optionSorting = data[69] ? data[69] : false;
		let MinOptionSelection = data[30] ? data[30] : '';
		let MaxOptionSelection = data[31] ? data[31] : '';
		
		let dimensionTxtValue = data[70] ? data[70] : [];
		
		let autoPopulate = '';
		if(autoPopulateTags){
			autoPopulate = 'Y';
		}
		
		let fieldDeactivated = data[60] ? data[60] : 'N';
		let fieldRegistry = data[57] ? data[57] : 'N';
		let builderNote = data[58] ? data[58] : '';
		let fieldInternalNote = data[56] ? data[56] : '';
		let fieldRAGNote = data[52] ? data[52] : '';
		
		if(fieldRAGNote){
			this.setState({fieldRAGBox:true});
		}else{
			this.setState({fieldRAGBox:false});
		}
		
		if(fieldInternalNote){
			this.setState({fieldInternalNoteBox:true});
		}else{
			this.setState({fieldInternalNoteBox:false});
		}
		
		let that = this;
		if(data[129] && data[130] && data[131]){
			showAddMds = false;
		}
		
		this.getRequiredAndOptionalFields(filed);
		
		setTimeout(function(){
			$('#selectType option').hide();
		}, 1000);
		
		setTimeout(function(){
			if(type == 'q1' || type == 'q2' || type == 'q2b' || type == 'q2c' || type == 'q2d' || type == 'q2e' || type == 'q3' || type == 'q11' || type == 'q11b' || type == 'smart' || type == '12'){
				$('#selectType option[value="Q1"],option[value="Q2"],option[value="Q2b"],option[value="Q2c"],option[value="Q2d"],option[value="Q2e"],option[value="Q3"],option[value="Q11"],option[value="Q11b"],option[value="smart"],option[value="Q12"]').show();
			}
			
			if(type == 'q5' || type == 'q10'){
				$('#selectType option[value="Q5"],option[value="Q10"]').show();
			}
		}, 2000);

		this.setState({buttonLabel:'',leftButtonTxt:'',rightButtonTxt:'',sacale1:'',sacale2:'',sacale3:'',sacale4:'',sacale5:'',numberRows:'1',numberOfColumn:'',numberOfGrid:'',arraignment:'provided',lowestText:'',highestText:'',validation1:'V1',validation2:'V1',validation3:'V1',validation4:'V1',validation5:'V1',validation6:'V1',validation7:'V1',validation8:'V1',vmin1:'',vmin2:'',vmin3:'',vmin4:'',vmin5:'',vmin6:'',vmin7:'',vmin8:'',vmax1:'',vmax2:'',vmax3:'',vmax4:'',vmax5:'',vmax6:'',vmax7:'',vmax8:'',ogAutoTagsArray:[],requiredFields:new Map(),hiddenDimensions:new Map(),optionalFields:new Map(),noneAbove:''});
		
		for(let i = 1; i <= 20; i++){
			let variable = 'row'+i;
			let variable2 = 'C'+i;
			let variable3 = 'R'+i;
			let variable4 = 'weight'+i;
			let variable5 = 'L'+i;
			
			for(let j = 1; j <= 10; j++){
				that.setState({['R'+i+'C'+j]:''});
			}
			
			that.setState({[variable]:'',[variable2]:'',[variable3]:'',[variable4]:'',[variable5]:''});
		}
		
		for(let i = 1; i <= 10; i++){
			this.setState({['columnOption'+i]:'free',['Option'+i]:'',['limited'+i]:false});
		}
		
		setTimeout(function(){
			$('.column-input').css('display','none');
			$('.row-input').css('display','none');
			$('.row-1').css('display','block');
			$('.column-1').css('display','block');
			if(type == 'weighted'){
				$('.row-2').css('display','block');
			}
			if(type == 'grid-dropdown'){
				$('.column-2').css('display','block');
			}
		}, 1000);
		
		if(type == 'parent header'){
			asGroup = data[126];
		}
		
		if(type == 'slider' && labelValue){
			let str = labelValue.split(',');
			let sliderMinValue = data[50];
			let sliderMaxValue = data[51];
			let sliderStepValue = data[36];
			this.setState({sliderMinText:str[0],sliderMaxText:str[1],sliderMinValue,sliderMaxValue,sliderStepValue});
		}
		
		if(type == 'smart' && changeAnsInpText){
			let str = changeAnsInpText.split(',');
			let txt = '';
			str.map((name, i) => {
				name = name.split('|');
				if(name[1]=='None of the Above'){
					txt = 'None of the Above';
				}
			})
			this.setState({noneAbove:txt});
			//changeAnsInpText = changeAnsInpText.replace(',None of the Above', '');
		}
		
		if(type == 'q13' && changeAnsInpText){
			let str = changeAnsInpText.split('|');
			this.setState({q13Guid:str[0]});
			changeAnsInpText = str[1];
		}
		
		if(typeof data[12] !== 'undefined' && data[12] !== ''){
			let addNoteText = data[12];
			let imgUrl  = addNoteText;
			const html = `<p>`+imgUrl+`</p>`;
			const contentBlock = htmlToDraft(html);

			if (contentBlock) {
				const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
				const editorState = EditorState.createWithContent(contentState);
				this.setState({
				  editorState,editorSourceHTML:addNoteText
				});
			}
		}else{
			this.setState({editorState:'',editorSourceHTML:''});
		}
		
		let changeQueType = false;
		let changeAnsOpt = false;
		let changeAnsOrder = false;
		let changeAnsOptKey = false;
		let changeAnsOptHidden = false;
		let changeRadioPlus = false;
		let checkboxPlusLable = false;
		let changeOneRadioPlus = false;
		let changeOutOpt = false;
		let apiVideo = false;
		let changeWebsite = false;
		let changeSliderText = false;
		let changeLaunchpad = false;
		let changeCalculation = false;
		let changeBasicGrid = false;
		let changeBasicGrid2 = false;
		let changeGridOption = false;
		let changeGridDropdown = false;
		let changeGrid5 = false;
		let changeLikert = false;
		let changeSmart = false;
		let changeGridCheck = false;
		let changeWeighted = false;
		let changeWcalculation = false;
		let changebuttonLabel = false;
		let changeinlineVideoLink = false;
		let showCompany = true;
		let showStyleQ4 = false;
		
		let showImageUpload = false;
		
		let hasPH = true;

		if(type != 'parent header' && type != 'child header 1' && type != 'child header 2' && type != 'child header 3' && type != 'boxbegin'){
			changeQueType = true;
			changeOutOpt = true;
			hasPH = false;
		}
		
		if(type == 'q12'){
			changeRadioPlus = true;
		}
		
		if(type == 'q10'){
			checkboxPlusLable = true;
		}
		
		if(type == 'apivideo'){
			apiVideo = true;
		}
		
		if(type == 'q4'){
			showStyleQ4 = true;
		}
		
		if(type == 'q13'){
			changeOneRadioPlus = true;
		}
		
		if(type == 'q1' || type == 'q2' || type == 'q2b' || type == 'q2c' || type == 'q2d' || type == 'q2e' || type == 'q3' || type == 'q4' || type == 'q11' || type == 'q11b' || type == 'q11w' || type == 'q11f' || type == 'gridcheck' || type == 'smart' || type == 'smartest'){
			changeAnsOpt = true;
		}
		
		if(type == 'q14'){
			changeAnsOptKey = true;
		}
		
		if(type == 'smartest'){
			changeAnsOrder = true;
		}
		
		
		if(valType == 'V3' || valType == 'V4' || valType == 'V5' || valType == 'V6' || valType == 'V9' || valType == 'V11'  || valType == 'V12' || valType == 'V13' || valType == 'V14' || valType == 'V15' || valType == 'V16' || valType == 'V17' || valType == 'V20' || valType == 'V21' || valType == 'V22' || valType == 'V23'){
			
			let date = new Date().toLocaleString("en-US", {timeZone: "America/New_York"}).split(',')[0];
			this.setState({showMinMax:true,minValue:minValue,maxValue:maxValue});
			
			if(!minValue && !maxValue){
				if(valType == 'V9'){
					this.setState({minValue:'01/01/1920',maxValue:date});
				}else if(valType == 'V11'){
					this.setState({maxValue:'01/01/2050',minValue:date});
				}else if(valType == 'V12'){
					this.setState({maxValue:'00:00:00',minValue:'00:00:00'});
				}else if(valType == 'V13'){
					this.setState({maxValue:'00:00',minValue:'00:00'});
				}
			}

		}else if(valType == 'V1' || valType == 'V2' || valType == 'V7' || valType == 'V8' || valType == 'V10' || valType == 'V18' || valType == 'V19'){
			this.setState({showMinMax:false,maxValue:'',minValue:''});
		}
		
		let showInlineVideo = false;
		
		if(type == 'image'){
			showImageUpload = true;
		}
		if(type == 'link'){
			changeWebsite = true;
		}
		
		if(type == 'slider'){
			changeSliderText = true;
		}
		
		if(type == 'q12' || type == 'q13'){
			let buttontxt = data[40].split(',');
			if(buttontxt[0]){
				this.setState({leftButtonTxt:buttontxt[0]});
			}
			if(buttontxt[1]){
				this.setState({rightButtonTxt:buttontxt[1]});
			}
			if(buttontxt[2]){
				this.setState({buttonLabel:buttontxt[2]});
			}
		}
		
		if(type == 'launchpad'){
			changeLaunchpad = true;
			let launchpadType = data[138];
			let ogAutoTagsArray = data[144] ? data[144].split(',') : [];
			let buttonLabel = data[40];
			let that = this;
			setTimeout(function(){
				let rqFields = that.state.requiredFields;
				let opFields = that.state.optionalFields;
				
				if(data[142] && data[142].indexOf(',') > -1){
					let rqFieldsId = data[142].split(',');
					rqFieldsId.map((item, i) => {
						rqFields.set(item, item);
					});
				}else if(data[142]){
					rqFields.set(data[142], data[142]);
				}
				
				if(data[143] && data[143].indexOf(',') > -1){
					let opFieldsId = data[143].split(',');
					opFieldsId.map((item, i) => {
						opFields.set(item, item);
					});
				}else if(data[143]){
					opFields.set(data[143], data[143]);
				}
				
				that.setState({buttonLabel,launchpadType,requiredFields:rqFields,optionalFields:opFields,ogAutoTagsArray});
			}, 1000);
		}else{
			this.setState({requiredFields:new Map(),optionalFields:new Map()});
		}
		
		if(type == 'calculation'){
			changeCalculation = true;
			let calFieldsId = this.state.calFieldsId;
			if(data[114] && data[114].indexOf(',') > -1){
				let FieldsId = data[114].split(',');
				FieldsId.map((item, i) => {
					calFieldsId.set(item, item);
				});
			}else{
				calFieldsId.set(data[114], data[114]);
			}
			this.setState({calFieldsId:calFieldsId});
		}
		
		if(type == 'smart'){
			changeSmart = true;
		}
		
		if(type == 'file' || type == 'video'){
			changebuttonLabel = true;
			let buttonLabel = data[40];
			this.setState({buttonLabel});
		}
			
		if(type == 'likert'){
			changeLikert = true;
			if(labelValue && labelValue.indexOf('_') > -1){
				let string = labelValue.split('_');
				if(string[0] && string[0].indexOf(',') > -1){
					let str1 = string[0].split(',');
					let col = str1.length;
					this.setState({numberOfColumn:col});
					setTimeout(function(){
						$('.column-input').css('display','none');
						for(let i = 0; i < col	; i++){
							let j = i+1;
							$('.column-'+j).css('display','block');
							let variable = 'L'+j;
							that.setState({[variable]:str1[i]});
						}
					}, 2000);
					//let str1 = string[0].split(',');
					//this.setState({lowestText:str1[0],highestText:str1[1]});
				}
				
				if(string[1] && string[1].indexOf(',') > -1){
					let str2 = string[1].split(',');
					let col2 = str2.length;
					this.setState({numberRows:col2});
					setTimeout(function(){
						$('.row-input').css('display','none');
						for(let i = 0; i < col2	; i++){
							let j = i+1;
							$('.row-'+j).css('display','block');
							let variable = 'row'+j;
							if(str2[i]){
								that.setState({[variable]:str2[i]});
							}
						}
					}, 1000);
				}
			}
		}
		
		if(type == 'wcalculation'){
			changeWcalculation = true;
			this.setState({wcalFieldsId:data[114]});
		}
		
		if(type == 'weighted'){
			changeWeighted = true;
			let numberOfGrid = data[136];
			let numberRows = data[137] ? data[137] : 2;
			let arraignment = data[138];
			this.setState({numberOfGrid,numberRows,arraignment});
			
			if(labelValue && labelValue.indexOf(',') > -1){
				let str1 = labelValue.split(',');
				setTimeout(function(){
					str1.map((item,i)=>{
						let str = item.split(':');
						let j = i+1;
						$('.row-'+j).css('display','block');
						let variable = 'row'+j;
						let variable2 = 'weight'+j;
						that.setState({[variable]:str[0],[variable2]:str[1]});
					})
				}, 1000);
			}
		}
		
		if(type == 'grid5point'){
			changeGrid5 = true;
			if(labelValue && labelValue.indexOf('_') > -1){
				let string = labelValue.split('_');
				if(string[0] && string[0].indexOf(',') > -1){
					let str1 = string[0].split(',');
					str1.map((item,i)=>{
						let j = i+1;
						let variable = 'sacale'+j;
						this.setState({[variable]:item});
						
					})
				}else{
					let sacale1 = string[0] ? string[0] : '';
					this.setState({sacale1});
				}
				
				if(string[1] && string[1].indexOf(',') > -1){
					let str2 = string[1].split(',');
					let col2 = str2.length;
					this.setState({numberRows:col2});
					setTimeout(function(){
						$('.row-input').css('display','none');
						for(let i = 0; i < col2	; i++){
							let j = i+1;
							$('.row-'+j).css('display','block');
							let variable = 'row'+j;
							if(str2[i]){
								that.setState({[variable]:str2[i]});
							}
						}
					}, 1000);
				}
			}
		}
		
		if(type == 'gridcheck'){
			changeGridCheck = true;
			let numberOfGrid = data[136];
			this.setState({numberOfGrid});
			if(labelValue && labelValue.indexOf('_') > -1){
				let string = labelValue.split('_');
				if(string[0] && string[0].indexOf(',') > -1){
					let str1 = string[0].split(',');
					let col = str1.length;
					this.setState({numberOfColumn:col});
					setTimeout(function(){
						$('.column-input').css('display','none');
						for(let i = 0; i < col	; i++){
							let j = i+1;
							$('.column-'+j).css('display','block');
							let variable = 'C'+j;
							that.setState({[variable]:str1[i]});
							
						}
						
						if(col == 3){
							//$('.dropdown-col3').css('display','block');
						}
					
					}, 2000);
					
				}else{
					let C1 = string[0] ? string[0] : '';
					this.setState({numberOfColumn:1,C1});
				}
				
				if(string[1] && string[1].indexOf(',') > -1){
					let str2 = string[1].split(',');
					let col2 = str2.length;
					this.setState({numberRows:col2});
					setTimeout(function(){
						$('.row-input').css('display','none');
						for(let i = 0; i < col2	; i++){
							let j = i+1;
							$('.row-'+j).css('display','block');
							let variable = 'row'+j;
							if(str2[i]){
								that.setState({[variable]:str2[i]});
							}
						}
					}, 1000);
				}else{
					let variable = 'row1';
					that.setState({[variable]:labelValue});
				}
			}else if(labelValue && labelValue.indexOf(',') > -1){
				let str2 = labelValue.split(',');
				let col2 = str2.length;
				this.setState({numberRows:col2});
				setTimeout(function(){
					$('.row-input').css('display','none');
					for(let i = 0; i < col2	; i++){
						let j = i+1;
						$('.row-'+j).css('display','block');
						let variable = 'row'+j;
						if(str2[i]){
							that.setState({[variable]:str2[i]});
						}
					}
				}, 1000);
			}else{
				let variable = 'row1';
				that.setState({[variable]:labelValue});
			}
			
		}
		
		if(type == 'gridcheck'){
			changeGridCheck = true;
			let numberOfGrid = data[136];
			this.setState({numberOfGrid});
			
			if(labelValue && labelValue.indexOf('_') > -1){
				let string = labelValue.split('_');
				
				if(string[0] && string[0].indexOf(',') > -1){
					let str1 = string[0].split(',');
					let col = str1.length;
					this.setState({numberOfColumn:col});
					setTimeout(function(){
						$('.column-input').css('display','none');
						for(let i = 0; i < col	; i++){
							let j = i+1;
							$('.column-'+j).css('display','block');
							let variable = 'C'+j;
							that.setState({[variable]:str1[i]});
							
						}
						
						if(col == 3){
							//$('.dropdown-col3').css('display','block');
						}
					
					}, 2000);
					
				}else{
					let C1 = string[0] ? string[0] : '';
					this.setState({numberOfColumn:1,C1});
				}
				
			
			
			
				if(string[1] && string[1].indexOf(',') > -1){
					let str2 = string[1].split(',');
					let col2 = str2.length;
					this.setState({numberRows:col2});
					setTimeout(function(){
						$('.row-input').css('display','none');
						for(let i = 0; i < col2	; i++){
							let j = i+1;
							$('.row-'+j).css('display','block');
							let variable = 'row'+j;
							if(str2[i]){
								that.setState({[variable]:str2[i]});
							}
						}
					}, 1000);
				}else{
					let variable = 'row1';
					that.setState({[variable]:labelValue});
				}
			}
		}
		
		if(type == 'grid-dropdown'){
			changeGridDropdown = true;
			
			if(labelValue && labelValue.indexOf('_') > -1){
				let string = labelValue.split('_');
				if(string[0] && string[0].indexOf(',') > -1){
					let str1 = string[0].split(',');
					let col = str1.length;
					this.setState({numberOfColumn:col});
					setTimeout(function(){
						$('.column-input').css('display','none');
						for(let i = 0; i < col	; i++){
							let j = i+1;
							$('.column-'+j).css('display','block');
							let variable = 'C'+j;
							that.setState({[variable]:str1[i]});
							
						}
						
						if(col == 3){
							$('.dropdown-col3').css('display','block');
						}
					
					}, 2000);
					
				}else{
					let C1 = string[0] ? string[0] : '';
					this.setState({numberOfColumn:1,C1});
				}
				
				
		
				if(string[1] && string[1].indexOf('|') > -1){
					
					let str2 = string[1].split('|');
					
					let col2 = str2.length;
					this.setState({numberRows:col2});
					
					setTimeout(function(){
						$('.row-input').css('display','none');
						for(let i = 0; i < col2	; i++){
							let j = i+1;
							$('.row-'+j).css('display','block');
							
							if(str2[i]){
								let str3 = str2[i].split(':');
								let col3 = str3.length;
								for(let n = 0; n < col3; n++){
									let s = n+1;
									let variable = 'R'+j+'C'+s;
									that.setState({[variable]:str3[n]});
								}
								
							}
						}
					}, 2000);
				}else{
					setTimeout(function(){
						if(string[1]){
							let str3 = string[1].split(':');
							let col3 = str3.length;
							for(let n = 0; n < col3; n++){
								let s = n+1;
								let variable = 'R1C'+s;
								that.setState({[variable]:str3[n]});
							}
						}
					}, 2000);
				}
			}	
		}
		
		if(type == 'grid-multicheck' || type == 'grid-singlecheck'){
			changeGridOption = true;
			if(labelValue && labelValue.indexOf('_') > -1){
				let string = labelValue.split('_');
				
				if(string[0] && string[0].indexOf(',') > -1){
					let str1 = string[0].split(',');
					let col = str1.length;
					this.setState({numberOfColumn:col});
					setTimeout(function(){
						$('.column-input').css('display','none');
						for(let i = 0; i < col	; i++){
							let j = i+1;
							$('.column-'+j).css('display','block');
							let variable = 'C'+j;
							that.setState({[variable]:str1[i]});
							
						}
					}, 2000);
				}else{
					let C1 = string[0] ? string[0] : '';
					this.setState({numberOfColumn:1,C1});
				}
				
				if(string[1] && string[1].indexOf(',') > -1){
					let str2 = string[1].split(',');
					let col2 = str2.length;
					this.setState({numberRows:col2});
					setTimeout(function(){
						$('.row-input').css('display','none');
						for(let i = 0; i < col2	; i++){
							let j = i+1;
							$('.row-'+j).css('display','block');
							let variable = 'R'+j;
							if(str2[i]){
								that.setState({[variable]:str2[i]});
							}
						}
					}, 2000);
				}
			}
		}
		
		if(type == 'basicgrid'){
			changeBasicGrid = true;
			let validation = data[48];
			let fVli = [];
			let vmin = [];
			let vmax = [];
			if(validation){
				if(validation.indexOf(',') > -1){
					let vli = validation.split(',');
					for(let i = 0; i < vli.length; i++){
						let srt = vli[i].split(':');
						fVli.push(srt[1]);
						vmin.push(srt[2]);
						vmax.push(srt[3]);
					}
				}else{
					let srt = validation.split(':');
					fVli.push(srt[1]);
					vmin.push(srt[2]);
					vmax.push(srt[3]);
				}
			}
			
			if(labelValue && labelValue.indexOf('_') > -1){
				let string = labelValue.split('_');
				
				if(string[0] && string[0].indexOf(',') > -1){
					let str1 = string[0].split(',');
					let col = str1.length;
					this.setState({numberOfColumn:col});
					setTimeout(function(){
						$('.column-input').css('display','none');
						for(let i = 0; i < col	; i++){
							let j = i+1;
							$('.column-'+j).css('display','block');
							let variable = 'C'+j;
							let validationVar = 'validation'+j;
							let vVar1 = 'vmin'+j;
							let vVar2 = 'vmax'+j;
							that.setState({[variable]:str1[i]});
							if(fVli[i] !== undefined){
								that.setState({[validationVar]:fVli[i],[vVar1]:vmin[i],[vVar2]:vmax[i]});
							}
						}
					}, 2000);
				}else{
					let C1 = string[0] ? string[0] : '';
					if(fVli[0] !== undefined){
						that.setState({validation1:fVli[0],vmin1:vmin[0],vmax1:vmax[0]});
					}
					this.setState({numberOfColumn:1,C1});
				}
				
				if(string[1] && string[1].indexOf(',') > -1){
					let str2 = string[1].split(',');
					let col2 = str2.length;
					this.setState({numberRows:col2});
					setTimeout(function(){
						$('.row-input').css('display','none');
						for(let i = 0; i < col2	; i++){
							let j = i+1;
							$('.row-'+j).css('display','block');
							let variable = 'R'+j;
							if(str2[i]){
								that.setState({[variable]:str2[i]});
							}
						}
					}, 2000);
				}else{
					this.setState({R1:string[1]});
				}
			}
		}
		
		if(type == 'basicgrid2'){
			changeBasicGrid = true;
			changeBasicGrid2 = true;
			let validation = data[48];
			let fVli = [];
			let vmin = [];
			let vmax = [];
			if(validation){
				if(validation.indexOf(',') > -1){
					let vli = validation.split(',');
					for(let i = 0; i < vli.length; i++){
						let srt = vli[i].split(':');
						fVli.push(srt[1]);
						vmin.push(srt[2]);
						vmax.push(srt[3]);
					}
				}else{
					let srt = validation.split(':');
					fVli.push(srt[1]);
					vmin.push(srt[2]);
					vmax.push(srt[3]);
				}
			}
			
			if(labelValue && labelValue.indexOf('_') > -1){
				let string = labelValue.split('_');
				
				if(string[0] && string[0].indexOf('|') > -1){
					
					let str1 = string[0].split('|');
					
					let col = str1.length;
					this.setState({numberOfColumn:col});
					
					setTimeout(function(){
						$('.column-input').css('display','none');
						for(let i = 0; i < col	; i++){
							let str2 = str1[i].split(':');
							let j = i+1;
							$('.column-'+j).css('display','block');
							let variable = 'C'+j;
							let validationVar = 'validation'+j;
							let vVar1 = 'vmin'+j;
							let vVar2 = 'vmax'+j;
							that.setState({[variable]:str2[0]});
							if(str2[1] == 'limited'){
								that.setState({['columnOption'+j]:'limited',['Option'+j]:str2[2],['limited'+j]:true});
							}
							if(fVli[i] !== undefined){
								that.setState({[validationVar]:fVli[i],[vVar1]:vmin[i],[vVar2]:vmax[i]});
							}
						}
					}, 2000);
				}else{
					let strC1 = string[0] ? string[0] : '';
					strC1 = strC1.split(':');
					this.setState({numberOfColumn:1,C1:strC1[0]});
					if(strC1[1] == 'limited'){
						that.setState({['columnOption1']:'limited',['Option1']:strC1[2],['limited1']:true});
					}
					if(fVli[0] !== undefined){
						that.setState({validation1:fVli[0],vmin1:vmin[0],vmax1:vmax[0]});
					}
				}
				
				if(string[1] && string[1].indexOf(',') > -1){
					let str2 = string[1].split(',');
					let col2 = str2.length;
					this.setState({numberRows:col2});
					setTimeout(function(){
						$('.row-input').css('display','none');
						for(let i = 0; i < col2	; i++){
							let j = i+1;
							$('.row-'+j).css('display','block');
							let variable = 'R'+j;
							if(str2[i]){
								that.setState({[variable]:str2[i]});
							}
						}
					}, 2000);
				}else{
					this.setState({R1:string[1]});
				}
			}
			
		}
		
		if(type == 'inlinevideo'){
			showInlineVideo = true;
			setTimeout(function(){
				$("#inlineVideo-"+filed).html(path);
				let iframeSrc = $('#inlineVideo-'+filed+' iframe').attr('src');
				if(iframeSrc){
					that.setState({inlineVideoLink:iframeSrc});
				}else{
					that.setState({inlineVideoLink:''});
				}
			}, 1000);
		}

		if(type == 'hidden'){
			changeAnsOptHidden = true;
			
			let KeyOptQ14 = [];
			this.state.allData.map(function(val,i) {
				if(val[5] == 'Q14'){
					KeyOptQ14.push(val);
				}
			})
			
			that.setState({KeyOptionQ14:KeyOptQ14,SelectedKeyNamesArray:[],SelectedKeyed:''});
			if(dimensionTxtValue.length > 0){
				let KeyNamesArray = [];
				setTimeout(function(){
					let newArrOption = that.state.hiddenDimensions;
					
					dimensionTxtValue.map((item, i) => {
						newArrOption.set(item.uid, item);
						let hiddsion = item.hiddenDimension;
						let optVal = [];
						hiddsion.map((val, i) => {
							
							let str = item.selectedKeyOpt.replaceAll(' ','');
							let str2 = val.option.replaceAll(' ','');
							that.setState({[str+'-'+str2]:val.value});
							KeyNamesArray.push(val.option);
							if(val.value){
								optVal.push(val.value);
							}
							
						});
						
						that.setState({[item.uid]:optVal.length});
					});
					
					let aUnique = that.uniqueArray2(KeyNamesArray);

					that.setState({hiddenDimensions:newArrOption,SelectedKeyNamesArray:aUnique,SelectedKeyed:dimensionTxtValue[0].keyedField});
				}, 1000);
			}
		}
		
		this.setState({fieldId:filed,showFieldEdit:true,showBuildEdit:false,chooseAnsType:ftype,changeQueInpText,changeAnsInpText,changeOutInpText,changeQueType,validationType:valType,responseDataFormat,LeftGridLabel,inlineVideo:path,imagePath:path,changeAnsOpt,changeAnsOptKey,changeAnsOptHidden,changeRadioPlus,checkboxPlusLable,changeOneRadioPlus,changeOutOpt,hasParentHeader:hasPH,asGroup,chooseCompany:companyName,dataPersistence,persistencekey,exPersistencekey,showImageUpload,showInlineVideo,changeWebsite,websiteLink,responseAction,changeSliderText,addTagsText,fieldIdentifier,staticFieldID,fieldAltText,altTextBox,changeCalculation,calculationType,changeBasicGrid,changeBasicGrid2,changeGridOption,changeGridDropdown,changeGrid5,changeGridCheck,changeLikert,changeSmart,changeWeighted,changeWcalculation,changebuttonLabel,dataAgg,legacyData,dataElement,dataElementOption,changeLaunchpad,showAddMds,showStyleQ4,styleQ4,apiVideo,analysisVideo,reportPdf,autoPopulate,autoPopulateTags,fieldDeactivated,fieldRegistry,builderNote,fieldInternalNote,fieldRAGNote,changeAnsOrder,optionSorting,MinOptionSelection,MaxOptionSelection,dimensionTxtValue,visibleTxtLabel,outputTxtLabel});
	}
	
	addOption=()=>{
		let optionKey = $("input[name='optionKey']").val();
		let changeAnsInpTextArr = this.state.changeAnsInpText ? this.state.changeAnsInpText.split(',') : [];
		let guid = ulid();
		if(optionKey){
			let exist = false;
			if(changeAnsInpTextArr){
				changeAnsInpTextArr.map((val, i) => {
					let optionArr = val.split('|');
					if(optionArr[1] == optionKey){
						exist = true;
					}
				});
			}
			if(exist){
				alert('The duplicate answer options are not allowed!');
			}else{
				let valueTxt = guid+'|'+optionKey;
				changeAnsInpTextArr.push(valueTxt);
				let optionTxt = changeAnsInpTextArr.join();
				this.setState({changeAnsInpText:optionTxt});
				
				$("input[name='optionKey']").val('');
			}
		}else{
			alert('Please insert Option Key and Value!');
		}
	}
	
	addOptionKey=()=>{
		let optionKey = $("input[name='optionKey']").val();
		let optionKeyValue = $("input[name='optionKeyValue']").val();
		
		let changeAnsInpTextArr = this.state.changeAnsInpText ? this.state.changeAnsInpText.split(',') : [];
		let guid = ulid();
		if(optionKey && optionKeyValue){
			let exist = false;
			if(changeAnsInpTextArr){
				changeAnsInpTextArr.map((val, i) => {
					let optionArr = val.split('|');
					if(optionArr[1] == optionKey){
						exist = true;
					}
				});
			}
			if(exist){
				alert('The duplicate answer options are not allowed!');
			}else{
				let valueTxt = guid+'|'+optionKey+'|'+optionKeyValue;
				changeAnsInpTextArr.push(valueTxt);
				let optionTxt = changeAnsInpTextArr.join();
				this.setState({changeAnsInpText:optionTxt});
				
				$("input[name='optionKey']").val('');
				$("input[name='optionKeyValue']").val('');
			}
		}else{
			alert('Please insert Option Key and Value!');
		}
	}
	
	changeOptionKey=(options)=>{
		let optionTxt = options.join();
		this.setState({changeAnsInpText:optionTxt});
	}
	
	editOptionKey=(val)=>{
		let editOptionKey = val.split('|');
		this.setState({oldOptionKey:val,optionKey:editOptionKey[1],optionKeyValue:editOptionKey[2],optionKeyEnum:editOptionKey[3] ? editOptionKey[3] : ''});
		$('#editOptionPopup').modal('show');
	}
	
	editOptionKey2=(val)=>{
		let editOptionKey = val.split('|');
		this.setState({oldOptionKey:val,optionKey:editOptionKey[1],optionKeyEnum:editOptionKey[2] ? editOptionKey[2] : '',addOpDetails:editOptionKey[3] ? editOptionKey[3] : 'N',addOpDetailsTxt:editOptionKey[4] ? editOptionKey[4] : ''});
		$('#editOptionPopup2').modal('show');
	}
	
	editOptionKeyUpdate=()=>{
		let oldOptionKey = this.state.oldOptionKey;
		let editOptionKey = oldOptionKey.split('|');
		let optionKey = this.state.optionKey;
		let optionKeyValue = this.state.optionKeyValue;
		let optionKeyEnum = this.state.optionKeyEnum;
		let changeAnsInpTextArr = this.state.changeAnsInpText.split(',');
		if(optionKey && optionKeyValue){
			let valueTxt = editOptionKey[0]+'|'+optionKey+'|'+optionKeyValue+'|'+optionKeyEnum;
			let newArrOption = [];
			changeAnsInpTextArr.map((row, i) => { 
				if(row == oldOptionKey){
					row = valueTxt;
				}
				newArrOption.push(row);
			});
			let optionTxt = newArrOption.join();
			this.setState({changeAnsInpText:optionTxt});
		}else{
			alert('Please update Option Key and Value!');
		}
	}
	
	editOptionKeyUpdate2=()=>{
		let oldOptionKey = this.state.oldOptionKey;
		let editOptionKey = oldOptionKey.split('|');
		let optionKey = this.state.optionKey;
		let optionKeyEnum = this.state.optionKeyEnum;
		
		let changeAnsInpTextArr = this.state.changeAnsInpText.split(',');
		if(optionKey){
			let valueTxt = editOptionKey[0]+'|'+optionKey+'|'+optionKeyEnum;
			
			if(this.state.chooseAnsType == 'Q11b'){
				let addOpDetails = this.state.addOpDetails;
				let addOpDetailsTxt = this.state.addOpDetailsTxt;
				valueTxt = editOptionKey[0]+'|'+optionKey+'|'+optionKeyEnum+'|'+addOpDetails+'|'+addOpDetailsTxt;
			}

			let newArrOption = [];
			changeAnsInpTextArr.map((row, i) => { 
				if(row == oldOptionKey){
					row = valueTxt;
				}
				
				newArrOption.push(row);
			});
			let optionTxt = newArrOption.join();
			this.setState({changeAnsInpText:optionTxt});
		}else{
			alert('Please update Option Key!');
		}
	}
	
	deleteOptionKey=(val)=>{
		let changeAnsInpTextArr = this.state.changeAnsInpText.split(',');
		
		let index = changeAnsInpTextArr.indexOf(val);
		if (index > -1) { 
		  changeAnsInpTextArr.splice(index, 1);
		}
		
		let optionTxt = changeAnsInpTextArr.join();
		this.setState({changeAnsInpText:optionTxt});
	}
	
	deleteOptionKeyValue=(val)=>{
		let changeAnsInpTextArr = this.state.changeAnsInpText.split(',');
		
		let index = changeAnsInpTextArr.indexOf(val);
		if (index > -1) { 
		  changeAnsInpTextArr.splice(index, 1);
		}
		
		let optionTxt = changeAnsInpTextArr.join();
		this.setState({changeAnsInpText:optionTxt});
	}
	
	addOptionKeyName=()=>{
		let optionKeyName = $("input[name='optionKeyName']").val();
		let guid = ulid();
		let changeAnsInpTextArr = this.state.changeAnsInpText.split(',');
		changeAnsInpTextArr = changeAnsInpTextArr.filter(function(x) {
			 return x !== '';
		});
		if(optionKeyName){
			let optguid = ulid();
			let optTxt = optguid+'|'+optionKeyName;
			changeAnsInpTextArr.push(optTxt);
			let optionTxt = changeAnsInpTextArr.join();
			this.setState({changeAnsInpText:optionTxt});
			$("input[name='optionKeyName']").val('');
		}else{
			alert('Please insert Option KeyName!');
		}
	}
	
	showDimantionPop=(val,vl)=>{
		this.setState({selectedKeyTxt:val[4],selectedKeyOpt:vl[1],selectedKeyOptVal:vl[2]});
		setTimeout(function(){
			$('#dimention').modal('show');
		}, 1000);
		
	}
	
	saveDimensions=()=>{
		let SelectedNamesArray = this.state.SelectedKeyNamesArray;
		let SelectedKeyed = this.state.SelectedKeyed;
		let selectedKeyOpt = this.state.selectedKeyOpt;
		let selectedKeyOptVal = this.state.selectedKeyOptVal;
		let dimensionTxtValue = this.state.dimensionTxtValue;
		let allData = this.state.allData;
		let optionArr = [];
		
		SelectedNamesArray.map((row, i) => {
			
			let str = selectedKeyOpt.replaceAll(' ','');
			let str2 = row.replaceAll(' ','');
			
			let val = this.state[str+'-'+str2] ? this.state[str+'-'+str2] : '';
			
			let optionData = {
				"option": row,
				"value": val,
			}

			optionArr.push(optionData);
			
		});
		
		let strNew = SelectedKeyed+selectedKeyOpt;
		strNew = strNew.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '');
		
		let fieldData = {
			"uid": strNew,
			"keyedField": SelectedKeyed,
			"selectedKeyOpt": selectedKeyOpt,
			"selectedKeyOptVal": selectedKeyOptVal,
			"hiddenDimension": optionArr
		}
		
		let newArrOption = this.state.hiddenDimensions;
		
		newArrOption.set(strNew, fieldData);
		
		this.setState({hiddenDimensions:newArrOption});
		
		let optVal = [];
		optionArr.map((val, i) => {
			let str = selectedKeyOpt.replaceAll(' ','');
			let str2 = val.option.replaceAll(' ','');
			this.setState({[str+'-'+str2]:val.value});
			if(val.value){
				optVal.push(val.value);
			}
		});
		
		this.setState({[strNew]:optVal.length})
	}
	
	onEditorStateChange=(editorState)=>{
		const editorSourceHTML = draftToHtml(
		  convertToRaw(editorState.getCurrentContent()), 
		  null, 
		  null, 
		  (entity, text) => {
			if (entity.type === 'EMBEDDED_LINK') {
			  const { src, width, height } = entity.data;
			  return `<iframe src="${src}" width="auto" height="auto" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" title="Inline Video" allowfullscreen credentialless></iframe>`;
			}
			
			if (entity.type === 'IFRAME') {
			  const { src, width, height } = entity.data;
			   return `<iframe src="${src}" width="${width}" height="${height}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" title="Inline Video" allowfullscreen credentialless></iframe>`;
			}
			
			return text;
		  }
		);
		
        this.setState({
            editorState,editorSourceHTML
        });
    }
	
    _uploadImageCallBack=(file)=>{
        let uploadedImages = this.state.uploadedImages;
        const imageObject = {
            file: file,
            localSrc: URL.createObjectURL(file),
        }
        uploadedImages.push(imageObject);
        this.setState({uploadedImages: uploadedImages})
        
		let ApiUrl = config.mongoApiUrl;
		let url = ApiUrl+'image-upload';
		return new Promise(
		(resolve, reject) => {
			var form_data = new FormData();
			form_data.append('file', file);
			axios({
				method: 'POST',
				url: url,
				data: form_data,
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			})
			.then(response => {
				let rlink = ApiUrl+response.data
				resolve({ data: { link: rlink } });
			})
		});
    }
		
	updateField=()=>{
		let fieldId = this.state.fieldId;
		let allData = this.state.originalData;
		let version = this.state.selectedSheetversion;
		let mdsGuid = ulid();
		let newFieldGuid = ulid();
		//let version = allData[1][59] ? allData[1][59] : '1.01';
		let selectedSheet = this.state.selectedSheet;
		let user_id = this.state.userGuid;
        let sheetName = 'Temp-File-'+user_id;
        if(selectedSheet != '' && selectedSheet !== undefined){
			mdsGuid = allData[1][91];
			sheetName = selectedSheet;
		}
		let hasPH = '';
		let question = this.state.changeQueInpText;
		let answerType = this.state.chooseAnsType;
		let options = this.state.changeAnsInpText;
		let optionSorting = this.state.optionSorting;
		let MinOptionSelection = this.state.MinOptionSelection;
		let MaxOptionSelection = this.state.MaxOptionSelection;
		let dimensionTxtValue = this.state.dimensionTxtValue;
		let outputText = this.state.changeOutInpText;
		let visibleTxtLabel = this.state.visibleTxtLabel;
		let outputTxtLabel = this.state.outputTxtLabel;
		let noteHtml = this.state.editorSourceHTML;
		let validationType = this.state.validationType;
		let responseDataFormat = this.state.responseDataFormat;
		let LeftGridLabel = this.state.LeftGridLabel;
		let minValue = this.state.minValue;
		let maxValue = this.state.maxValue;
		let inlineVideo = this.state.inlineVideo;
		let asGroup = this.state.asGroup;
		//let PFB = this.state.PFB;
		//let chooseCompany = this.state.chooseCompany;
		let dataPersistence = this.state.dataPersistence;
		let persistencekey = this.state.persistencekey;
		let exPersistencekey = this.state.exPersistencekey;
		let chooseTracking = this.state.chooseTracking;
		let websiteLink = this.state.websiteLink;
		let responseAction = this.state.responseAction;
		let addTagsText = this.state.addTagsText;
		let fieldIdentifier = this.state.fieldIdentifier;
		let staticFieldID = this.state.staticFieldID;
		let fieldAltText = this.state.fieldAltText;
		let buttonLabel = this.state.buttonLabel;
		let addParentMds = this.state.addParentMds;
		let addGroupMds = this.state.addGroupMds;
		let dataAgg = this.state.dataAgg;
		let legacyData = this.state.legacyData;
		let dataElement = this.state.dataElement;
		let dataElementOption = this.state.dataElementOption;
		let styleQ4 = this.state.styleQ4;
		let analysisVideo = this.state.analysisVideo;
		let reportPdf = this.state.reportPdf;
		let autoPopulateTags = this.state.autoPopulateTags;
		let fieldDeactivated = this.state.fieldDeactivated;
		let fieldRegistry = this.state.fieldRegistry;
		let builderNote = this.state.builderNote;
		let fieldInternalNote = this.state.fieldInternalNote;
		let fieldRAGNote = this.state.fieldRAGNote;
		let labelValue = '';
		let mod = '';
		let requiredFields = '';
		let optionalFields = '';
		let ogAutoTags = '';
		let sliderMinValue = '';
		let sliderMaxValue = '';
		let sliderStepValue = '';
		
		let calculationType = this.state.calculationType;
		let calFieldsId = this.state.calFieldsId;
		let wcalFieldsId = this.state.wcalFieldsId;
		
		if(calFieldsId){
			let calFields = Object.fromEntries(calFieldsId.entries());
			
			let calArr = [];
			for (let prop in calFields) {
				calArr.push(calFields[prop]);
			}
			calArr = calArr.filter(function(x) {
				 return x !== '';
			});
			calFieldsId = calArr.join();
		}
		let rowId ='';
		let rowVal = [];
		let perantFeildGuid = '';
		let fieldGuid = '';
		allData.map((valu, i) => { 
			if(valu[0] == fieldId){
				rowId = (i+2);
				rowVal = valu;
				perantFeildGuid = valu[131];
				fieldGuid = valu[117];
			}
		});
		
		if(answerType.toLowerCase() == 'parent header' || answerType.toLowerCase() == 'child header 1' || answerType.toLowerCase() == 'child header 2' || answerType.toLowerCase() == 'child header 3'){
			if(question == ''){
				alert('Please enter the Visible Text for the field!');
				return false;
			}
		}else{
			if(question == '' || outputText == ''){
				alert('Please enter the Visible Text or Output Text for the field!');
				return false;
			}
		}
		
		if(this.state.dataMode == 'Child' && !addParentMds && !perantFeildGuid){
			alert('Please select the option to Add to MDS!');
			return false;
		}
		let role = localStorage.getItem('role');
		if((staticFieldID == '' || fieldIdentifier == '') && (role == 'Administrator' || role == 'Builder')){
			alert('Please add the StaticFieldID and Static FieldName Identifier!');
			return false;
		}
	
		let optionType = rowVal[5].toLowerCase();
		
		if((optionType == 'q1' || optionType == 'q2' || optionType == 'q3' || optionType == 'q11' || optionType == 'q11b' || optionType == 'smart' || optionType == 'q12') && options == ''){
			alert('Please add the options for this field!');
			return false;
		}
		
		
		let path = '';
		let numberOfColumn = '';
		let numberOfRow = '';
		
		if (optionType == 'image') {
			path = this.state.imagePath;
		}
		if(optionType == 'file'){
			path = this.state.filePath;
		}
		if(optionType == 'inlinevideo'){
			path = this.state.inlineVideo;
		}
		
		let column = 'DX';
		
		if(optionType == 'Parent Header'){
			column = 'DW';
		}
		
		if(optionType == 'q12' || optionType == 'q13'){
			buttonLabel = this.state.leftButtonTxt+','+this.state.rightButtonTxt+','+this.state.buttonLabel
		}
		

		if(optionType == 'basicgrid'){
			numberOfColumn = 1;
			let optionRows = [this.state.R1,this.state.R2,this.state.R3,this.state.R4,this.state.R5,this.state.R6,this.state.R7,this.state.R8,this.state.R9,this.state.R10,this.state.R11,this.state.R12,this.state.R13,this.state.R14,this.state.R15,this.state.R16,this.state.R17,this.state.R18,this.state.R19,this.state.R20];
			
			optionRows = optionRows.filter(function(x) {
				 return x !== undefined && x !== '';
			});
			
			numberOfColumn = this.state.numberOfColumn;
			numberOfRow = this.state.numberRows;
			let rows = [];
			optionRows.map((row, i) => { 
				if(i < numberOfRow){
					rows.push(row);
				}
			});
			let rowaStr = rows.join();
			let optionColumns = [this.state.C1];
			let columnsVali = ['C1:'+this.state.validation1+':'+this.state.vmin1+':'+this.state.vmax1];
			if(this.state.C2 && numberOfColumn >= 2){
				optionColumns.push(this.state.C2);
				columnsVali.push('C2:'+this.state.validation2+':'+this.state.vmin2+':'+this.state.vmax2);
			}
			if(this.state.C3 && numberOfColumn >= 3){
				optionColumns.push(this.state.C3);
				columnsVali.push('C3:'+this.state.validation3+':'+this.state.vmin3+':'+this.state.vmax3);
			}
			if(this.state.C4 && numberOfColumn >= 4){
				optionColumns.push(this.state.C4);
				columnsVali.push('C4:'+this.state.validation4+':'+this.state.vmin4+':'+this.state.vmax4);
			}
			if(this.state.C5 && numberOfColumn >= 5){
				optionColumns.push(this.state.C5);
				columnsVali.push('C5:'+this.state.validation5+':'+this.state.vmin5+':'+this.state.vmax5);
			}
			if(this.state.C6 && numberOfColumn >= 6){
				optionColumns.push(this.state.C6);
				columnsVali.push('C6:'+this.state.validation6+':'+this.state.vmin6+':'+this.state.vmax6);
			}
			if(this.state.C7 && numberOfColumn >= 7){
				optionColumns.push(this.state.C7);
				columnsVali.push('C7:'+this.state.validation7+':'+this.state.vmin7+':'+this.state.vmax7);
			}
			if(this.state.C8 && numberOfColumn >= 8){
				optionColumns.push(this.state.C8);
				columnsVali.push('C8:'+this.state.validation8+':'+this.state.vmin8+':'+this.state.vmax8);
			}
			validationType = columnsVali.join();
			optionColumns = optionColumns.filter(function(x) {
				 return x !== 'undefined:undefined';
			});
			
			//console.log('optionColumns->',optionColumns);
			
			let columnStr = optionColumns.join();                 
			labelValue = columnStr+'_'+rowaStr
		}
		
		if(optionType == 'basicgrid2'){
			numberOfColumn = 1;
			let optionRows = [this.state.R1,this.state.R2,this.state.R3,this.state.R4,this.state.R5,this.state.R6,this.state.R7,this.state.R8,this.state.R9,this.state.R10,this.state.R11,this.state.R12,this.state.R13,this.state.R14,this.state.R15,this.state.R16,this.state.R17,this.state.R18,this.state.R19,this.state.R20];
			
			optionRows = optionRows.filter(function(x) {
				 return x !== undefined && x !== '';
			});
			
			numberOfColumn = this.state.numberOfColumn;
			numberOfRow = this.state.numberRows;
			let rows = [];
			optionRows.map((row, i) => { 
				if(i < numberOfRow){
					rows.push(row);
				}
			});
			
			let rowaStr = rows.join();
			
			let optionColumns = [this.state.C1+':'+this.state.columnOption1];
			let columnsVali = ['C1:'+this.state.validation1+':'+this.state.vmin1+':'+this.state.vmax1];
			if(this.state.columnOption1 == 'limited' && this.state.Option1){
				optionColumns = [this.state.C1+':'+this.state.columnOption1+':'+this.state.Option1];
				columnsVali = ['C1:V1'];
			}
			
			if(this.state.C2 && numberOfColumn >= 2){
				
				if(this.state.columnOption2 == 'limited' && this.state.Option2){
					optionColumns.push(this.state.C2+':'+this.state.columnOption2+':'+this.state.Option2);
					columnsVali.push('C2:V1');
				}else{
					optionColumns.push(this.state.C2+':'+this.state.columnOption2);
					columnsVali.push('C2:'+this.state.validation2+':'+this.state.vmin2+':'+this.state.vmax2);
				}
			
				
			}
			if(this.state.C3 && numberOfColumn >= 3){
				
				if(this.state.columnOption3 == 'limited' && this.state.Option3){
					optionColumns.push(this.state.C3+':'+this.state.columnOption3+':'+this.state.Option3);
					columnsVali.push('C3:V1');
				}else{
					optionColumns.push(this.state.C3+':'+this.state.columnOption3);
					columnsVali.push('C3:'+this.state.validation3+':'+this.state.vmin3+':'+this.state.vmax3);
				}
				
			}
			if(this.state.C4 && numberOfColumn >= 4){
				
				if(this.state.columnOption4 == 'limited' && this.state.Option4){
					optionColumns.push(this.state.C4+':'+this.state.columnOption4+':'+this.state.Option4);
					columnsVali.push('C4:V1');
				}else{
					optionColumns.push(this.state.C4+':'+this.state.columnOption4);
					columnsVali.push('C4:'+this.state.validation4+':'+this.state.vmin4+':'+this.state.vmax4);
				}
				
			}
			if(this.state.C5 && numberOfColumn >= 5){
				
				if(this.state.columnOption5 == 'limited' && this.state.Option5){
					optionColumns.push(this.state.C5+':'+this.state.columnOption5+':'+this.state.Option5);
					columnsVali.push('C5:V1');
				}else{
					optionColumns.push(this.state.C5+':'+this.state.columnOption5);
					columnsVali.push('C5:'+this.state.validation5+':'+this.state.vmin5+':'+this.state.vmax5);
				}
				
			}
			
			if(this.state.C6 && numberOfColumn >= 6){
				
				if(this.state.columnOption6 == 'limited' && this.state.Option6){
					optionColumns.push(this.state.C6+':'+this.state.columnOption6+':'+this.state.Option6);
					columnsVali.push('C6:V1');
				}else{
					optionColumns.push(this.state.C6+':'+this.state.columnOption6);
					columnsVali.push('C6:'+this.state.validation6+':'+this.state.vmin6+':'+this.state.vmax6);
				}
				
			}
			
			if(this.state.C7 && numberOfColumn >= 7){
				
				if(this.state.columnOption7 == 'limited' && this.state.Option7){
					optionColumns.push(this.state.C7+':'+this.state.columnOption7+':'+this.state.Option7);
					columnsVali.push('C7:V1');
				}else{
					optionColumns.push(this.state.C7+':'+this.state.columnOption7);
					columnsVali.push('C7:'+this.state.validation7+':'+this.state.vmin7+':'+this.state.vmax7);
				}
				
			}
			
			if(this.state.C8 && numberOfColumn >= 8){
				
				if(this.state.columnOption8 == 'limited' && this.state.Option8){
					optionColumns.push(this.state.C8+':'+this.state.columnOption8+':'+this.state.Option8);
					columnsVali.push('C8:V1');
				}else{
					optionColumns.push(this.state.C8+':'+this.state.columnOption8);
					columnsVali.push('C8:'+this.state.validation8+':'+this.state.vmin8+':'+this.state.vmax8);
				}
				
			}
			
			validationType = columnsVali.join();
			
			let columnStr = optionColumns.join('|');
			labelValue = columnStr+'_'+rowaStr
		}
		
		
		if(optionType == 'grid-multicheck' || optionType == 'grid-singlecheck'){
			numberOfColumn = 1;
			let optionRows = [this.state.R1,this.state.R2,this.state.R3,this.state.R4,this.state.R5,this.state.R6,this.state.R7,this.state.R8,this.state.R9,this.state.R10,this.state.R11,this.state.R12,this.state.R13,this.state.R14,this.state.R15,this.state.R16,this.state.R17,this.state.R18,this.state.R19,this.state.R20];
			
			optionRows = optionRows.filter(function(x) {
				 return x !== undefined && x !== '';
			});
			
			numberOfColumn = this.state.numberOfColumn;
			numberOfRow = this.state.numberRows;
			let rows = [];
			optionRows.map((row, i) => { 
				if(i < numberOfRow){
					rows.push(row);
				}
			});
			let rowaStr = rows.join();
			let optionColumns = [this.state.C1];
			if(this.state.C2 && numberOfColumn >= 2){
				optionColumns.push(this.state.C2);
			}
			if(this.state.C3 && numberOfColumn >= 3){
				optionColumns.push(this.state.C3);
			}
			if(this.state.C4 && numberOfColumn >= 4){
				optionColumns.push(this.state.C4);
			}
			if(this.state.C5 && numberOfColumn >= 5){
				optionColumns.push(this.state.C5);
			}
			
			if(this.state.C6 && numberOfColumn >= 6){
				optionColumns.push(this.state.C6);
			}
			
			if(this.state.C7 && numberOfColumn >= 7){
				optionColumns.push(this.state.C7);
			}
			
			if(this.state.C8 && numberOfColumn >= 8){
				optionColumns.push(this.state.C8);
			}
			
			optionColumns = optionColumns.filter(function(x) {
				 return x !== 'undefined:undefined';
			});
			let columnStr = optionColumns.join();
			labelValue = columnStr+'_'+rowaStr
		}
		
		
		if(optionType == 'grid5point'){
			let sacale = [this.state.sacale1,this.state.sacale2,this.state.sacale3,this.state.sacale4,this.state.sacale5];
			let gridRows = [this.state.row1,this.state.row2,this.state.row3,this.state.row4,this.state.row5,this.state.row6,this.state.row7,this.state.row8,this.state.row9,this.state.row10,this.state.row11,this.state.row12,this.state.row13,this.state.row14,this.state.row15];
			sacale = sacale.filter(function(x) {
				 return x !== undefined && x !== '';
			});
			gridRows = gridRows.filter(function(x) {
				 return x !== undefined && x !== '';
			});
			numberOfRow = this.state.numberRows;
			let rows = [];
			gridRows.map((row, i) => { 
				if(i < numberOfRow){
					rows.push(row);
				}
			});
			let sacaleStr = sacale.join();
			let rowaStr = rows.join();
			labelValue = sacaleStr+'_'+rowaStr;
		}
		
		if(optionType == 'grid-dropdown'){
			numberOfColumn = 2;
			let optionColumns = [this.state.C1,this.state.C2];
			if(this.state.numberOfColumn){
				numberOfColumn = this.state.numberOfColumn;
			}
			if(this.state.C3 && numberOfColumn == 3){
				optionColumns.push(this.state.C3);
			}
			optionColumns = optionColumns.filter(function(x) {
				 return x !== 'undefined';
			});
			let columnStr = optionColumns.join();
			

			numberOfRow = this.state.numberRows;
			let optionRows = [];
			for(let i=1; i <= numberOfRow; i++ ){
				if(numberOfColumn == 2 && this.state['R'+i+'C1']){
					optionRows.push(this.state['R'+i+'C1']+':'+this.state['R'+i+'C2']);
				}else if(numberOfColumn == 3 && this.state['R'+i+'C1']){
					optionRows.push(this.state['R'+i+'C1']+':'+this.state['R'+i+'C2']+':'+this.state['R'+i+'C3']);
				}
			}
			
			let rows = [];
			optionRows.map((row, i) => { 
				if(i < numberOfRow){
					rows.push(row);
				}
			});
			let rowaStr = rows.join('|');
			
			
			labelValue = columnStr+'_'+rowaStr
			
		}
		
		
		if(optionType == 'gridcheck'){
			let numberOfGrid = 2;
			let optionColumns = [this.state.C1,this.state.C2];
			if(this.state.numberOfGrid){
				numberOfGrid = this.state.numberOfGrid;
			}
			if(this.state.C3 && numberOfGrid == 3){
				optionColumns.push(this.state.C3);
			}
			if(this.state.C4 && numberOfGrid == 4){
				optionColumns.push(this.state.C4);
			}
			optionColumns = optionColumns.filter(function(x) {
				 return x !== 'undefined';
			});
			let columnStr = optionColumns.join();
			
			
			let gridRows = [this.state.row1,this.state.row2,this.state.row3,this.state.row4,this.state.row5];
			gridRows = gridRows.filter(function(x) {
				 return x !== undefined && x !== '';
			});
			
			numberOfRow = this.state.numberRows;
			let rows = [];
			gridRows.map((row, i) => { 
				if(i < numberOfRow){
					rows.push(row);
				}
			});
			
			let rowaStr = rows.join();
			labelValue = columnStr+'_'+rowaStr;
		}
		
		
		if(optionType == 'likert'){
			numberOfColumn = 1;
			if(this.state.numberOfColumn){
				numberOfColumn = this.state.numberOfColumn;
			}
			
			let optionColumns = [this.state.L1];
			/* if(this.state.L2 && numberOfColumn >= 2){
				optionColumns.push(this.state.L2);
			} */
			
			for(let i=2; i <= numberOfColumn; i++ ){
				let vri = 'L'+i;
				if(this.state[vri]){
					optionColumns.push(this.state[vri]);
				}
			}
			optionColumns = optionColumns.filter(function(x) {
				 return x !== undefined && x !== '';
			});
			let columnStr = optionColumns.join();
			
			let gridRows = [this.state.row1,this.state.row2,this.state.row3,this.state.row4,this.state.row5];
			gridRows = gridRows.filter(function(x) {
				 return x !== undefined && x !== '';
			});
			numberOfRow = this.state.numberRows;
			let rows = [];
			gridRows.map((row, i) => { 
				if(i < numberOfRow){
					rows.push(row);
				}
			});
			let rowaStr = rows.join();
			labelValue = columnStr+'_'+rowaStr;
		}
		
		/* if(optionType == 'likert'){
			let sacale = [this.state.lowestText,this.state.highestText];
			let gridRows = [this.state.row1,this.state.row2,this.state.row3,this.state.row4,this.state.row5];
			sacale = sacale.filter(function(x) {
				 return x !== undefined && x !== '';
			});
			gridRows = gridRows.filter(function(x) {
				 return x !== undefined && x !== '';
			});
			numberOfRow = this.state.numberRows;
			let rows = [];
			gridRows.map((row, i) => { 
				if(i < numberOfRow){
					rows.push(row);
				}
			});
			let sacaleStr = sacale.join();
			let rowaStr = rows.join();
			labelValue = sacaleStr+'_'+rowaStr;
		} */
		
		if(optionType == 'weighted'){
			let state = this.state;
			numberOfColumn = 1;
			let optionRows = [state.row1+':'+state.weight1 , state.row2+':'+state.weight2,state.row3+':'+state.weight3 , state.row4+':'+state.weight4,state.row5+':'+state.weight5 , state.row6+':'+state.weight6,state.row7+':'+state.weight7 , state.row8+':'+state.weight8,state.row9+':'+state.weight9 , state.row10+':'+state.weight10];
			
			optionRows = optionRows.filter(function(x) {
				 return x !== 'undefined:undefined' && x !== ':';
			});
			
			numberOfRow = this.state.numberRows;
			let rows = [];
			optionRows.map((row, i) => { 
				if(i < numberOfRow){
					rows.push(row);
				}
			});
			labelValue = rows.join();
			numberOfColumn = this.state.numberOfGrid;
		}
				
		
		if(optionType == 'q13'){
			let guid = ulid();
			if(this.state.q13Guid){
				guid = this.state.q13Guid;
			}
			options = guid+'|'+this.state.changeAnsInpText;
		}
		
		if(optionType == 'smart'){
			let str = this.state.changeAnsInpText.split(',');
			if(this.state.noneAbove != ''){
				let exist = false;
				str.map((name, i) => {
					name = name.split('|');
					if(name[1] == 'None of the Above'){
						exist = true;
					}
				})
				
				if(!exist){
					let guid = ulid();
					options = this.state.changeAnsInpText+','+guid+'|'+this.state.noneAbove;
				}
			}else{
				let newOptions = [];
				str.map((val, i) => {
					let name = val.split('|');
					if(name[1] != 'None of the Above'){
						newOptions.push(val);
					}
				})
				options = newOptions.join(',');
			}
		}
		
		let data = [];
		
		if (optionType == 'launchpad') {
			mod = 'LP1';
			if(this.state.launchpadType != ''){
				mod = this.state.launchpadType;
			}
			
			ogAutoTags = this.state.ogAutoTags;
			requiredFields = this.state.requiredFields;
			optionalFields = this.state.optionalFields;
			if(requiredFields){
				let rqFields = Object.fromEntries(requiredFields.entries());
				let rqcalArr = [];
				for (let prop in rqFields) {
					rqcalArr.push(rqFields[prop]);
				}
				rqcalArr = rqcalArr.filter(function(x) {
					 return x !== '';
				});
				requiredFields = rqcalArr.join();
			}
			
			if(optionalFields){
				let opFields = Object.fromEntries(optionalFields.entries());
				let opcalArr = [];
				for (let prop in opFields) {
					opcalArr.push(opFields[prop]);
				}
				opcalArr = opcalArr.filter(function(x) {
					 return x !== '';
				});
				optionalFields = opcalArr.join();
			}
			
		}
		
		if(optionType == 'slider'){
			sliderMinValue = this.state.sliderMinValue
			sliderMaxValue = this.state.sliderMaxValue
			sliderStepValue = this.state.sliderStepValue
			labelValue = this.state.sliderMinText+', '+this.state.sliderMaxText;
		}
		
		if(optionType == 'weighted'){
			mod = this.state.arraignment;
		}
		
		if(optionType == 'q4'){
			mod = this.state.styleQ4;
		}
		
		let currentDate = new Date().toLocaleString("en-US", {timeZone: "America/New_York"}).replace(',','');
		
		let hiddendns = this.state.hiddenDimensions;
		let hiddendnsArray = [];
		if(hiddendns){
			let hidFields = Object.fromEntries(hiddendns.entries());
			let hidArr = [];
			for (let prop in hidFields) {
				hidArr.push(hidFields[prop]);
			}
			hiddendnsArray = hidArr.filter(function(x) {
				 return x !== '';
			});
		}
		
		let dates = [];

		allData.map((val, i) => {
			if(val[0] == fieldId){
				if(val[5] != answerType){
					val[117] = newFieldGuid;
				}
				val[3] = dataAgg;
				val[4] = question;
				val[5] = answerType;
				val[6] = options;
				val[9] = outputText;
				val[12] = noteHtml;
				val[13] = addTagsText;
				val[48] = validationType;
				
				val[50] = minValue;
				val[51] = maxValue;
				val[99] = path;
				val[65] = legacyData;
				
				val[100] = dataElement;
				val[101] = dataElementOption ? dataElementOption : 'Public';
				val[102] = responseDataFormat;
				val[53] = LeftGridLabel;
				
				val[106] = autoPopulateTags;
				val[127] = asGroup;
				val[125] = chooseTracking;
				val[110] = dataPersistence;
				val[39] = persistencekey;
				val[42] = exPersistencekey;
				val[61] = fieldIdentifier;
				val[63] = staticFieldID;
				val[64] = fieldAltText;
				val[57] = fieldRegistry;
				val[56] = fieldInternalNote;
				val[52] = fieldRAGNote;
				val[58] = builderNote;
				val[60] = fieldDeactivated;
				val[78] = websiteLink;
				val[142] = requiredFields;
				val[143] = optionalFields;
				val[144] = ogAutoTags;
				val[44] = responseAction;
				val[113] = calculationType;
				val[114] = answerType == 'calculation' ? calFieldsId : wcalFieldsId;
				val[40] = buttonLabel;
				val[41] = labelValue;
				val[45] = visibleTxtLabel;
				val[46] = outputTxtLabel;
				val[136] = numberOfColumn;
				val[137] = numberOfRow;
				val[138] = mod;
				val[59] = analysisVideo;
				//val[60] = reportPdf;
				val[98] = currentDate;
				val[91] = mdsGuid;
				val[69] = optionSorting;
				val[30] = MinOptionSelection;
				val[31] = MaxOptionSelection;
				val[70] = hiddendnsArray;
				//val[70] = '';
				if(answerType == 'slider' && labelValue){
					val[50] = sliderMinValue;
					val[51] = sliderMaxValue;
					val[36] = sliderStepValue;
				}
			}
			
			let date = new Date(val[98]);
			if(date != 'Invalid Date'){
				dates.push(date); 
			}
		});
		
		let maximumDate = new Date(Math.max.apply(null, dates));
		let modifiedDate = new Date(maximumDate).toLocaleString("en-US").replace(',','');
		
		if(fieldId || this.state.dataMode == 'Child'){
			modifiedDate = new Date().toLocaleString("en-US", {timeZone: "America/New_York"}).replace(',','');
		}
		let fieldData = {
			"MDSName": sheetName,
			"MDSGuid": mdsGuid,
			"Version": version ? version : '1.01',
			"ModifiedDate": moment(modifiedDate).format('YYYY-MM-DD HH:mm:ss'),
			"Fields": allData,
		}
		
		if(this.state.dataMode == 'Child'){
			fieldData = {
				"LayoutName": sheetName,
				"LayoutGuid": mdsGuid,
				"Version": version ? version : '1.01',
				"ModifiedDate": moment(modifiedDate).format('YYYY-MM-DD HH:mm:ss'),
				"Fields": allData,
			}
		}
		
		this.mongoUpdateData(fieldData,sheetName,'field-update');
	}
	
	deleteField(filed){
		let allData = this.state.allData;
		let newData = [];
		let startIndex = '';
		allData.map((rowDatas, i) => {
			if(rowDatas[0] != filed){
				newData.push(rowDatas);
			}
			if(rowDatas[0] == filed){
				startIndex = i+1;
			}
		});
		this.setState({allData:newData});
		let that = this;
		setTimeout(function(){
			that.updateData('del');
		}, 1000);
	}
	
	softDeleteField(){
		alert('This field cannot be Deleted!');
	}
	
	emptyState=()=>{
		let kioskResponse = this.state.kioskResponse;
		let userClassResponse = this.state.userClassResponse;
		let checkedNeeds = this.state.checkedNeeds;
		let userReviewData = this.state.userReviewData;
		let needsNote = this.state.needsNote;
		this.setState({kioskResponse:new Map(),checkedCopyFields:new Map(),userClassResponse:new Map(),checkedNeeds:new Map(),needsNote:new Map(),userReviewData:new Map()});
	}
	
	checkKey2(elements, parentId = '',ids ,pId, cId) {
        var branch = [];
        { elements.map((element,i) => {
            if(element[5] == 'Parent Header'){
                element[pId] = '';
            }  
            if (element[pId].toLowerCase() == parentId) {
                if(element[cId] == ''){
                    element[cId]='a';
                }
                var children = this.checkKey2(elements, element[cId].toLowerCase(), ids, pId, cId);
                if (children) {
                    element['sub'] = children; 
                }
                if(!ids.includes(element['0'])){
                    branch.push(element);  
                }
                ids.push(element['0']);
            }
        })};
        return branch;    
    }
	
	handleInclude = (e) => {
		let item = e.target.name;
        let isChecked = e.target.checked;
        let checkedInc = this.state.checkedInc;
        let that = this;
		if(isChecked == true){
			checkedInc.set(item, 'Y')
		}else{
            checkedInc.set(item, 'N')
        }
		this.setState({checkedInc: checkedInc});
		
		setTimeout(function(){
			that.includeHeaders(item,isChecked);
		}, 1000);
		
    }
	
	includeHeaders=(item,isChecked)=>{
		let data = this.state.originalData2;
		let dataArray = []; 
		data.map((rows, i) => {
			dataArray.push(rows);
		});	
		let reverse = dataArray.reverse();
		
		let checkedInc = this.state.checkedInc;
		reverse.map((rows, i) => {
			let childInclude = false;
			if(rows.sub){
				if(rows.sub.length > 0){
					
					let headerHnclude = checkedInc.get(rows[0]);
			
					rows.sub.map((rs, i) => {
						if(headerHnclude == 'N' && item == rows[0]){
							checkedInc.set(rs[0], 'N');
						}else{
							let include = checkedInc.get(rs[0]);
							if(include == 'Y'){
								childInclude = true;
							}
						}
						
						if(rs.sub){
							if(rs.sub.length > 0){
								
								rs.sub.map((ra, i) => {
									if(headerHnclude == 'N' && item == rows[0]){
										checkedInc.set(ra[0], 'N');
									}else{
										let included = checkedInc.get(ra[0]);
										if(included == 'Y'){
											childInclude = true;
										}
									}
									
									if(ra.sub){
										if(ra.sub.length > 0){
											
											ra.sub.map((rk, i) => {
												if(headerHnclude == 'N' && item == rows[0]){
													checkedInc.set(rk[0], 'N');
												}else{
													let included = checkedInc.get(rk[0]);
													if(included == 'Y'){
														childInclude = true;
													}
												}
												
												if(rk.sub){
													if(rk.sub.length > 0){
														
														rk.sub.map((rj, i) => {
															if(headerHnclude == 'N' && item == rows[0]){
																checkedInc.set(rj[0], 'N');
															}else{
																let included = checkedInc.get(rj[0]);
																if(included == 'Y'){
																	childInclude = true;
																}
															}
														});
													}
												}
											
											});
										}
									}
								});
							}
						}
					});
					
					if(childInclude){
						checkedInc.set(rows[0], 'Y');
					}else if(item != rows[0] && isChecked != true){
						checkedInc.set(rows[0], 'N');
					}
				}
				
				this.setState({checkedInc: checkedInc});	
			}
		});
	}

	handleRequire = (e) => {
		let item = e.target.name;
        let isChecked = e.target.checked;
        let checkedReq = this.state.checkedReq;
        
		if(isChecked == true){
			checkedReq.set(item, 'Y')
			
        }else{
            checkedReq.set(item, 'N')
        }
		
        this.setState({checkedReq: checkedReq});
    }
	
	handleKiosk = (e) => {
		let item = e.target.name;
        let isChecked = e.target.checked;
        let checkedKiosk = this.state.checkedKiosk;
        
		if(isChecked == true){
			checkedKiosk.set(item, 'Y')
        }else{
            checkedKiosk.set(item, 'N')
        }
		
        this.setState({checkedKiosk: checkedKiosk});
    }
	
	selectKioskUsers=(event)=>{
		let delegateUsers = this.state.delegateUsers;
		let item = event.target.name;
		delegateUsers.set(item, Array.from(event.target.selectedOptions, (item) => item.value))
        this.setState({delegateUsers:delegateUsers});
    }

	showAddUsersModal=(id)=>{
		this.setState({fieldId:id});
		$('#kioskUser').modal('show');
	}
	
	showPreviewModal=(value)=>{
		this.setState({previewData:value});
		$('#fieldPreview').modal('show')
	}
	
	classTypes(comment){
        let className = 'question';
        if(comment[5].toLowerCase() == 'parent header'){
            className = 'parent-header';
        }else if(comment[5].toLowerCase() == 'child header 1'){
			className = 'builder-header-1 ';
		}else if(comment[5].toLowerCase() == 'child header 2'){
			className = 'builder-header-2 ';
		}else if(comment[5].toLowerCase() == 'child header 3'){
			className = 'builder-header-3 ';
		}
		return className;
    }
	
	showOutputText=()=>{
		let outputText = this.state.outputText;
		if($("input[name='showOutputText']").prop("checked") == true){
			this.setState({outputText:true});
		}else{
			this.setState({outputText:false});
		}
	}
	
	showHideForm=()=>{
		if($("input[name='showHide']").prop("checked") == true){ 
			$('.mode-Prod').hide();
		}else{
			$('.mode-Prod').show();
		}
	}
	
	getRequiredAndOptionalFields=(fieldId)=>{
		let allData = this.state.allData;
		let rqFields = [];
		let opFields = [];
		if(allData.length > 1){
			
			allData.map((field,i)=>{
				
				if(fieldId != field[0] && field[15] == 'Y'){
					let array = [field[0],field[4],field[91],field[117]];
					rqFields.push(array);
				}
				
				if(fieldId != field[0] && field[15] == 'N'){
					let arrayOp = [field[0],field[4],field[91],field[117]];
					opFields.push(arrayOp);
				}
			});
			
			this.setState({rqFields,opFields});
		} 
	}
	
	handleAddNewFiled = (e) => {
		
		let allData = this.state.allData;
		
		allData.map((field,i)=>{
			this.setState({[field[0]]: ''});
		});
		
		let id = e.target.name;
		let pos = e.target.value;
		let isChecked = e.target.checked;
		if(isChecked == true){
			this.setState({fieldPos: pos,[id]: pos});
        }else{
            this.setState({fieldPos: '',[id]: ''});
        }
	}
	
	clearTempData=(msg=null)=>{
		let arr1 = this.state.mdsHeaders;
		this.setState({allData:''});
		let that = this;
		let user_id = this.state.userGuid;
        let sheetName = 'Temp-File-'+user_id;
		setTimeout(function(){
			let arr1 = that.state.mdsHeaders;
			let fieldData = {
				"MDSName": sheetName,
				"MDSGuid": ulid(),
				"Version": 1.01,
				"Fields": arr1,
			}
			if(that.state.dataMode == 'Child'){
				fieldData = {
					"LayoutName": sheetName,
					"LayoutGuid": ulid(),
					"ModifiedDate": '',
					"Version": 1.01,
					"Fields": arr1,
				}
			}
			//console.log('fieldData->',fieldData);
			that.mongoUpdateData(fieldData);
		}, 1000);
	}
	
	buildDetails=()=>{
		$(".fadeInRight").trigger("click");
		this.setState({showFieldEdit:false,showBuildEdit:true,fieldPrefix:''});
		$('.build-select').val('');
	}
	
	buildMds=(mode)=>{
		let allData = this.state.allData;
		let mdsDataName = this.state.mdsDataName;
		let mdsExist = false;
		let guid = allData[0][91];	
		let ApiUrl = config.mongoApiUrl;
		
		let url = ApiUrl+'mds-file-v2/'+mdsDataName;
		
		if(this.state.dataMode == 'Child'){
			url = ApiUrl+'layout-file-v2/'+mdsDataName;
		}
		
		let data = [];
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			const Mdsform = response.data;
			if(mode == 'Update'){
				if(Mdsform.MDSGuid != guid && Mdsform.MDSName == mdsDataName){
					mdsExist = true;
				}
			}else{
				if(Mdsform.MDSName == mdsDataName){
					mdsExist = true;
				}
			}
			let that = this;
			setTimeout(function(){
				if(mdsExist){
					alert('MDS or Layout name already exist!');
					$("#mdsDataName").addClass('error');
					$('#createBuild').modal('hide');
				}else{
					that.buildMds2(mode);
				}
			}, 1000);
		});
	}
	
	buildMds2=(mode)=>{
		let mdsDataName = this.state.mdsDataName;
		let mdsCompany = this.state.mdsCompany;
		let mdsFacility = this.state.mdsFacility;
		
		if(!mdsFacility && this.state.dataMode == 'Child'){
			mdsFacility = this.state.defaultLayoutFacility;
		}
		let mdsGroupId = this.state.mdsGroupId;
		//let Public = this.state.Public;
		//let chooseCompany = this.state.chooseCompany;
		let allDelegate = this.state.allDelegate;
		let allTypes = this.state.allTypes;
		let associatedAnatomy = this.state.associatedAnatomy;
		let allDeviceTypes = this.state.allDeviceTypes;
		let allVisitTypes = this.state.allVisitTypes;
		let internalNote = this.state.internalNote;
		
		let error = 0;
		if(!mdsDataName){
			$("#mdsDataName").addClass('error');
			//alert('Please select Master Data Set Name!');
			//return false;
			error = 1;
		}
		
		if(!mdsFacility){
			$("#mdsFacility").addClass('error');
			//alert('Please select Facility ID!');
			//return false;
			error = 1;
		}
		
		if(!allDelegate){
			$("#allDelegate").addClass('error');
			//alert('Please select Delegate Types!');
			//return false;
			error = 1;
		}
		
		if(!allTypes){
			$("#allTypes").addClass('error');
			//alert('Please select Associated Type!');
			//return false;
			error = 1;
		}
		
		if(!allDeviceTypes){
			$("#allDeviceTypes").addClass('error');
			//alert('Please select Associated Device Type!');
			//return false;
			error = 1;
		}
		
		if(!allVisitTypes){
			$("#allVisitTypes").addClass('error');
			//alert('Please select Associated Visit Type!');
			//return false;
			error = 1;
		}
		
		if(this.state.dataMode == 'Child'){
			let Public = this.state.Public;
			let privateOwner = this.state.privateOwner;
			let layoutFriendlyName = this.state.layoutFriendlyName;
			let layoutCategory = this.state.layoutCategory;
			
			if(Public == 'No' && ( privateOwner == '' || privateOwner == undefined )){
				error = 1;
			}
			
			if(!Public){
				$("#Public").addClass('error');
				error = 1;
			}
			
			if(!layoutFriendlyName){
				$("#layoutFriendlyName").addClass('error');
				error = 1;
			}
			
			if(!associatedAnatomy){
				$("#associatedAnatomy").addClass('error');
				error = 1;
			}
			
			if(!layoutCategory){
				$("#layoutCategory").addClass('error');
				error = 1;
			}
		}
		
		if(error == 1){
			$('#createBuild').modal('hide');
			setTimeout(function(){
				alert('Please select fill in the required fields!');
			}, 1000);
			return false;
		}
		
		
		let fieldPrefix = this.state.fieldPrefix;
		let uld = ulid();
		if(mode != 'Update' && !fieldPrefix){
			fieldPrefix = mdsDataName;
		}
		
		if(mode == 'Update' && this.state.dataMode == 'Child'){
			fieldPrefix = mdsDataName;
		}
		
		let selectedSheet = this.state.selectedSheet;
        let user_id = this.state.userGuid;
        let sheetName = 'Temp-File-'+user_id;
        if(selectedSheet != '' && selectedSheet !== undefined){
			sheetName = selectedSheet;
		}
		
		let allData = this.state.allData;
		let existMds = false;
		let txt = '';
		if(this.state.dataMode == 'Child' && mode != 'Update'){
			
			allData.map((rows, i) => {
				if(existMds){
					return false;
				}
				if(!rows[129] || !rows[130] || !rows[131]){
					txt = rows[4] ? rows[4] : rows[5];
					$("#fId-"+rows[0]).trigger("click");
					existMds = true;
				}
			});
			
		}
		
		if(existMds){
			$('#createBuild').modal('hide');
			setTimeout(function(){
				alert('The field "'+txt+'" required to add to Parent MDS!');
				$('#sidebar-wrapper-right').animate({ scrollTop: 0}, 1000);
			}, 1000);
			return false;
		}
		
		/* let version = allData[0][59];
			
		if(sheetName != 'Temp-File' && version != '' && mode != 'Update'){
			version = parseFloat(version) + parseFloat(0.01);
		}else{
			version = 1.01;
		} */
		let version = '1.01';
		
		if(this.state.selectedSheetversion){
			version = this.state.selectedSheetversion;
		}
		
		allData[0][115] = mdsCompany;
		allData[0][120] = mdsFacility;
		allData[0][121] = mdsGroupId;
		allData[0][119] = allDelegate;
		allData[0][92] = allTypes;
		allData[0][94] = allDeviceTypes;
		allData[0][95] = allVisitTypes;
		allData[0][96] = associatedAnatomy;
		allData[0][59] = version;
		
		if(this.state.dataMode == 'Child'){
			allData[0][62] = this.state.layoutFriendlyName;
			allData[0][111] = this.state.Public;
			allData[0][115] = this.state.privateOwner;
			allData[0][125] = this.state.chooseTracking;
		}
		
		let dates=[];
		if(mode != 'Update'){
			
			let rowId='';
			let prefixId='';
			allData.map((rowDatas, i) => {
				rowId = (i+2);
				prefixId = (i+1);
				let prefix = fieldPrefix+'-'+prefixId;
				let newPos = rowDatas[16].replace(rowDatas[0],prefix);
				rowDatas[0] = prefix;
				rowDatas[16] = newPos;
				rowDatas[91] = uld;
			
				if(this.state.dataMode == 'MDS'){
					rowDatas[118] = mdsDataName;
				}

				let date = new Date(rowDatas[98]);
				if(date != 'Invalid Date'){
					dates.push(date);
				}
				
				if(this.state.dataMode == 'Child'){
					rowDatas[17] = 'Yes';
				}
				
			});
			
		}else{
			let rowId='';
			let prefixId='';
			uld = allData[0][91];
			allData.map((rowDatas, i) => {
				rowId = (i+2);
				prefixId = (i+1);
				let prefix = fieldPrefix+'-'+prefixId;
				let newPos = rowDatas[16].replace(rowDatas[0],prefix);
				rowDatas[0] = prefix;
				rowDatas[16] = newPos;
	
				if(this.state.dataMode == 'MDS'){
					rowDatas[118] = mdsDataName;
				}

				let date = new Date(rowDatas[98]);
				if(date != 'Invalid Date'){
					dates.push(date);
				}
				
				if(this.state.dataMode == 'Child'){
					rowDatas[17] = 'Yes';
				}
			
			});
		}
		
		let maximumDate = new Date(Math.max.apply(null, dates));
		let lastUpDate = new Date(maximumDate).toLocaleString("en-US").replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
		let totalFields = allData.length;
		
		let apiName = 'MDS_'+ mdsDataName +'_'+lastUpDate+'_'+totalFields;
		if(this.state.dataMode == 'Child'){
			apiName = 'DefaultLayout_'+ mdsDataName +'_'+lastUpDate+'_'+totalFields;
		}
		
		allData[0][123] = apiName;
		
		let arr1 = this.state.mdsHeaders;
		let allMdsData = arr1.concat(allData);
		
		let minimumDate = new Date(Math.min.apply(null, dates));
		let modifiedDate = new Date(maximumDate).toLocaleString("en-US").replace(',','');
		let createdDate = new Date(minimumDate).toLocaleString("en-US").replace(',','');

		let fieldData = {
			"MDSGuid": uld,
			"MDSName": mdsDataName,
			"InstanceName": this.state.selectedInstanceName,
			"InstanceGuild": this.state.selectedInstanceId,
			"CreatedDate": moment(createdDate).format('YYYY-MM-DD HH:mm:ss'),
			"ModifiedDate": moment(modifiedDate).format('YYYY-MM-DD HH:mm:ss'),
			"Version": version,
			"Mode": 'Test',
			//"CreatedBy": this.state.createdBy,
			"Fields": allMdsData,
		}
		
		if(this.state.dataMode == 'Child'){
			modifiedDate = new Date().toLocaleString("en-US", {timeZone: "America/New_York"}).replace(',','');
			fieldData = {
				"LayoutName": mdsDataName,
				"LayoutGuid": uld,
				"InstanceName": this.state.selectedInstanceName,
				"InstanceGuild": this.state.selectedInstanceId,
				"LayoutCategory": this.state.layoutCategory,
				"AssociatedAnatomy": this.state.associatedAnatomy,
				"startWorkflow": this.state.startWorkflow,
				"JobInitiator": this.state.JobInitiator,
				"workflowCategory": this.state.workflowCategory,
				"CreatedDate": moment(createdDate).format('YYYY-MM-DD HH:mm:ss'),
				"ModifiedDate": moment(modifiedDate).format('YYYY-MM-DD HH:mm:ss'),
				"Version": version,
				"InternalNote": internalNote,
				"Mode": 'Test',
				//"CreatedBy": this.state.createdBy,
				"Fields": allMdsData,
			}

			if(mode == 'Update'){
				this.mongoUpdateLayout(fieldData,mdsDataName);
			}else{
				fieldData['CreatedBy'] = this.state.CreatedBy;
				this.mongoStoreNewLayout(fieldData,mdsDataName);
			}
			//this.mongoStoreNewLayout(fieldData,mdsDataName);
		}else if(this.state.dataMode == 'MDS' && mode != 'Update'){
			
			if(this.state.selectedInstanceId){
				fieldData['CreatedBy'] = this.state.CreatedBy;
				this.mongoStoreNewMds(fieldData,mdsDataName);
			}else{
				$('#createBuild').modal('hide');
				alert('Please select Instance first!');
			}
		}
		
		if(mode == 'Update'){
			this.setState({selectedSheet:mdsDataName});
			this.mongoUpdateData(fieldData,mdsDataName);
			$(".fadeInRight").trigger("click");
			//alert('Work In-Progress');
		}
		if(mode != 'Update'){
			let logData = {
				"Form": this.state.dataMode == 'MDS' ? 'MDS' : 'Layout',
				"FormGuid": uld,
				"FormName": mdsDataName,
				"Status": 'Test',
				"Action": 'Form added',
				"Created": moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
			}
			this.auditLog(logData);
		}
	}
	
	mongoStoreNewMds=(data,mdsDataName)=>{
		
		let mongoApiUrl = config.mongoApiUrl;
		let url = mongoApiUrl+'store-mds-files';
		axios({
			method: 'POST',
			url: url,
			data: JSON.stringify(data),
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			let res = response.data;
			
			if(res == 'Inserted Successfully!'){
				$('#createBuild').modal('hide');
				this.getMdsSheets(this.state.selectedInstanceId);
				this.getMdsData(1);
				let user_id = this.state.userGuid;
				let sheetName = 'Temp-File-'+user_id;
				if(mdsDataName != sheetName){
					this.uploadMdsJsonMongoDb(mdsDataName);
				}
				alert('MDS File created successfully!');
			}else if(res == 'Already Exist!'){
				alert('MDSName Already Exist!');
			}
		}).catch(error => {
			console.log('error::', error);
		})
		
	}
	
	mongoStoreNewLayout=(data,mdsDataName)=>{
		
		let mongoApiUrl = config.mongoApiUrl;
		let url = mongoApiUrl+'store-layout-files';
		axios({
			method: 'POST',
			url: url,
			data: JSON.stringify(data),
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			let res = response.data;
			
			if(res == 'Inserted Successfully!'){
				$('#createBuild').modal('hide');
				this.getLayoutSheets(this.state.selectedInstanceId);
				this.getLayoutData();
				this.uploadLayoutJsonMongoDb(mdsDataName,'create');
				alert('Layout File created successfully!');
			}
		}).catch(error => {
			console.log('error::', error);
		})
		
	}
	
	mongoUpdateLayout=(data,mdsDataName)=>{
		
		let mongoApiUrl = config.mongoApiUrl;
		let url = mongoApiUrl+'update-layout';
		axios({
			method: 'POST',
			url: url,
			data: JSON.stringify(data),
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			let res = response.data;
			
			if(res == true){
				$('#createBuild').modal('hide');
				this.getLayoutSheets(this.state.selectedInstanceId);
				this.getLayoutData();
				this.uploadLayoutJsonMongoDb(mdsDataName,'update');
				alert('Layout File updated successfully!');
			}
		}).catch(error => {
			console.log('error::', error);
		})
		
	}
	
	addParentSets=(sheet,i) =>{

		$('.set-btn').removeClass('active');
		$('.set-'+i).addClass('active');
		
		let ApiUrl = config.mongoApiUrl;
		let url = ApiUrl+'mds-file/'+sheet;
		let data = [];
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			const dataSets = response.data.Fields;
			let fields = [];
			dataSets.map((row, i) => {
				if(row[60] != 'Y'){
					fields.push(row);
				}
			});
			this.setState({parentDataSets:fields});
		});
	}
	
	addNewField=(optionType,txt) =>{
		this.setState({	MDGroups:0});
		let allData = this.state.allData;
		let fieldPos = this.state.fieldPos;
		let fieldPrefix = this.state.fieldPrefix;
		let id = allData.length+1
		let ttevalId = fieldPrefix+'-'+id;
		let fieldID = '';
		let parentId = '';
		let position = id;
		let PosId = '';
		let guids = '';
		let guids_dn = ulid();
		let tagId = '';
		let mds_guids = '';
		
		let optionKName = '';
		let optionKeyName = '';
		
		if(optionType == 'hidden'){
			optionKName = 'Category,Sub-Categorry,Quantity,Materials,Size,Cost,Min time in hours,Max time in hours,Min time in days,Max time in days,SKU #,Resource requirements,Location';
			
			optionKName = optionKName.split(',');
			let optionArr = [];
			optionKName.map((val, i) => {
				let optguid = ulid();
				let optTxt = optguid+'|'+val;
				optionArr.push(optTxt);
			});
			
			optionKeyName = optionArr.join();
		}
		
		let currentDate = new Date().toLocaleString("en-US", {timeZone: "America/New_York"}).replace(',','');
		let newField = [ ttevalId,fieldID,parentId,'','',optionType,optionKeyName,'','','',position,'','','','Y','N',PosId,'','','','','','','','','','','','','','','','Y','N','',guids,'','N','',tagId,'','','','','','','','','V1','','','','','','','','','','','','N','','','','','','','','','','','','','','','','','','','','','','','','','','','','','','',mds_guids,'','','','','',currentDate,currentDate,'','','','','','','','','','','','','Y','','','','','',guids_dn,'','','','','','','','' ];
		
		allData.push(newField);

		if(fieldPos){
			allData = arrayMove(allData, allData.length-1, fieldPos);
		}
		this.setState({allData});
		let that = this;
		setTimeout(function(){
			if(fieldPos){
				that.updateData('pos');
			}else{
				that.updateData();
			}
		}, 2000);
	}
	
	addNewPreField=(value) =>{
		
		let miss = false;
		if(value[61] == '' || value[63] == ''){
			miss = true;
		}
		if(miss){
			alert('Save layout and create Static ID to field to add to Layout!');
			return false;
		}
		
		this.setState({	MDGroups:0})
		let fieldPos = this.state.fieldPos;
		let selectedSheet = this.state.selectedSheet;
        let user_id = this.state.userGuid;
		let sheetName = 'Temp-File-'+user_id;
        if(selectedSheet != '' && selectedSheet !== undefined){
			sheetName = selectedSheet;
		}
		let uld = ulid();
		let row = Object.assign([], value);
		let allData = this.state.allData;
		let exist = false;
		{allData.map((data,i)=>{
			if(data[130] == value[0] && data[131] == value[117]){
				exist = true;
			}
			
			
		})}
	
		if(exist){
			alert('The field already exist in the Default Layout!');
			return false;
		}
		
				
		let currentDate = new Date().toLocaleString("en-US", {timeZone: "America/New_York"}).replace(',','');
		row[129] = value[91];
		row[130] = value[0];
		row[131] = value[117];
		row[7] = '';
		row[8] = '';
		//row[39] = '';
		row[17] = 'Yes';
		row[71] = '';
		//row[91] = '';
		row[92] = '';
		row[93] = '';
		row[94] = '';
		row[95] = '';
		//row[117] = uld;
		row[97] = currentDate;
		row[98] = currentDate;
		row[59] = 1.01;
		row[60] = 'N';

		allData.push(row);

		if(fieldPos){
			allData = arrayMove(allData, allData.length-1, fieldPos);
		}
		this.setState({allData});
		let that = this;
		setTimeout(function(){
			if(fieldPos){
				that.updateData('pos');
			}else{
				that.updateData();
			}
		}, 1000);
	}
	
	addNewGroup=(fname,type,pos) =>{
		let parentdata = this.state.parentDataSets;
		let spreadsheetId = this.state.spreadsheetId;
		let selectedSheet = this.state.selectedSheet;
		let allData = this.state.allData;
		let fieldPos = this.state.fieldPos;
		let user_id = this.state.userGuid;
		let sheetName = 'Temp-File-'+user_id;
        if(selectedSheet != '' && selectedSheet !== undefined){
			sheetName = selectedSheet;
		}
		
		parentdata.sort(function(a, b) {
			return a[10] - b[10];
		});
		
		let newSets = [];
		let end = 0;
		for (var i = pos; i < parentdata.length; i++) {
			
			if(i > pos && (parentdata[i][5] == type || (type.toLowerCase() == 'child header 1' && parentdata[i][5].toLowerCase() == 'parent header') || (type.toLowerCase() == 'child header 2' && (parentdata[i][5].toLowerCase() == 'child header 1' || parentdata[i][5].toLowerCase() == 'parent header')) || (type.toLowerCase() == 'child header 3' && (parentdata[i][5].toLowerCase() == 'child header 2' || parentdata[i][5].toLowerCase() == 'child header 1' || parentdata[i][5].toLowerCase() == 'parent header'))) ){
				break;
			}
			
			/* if(type.toLowerCase() == 'boxbegin' && end > 0){
				break;
			}
			
			if(i > pos && (parentdata[i][5] == type || (type.toLowerCase() == 'boxbegin' && parentdata[i][5].toLowerCase() == 'boxend')) ){
				end = end+1;
			} */
			
			let exist = false;
			allData.map((data,j)=>{
				if(data[130] == parentdata[i][0]){
					exist = true;
				}
			})
			
			if(exist){
				break;
			}
			
			let miss = false;
			if(parentdata[i][61] == '' || parentdata[i][63] == ''){
				miss = true;
			}
			if(miss){
				alert('Save layout and create Static ID to field to add to Layout!');
				break;
			}
			
			let currentDate = new Date().toLocaleString("en-US", {timeZone: "America/New_York"}).replace(',','');
			parentdata[i][14] = 'Y';
			parentdata[i][17] = 'Yes';
			parentdata[i][129] = parentdata[i][91];
			parentdata[i][130] = parentdata[i][0];
			parentdata[i][131] = parentdata[i][117];
			parentdata[i][7] = '';
			parentdata[i][8] = '';
			//parentdata[i][39] = '';
			parentdata[i][71] = '';
			//parentdata[i][91] = '';
			parentdata[i][60] = 'N';
			parentdata[i][92] = '';
			parentdata[i][93] = '';
			parentdata[i][94] = '';
			parentdata[i][95] = '';
			parentdata[i][97] = currentDate;
			parentdata[i][98] = currentDate;
			//parentdata[i][58] = mdsSpreadsheetId;
			newSets.push(parentdata[i]);  
		}
		
		//this.setState({	MDGroups:newSets.length});
		let MDGroups = newSets.length
		if(newSets.length > 0){
			let length = allData.length+1
			this.setState({dataLength:length});
			allData = allData.concat(newSets);
			if(this.state.fieldPos && MDGroups > 0){
				let dataLenth = allData.length - MDGroups;
				for(let i=0; i < MDGroups; i++ ){
					allData = arrayMove(allData, dataLenth+i, parseInt(this.state.fieldPos)+parseInt(i));
				}
			}else if(this.state.fieldPos && MDGroups == 0){
				allData = arrayMove(allData, allData.length-1, this.state.fieldPos);
			}
			//console.log('allData->',allData);
			this.setState({allData});
			let that = this;
			if(!this.state.fieldPos){
				setTimeout(function(){
					that.updateData();
					$(".page-builder").animate({ scrollTop: $('.page-builder').prop("scrollHeight")}, 1000);
					$('.btn-undo-data').show();
				}, 3000);
			}else{
				$('.btn-undo-data').show();
			}
			
		}else{
			alert('The Group fields already exist in the Default Layout!');
		}

	}
	
	clearLastData=()=>{
		this.getLayoutData();
		$('.btn-undo-data').hide();	
	}
	
	preViewModeOn=()=>{
		this.builderOption(null,'mds_view');
	}
	
	preViewModeOnImprove=()=>{
		this.builderOption(null,'improve_view');
	}
	
	preViewModeOffImprove=()=>{
		this.builderOption(null,'improve');
	}
	
	preViewModeOff=()=>{
		this.builderOption(null,'builder');
	}
	
	builderOption=(event,value)=>{
		if((this.state.dataMode == 'MDS' || this.state.dataMode == 'Child') && this.state.allData.length > 0 && !value){
			
			if (window.confirm('Page will be cleared - Be sure to save your work.')){
				this.clearTempData();
			}else{
				this.setState({dataMode:this.state.dataMode});
				return false;
			}				
		}
		
		let val = '';
		if(value){
			val = value;
		}else{
			val = event.target.value;
			
			if(this.state.allData.length > 0){
				this.setState({allData:[]});
				//window.location.reload();
			}
		}

		this.setState({viewMode:val,showView:false,instanceManager:false,showTrackerTable:false,trackerStatusManager:false,taskManager:false,workFlow:false,workFlowDetails:false,workFlowManger:false,workFlowProgress:false,scheduledworkFlow:false,showMdsList:false,showMongoSection:false,showTestSection:false,showMongoMoveMdsSection:false,showMongoMdsSection:false,showTranslationManager:false,showLookDataManager:false,showSuggestManager:false,showMdsManageSection:false,showUserSection:false});
		$('#wrapperImp').hide();
		if(val == 'mds_view'){
			//$('.mds-view').show();
			this.setState({showView:true});
			$('#wrapper').show();
			$('.mds-manager').hide();
			/* let that = this;
			setTimeout(function(){
				//that.showBoxBegin(that.state.allData);
			}, 3000); */
			//this.getStatusData();
		}else if(val == 'builder'){
			$('#wrapper').show();
			$('.mds-manager').hide();
			$('.mds-view').hide();
			//this.getLayoutSheets(this.state.selectedInstanceId);
			//this.setState({allData:[]});
		}else if(val == 'user'){
			this.setState({showUserSection:true});
			$('#wrapper').hide();
			$('.mds-view').hide();
		}else if(val == 'move_mds'){
			//this.getMdsSheetsWithfields(this.state.selectedInstanceId);
			//this.getMdsSheets(this.state.selectedInstanceId);
			this.setState({showMongoMoveMdsSection:true});
			$('#wrapper').hide();
			$('.mds-view').hide();
		}else if(val == 'mds_mongo'){
			//this.getMdsSheetsWithfields(this.state.selectedInstanceId);
			//this.getMdsSheets(this.state.selectedInstanceId);
			this.setState({showMongoMdsSection:true});
			$('#wrapper').hide();
			$('.mds-view').hide();
		}else if(val == 'layout_mongo'){
			this.setState({showMongoSection:true});
			this.getLayoutSheets(this.state.selectedInstanceId);
			$('#wrapper').hide();
			$('.mds-view').hide();
		}else if(val == 'test_manager'){
			this.setState({showTestSection:true});
			this.getLayoutSheetsV2(this.state.selectedInstanceId);
			$('#wrapper').hide();
			$('.mds-view').hide();
		}else if(val == 'instance'){
			this.setState({instanceManager:true});
			$('#wrapper').hide();
			$('.mds-manager').hide();
			$('.mds-view').hide();
			//this.getDestination();
		}else if(val == 'improve'){
			$('#wrapper').hide();
			$('#wrapperImp').show();
			$('.sidebar').hide();
			$('.mds-manager').hide();
			$('.mds-view').hide();
			$("#select-view-option").val('improve').prop('selected', true);
			
		}else if(val == 'improve_view'){
			this.setState({showView:true});
			$('#wrapper').hide();
			$('#wrapperImp').show();
			$('.sidebar').hide();
			$('.mds-manager').hide();
			$('.mds-view').hide();
			//$("#select-view-option").val('improve').prop('selected', true);
		}else if(val == 'translation'){
			this.setState({showTranslationManager:true});
			$('#wrapper').hide();
			$('.mds-view').hide();
		}else if(val == 'look_data'){
			this.setState({showLookDataManager:true});
			$('#wrapper').hide();
			$('.mds-view').hide();
		}else if(val == 'suggested'){
			this.setState({showSuggestManager:true});
			$('#wrapper').hide();
			$('.mds-view').hide();
		}
		
		if(this.state.dataMode != 'Child' && this.state.dataMode != 'TestForm'){
			$(".load-select-child option:selected").prop("selected", false);
		}
		
		this.setState({delegateFilter:''});
	}
	
	filterMdsForms=(event)=>{
		let item = event.target.name;
		let searchQuery = event.target.value.toLowerCase();
		let mdsSheetNames = this.state.mdsSheets;
		if(searchQuery.length > 1){
			$("#loadSelectMds").children('option').hide();
			mdsSheetNames.map((sheet,i)=>{
				let sheetName = sheet.MDSName.toLowerCase();
				sheetName = sheetName.substring(0, 10);
				//if(sheetName.indexOf(searchQuery) > -1){
				if(sheetName.includes(searchQuery) || sheet.Mode.toLowerCase().includes(searchQuery) || sheet.Version == searchQuery){
					let sheetValue = sheet.MDSName.replaceAll(' ','-');
					sheetValue = sheet.MDSName.replaceAll('.','-');
					$("#loadSelectMds").children("option[value^=" + sheetValue + "]").show();
				}
			})
		}else{
			$("#loadSelectMds").children('option').show();
		}
	}

	getTrackMongo=()=>{
		let trackName = this.state.trackName;
		let mongoApiUrl = config.mongoApiUrl;
		let url = mongoApiUrl+'get-track';
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			//console.log('assignTracks::', response.data);
			this.setState({assignTracks: response.data});
		}).catch(error => {
			console.log('error::', error);
		})
		
	}
	
	addTrackMongo=()=>{
		let trackName = this.state.trackName;
		let mongoApiUrl = config.mongoApiUrl;
		let url = mongoApiUrl+'add-track';
		let data = {
			"trackName": trackName,
		}
		axios({
			method: 'POST',
			url: url,
			data: JSON.stringify(data),
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			//console.log('response::', response.data);
			$('.add-track-n').val('');
			this.getTrackMongo();
		}).catch(error => {
			console.log('error::', error);
		})
		
	}
	
	deleteTrack=(track)=>{
		let trackName = this.state.trackName;
		let mongoApiUrl = config.mongoApiUrl;
		let url = mongoApiUrl+'delete-track';
		let data = {
			"trackName": track,
		}
		axios({
			method: 'POST',
			url: url,
			data: JSON.stringify(data),
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			//console.log('response::', response.data);
			this.getTrackMongo();
		}).catch(error => {
			console.log('error::', error);
		})
		
	}
	
	calculationFields=()=>{
		
		let validationTypefilter = this.state.validationTypefilter;
		
		return (<div>
			<table className="table table-bordered">
			{this.state.allData.map((comment,i) =>{
				if((validationTypefilter && comment[48] == validationTypefilter) || (!validationTypefilter && (comment[48]== 'V3' || comment[48]== 'V4' || comment[48]== 'V5' || comment[48]== 'V6' || comment[48]== 'V7' || comment[48]== 'V8' || comment[48]== 'V12' || comment[48]== 'V13')) ){
					let calFieldsId = this.state.calFieldsId;
					let hasId = calFieldsId.get(comment[117]);
					
					return (<tr >
						<td><input name={comment[117]} type="checkbox" onChange={this.handleCalItem} checked={hasId ? 'checked' : ''} /></td>
						<td>{comment[0]}</td>
						<td>{comment[4]}</td>
						<td>{comment[48]}</td>
					</tr>)
				}
			}   
			)}
			</table>
		</div>);
	}
	
	handleCalItem = (e) => {
        const item = e.target.name;
        let isChecked = e.target.checked;
		let calFieldsId = this.state.calFieldsId;
		if(isChecked == true){
			calFieldsId.set(item, item);
		}else{
			calFieldsId.delete(item);
		}
		this.setState({calFieldsId:calFieldsId});
    }
	
	handleLaunchPadItem = (e) => {
        let item = e.target.name;
        let type = e.target.value;
		let isChecked = e.target.checked;
		if(type == 'rq'){
			let rqFields = this.state.requiredFields;
			if(isChecked == true){
				rqFields.set(item, item);
			}else{
				rqFields.delete(item);
			}
			this.setState({requiredFields:rqFields});
		}
		
		if(type == 'op'){
			let opields = this.state.optionalFields;
			if(isChecked == true){
				opields.set(item, item);
			}else{
				opields.delete(item);
			}
			//console.log('opields->',opields);
			this.setState({optionalFields:opields});
		}
    }
	
	handleCalItemWeight = (e) => {
		const item = e.target.value;
        this.setState({wcalFieldsId:item});
    }
	
	wcalculationFields=()=>{
		return (<div>
			<table className="table table-bordered">
			{this.state.allData.map((comment,i) =>{
				if(comment[5] == 'weighted'){
					let hasId = this.state.wcalFieldsId;
					return (<tr >
						<td><input name={comment[5]} value={comment[117]} type="Radio" onChange={this.handleCalItemWeight} checked={hasId == comment[117] ? 'checked' : ''} /></td>
						<td>{comment[0]}</td>
						<td>{comment[4]}</td>
					</tr>)
				}
			}   
			)}
			</table>
		</div>);
	}
	
	setAsGroup=(event)=>{
		let name = event.target.name;
		let res = event.target.value;
		let isChecked = event.target.checked;
		if(isChecked){
			this.setState({[event.target.name]:event.target.value});
		}else{
			this.setState({[event.target.name]:''});
		}
	}
	
	subQuestions = (id,value) => {
		this.getResponseValue(id,value);
	}
	
	getResponseValue=(Id,Value)=>{
		let kioskResponse = this.state.kioskResponse;
		let userClassResponse = this.state.userClassResponse;
		let delegateFilter = this.state.delegateFilter;
		let userResponseDate = this.state.userResponseDate;
		
		if(Value){
			let isValid = this.validationValue(Id, Value);
			let date = new Date().toLocaleString("en-US", {timeZone: "America/New_York"}).replace(',','');
			if(isValid){
				kioskResponse.set(Id, Value);
				userResponseDate.set(Id, date);
				if(delegateFilter){
					userClassResponse.set(Id, delegateFilter);
				}else{
					userClassResponse.set(Id, 'CPO');
				}
			}else{
				//$('.res_'+Id).val('');
				kioskResponse.delete(Id);       
				userClassResponse.delete(Id);       
				userResponseDate.delete(Id);       
			}
		}else{  
            kioskResponse.delete(Id);       
            userClassResponse.delete(Id);       
            userResponseDate.delete(Id);       
        }
        this.setState({kioskResponse:kioskResponse});
		this.calculationResponse(Id, Value);
	}
	
	validationValue=(Id, value)=>{
		let isValid = true;
		this.state.allData.map((rowDatas,i)=>{
			
			let qType = rowDatas[5].toLowerCase();
			if((rowDatas[0] == Id) && (qType == 'q6' || qType == 'q7' || qType == 'q8' || qType == 'q9' || qType == 'q10' || qType == 'timer')){
				let min = rowDatas[50];
				let max = rowDatas[51];
				let ex = '';
				let found = '';
				if(rowDatas[48]){
					switch (rowDatas[48].toLowerCase()) {
						/* case 'v1' :
							ex = /^[ A-Za-z0-9_@./&+-,.':-]*$/;
							if(ex.test(value)==true){
								isValid = true;
								$('.res_'+Id).removeClass('error');
							}else{
								isValid = false;
								//$('.res_'+Id).val('');
								$('.res_'+Id).addClass('error');
								alert('No special characters allowed, only alphanumeric.');
							}
							break; */
						case 'v2' :
							ex = /^[ A-Za-z_,. ]*$/;
							if(ex.test(value)==true){
								isValid = true;
								$('.res_'+Id).removeClass('error');
							}else{
								isValid = false;
								//$('.res_'+Id).val('');
								$('.res_'+Id).addClass('error');
								alert('No special characters or numbers allowed, only text.');
							}
							break;
						case 'v3' :
						    ex = /^[-+]?[0-9]+\.[0-9]+$/;
							found = value.match( ex );
							
							if(Number(value) >= Number(min) && Number(value) <= Number(max) && !found){
								isValid = true;
								$('.res_'+Id).removeClass('error');
							}else{
								isValid = false;
								//$('.res_'+Id).val('');
								$('.res_'+Id).addClass('error');
								alert('The value should be greater than or equal to '+min+' and less than or equal to '+max+' and no negatives & no decimals.');
							}
							break;
						case 'v4' :
							ex = /^[-+]?[1-9]+\.[1-9]+$/;
							found = value.match( ex );
							
							if(Number(value) >= Number(min) && Number(value) <= Number(max) && !found){
								isValid = true;
								$('.res_'+Id).removeClass('error');
							}else{
								isValid = false;
								//$('.res_'+Id).val('');
								$('.res_'+Id).addClass('error');
								alert('The value should be greater than or equal to '+min+' and less than or equal to '+max+' and no negatives & no decimals.');
							}
							break;
						case 'v5' :
							ex = /^\d{0,11}(\.\d{0,1})?$/;
							if(Number(value) >= Number(min) && Number(value) <= Number(max) && ex.test(Number(value))==true){
								isValid = true;
								$('.res_'+Id).removeClass('error');
							}else{
								//$('.res_'+Id).val('');
								$('.res_'+Id).addClass('error');
								isValid = false;
								alert('The value should be greater than or equal to '+min+' and less than or equal to '+max+ ' and only 1 decimal place.');
							}
							break;
						case 'v6' :
							ex = /^\d{0,9}(\.\d{0,2})?$/;
							if(Number(value) >= Number(min) && Number(value) <= Number(max) && ex.test(Number(value))==true){
								isValid = true;
								$('.res_'+Id).removeClass('error');
							}else{
								isValid = false;
								//$('.res_'+Id).val('');
								$('.res_'+Id).addClass('error');
								alert('The value should be greater than or equal to '+min+' and less than or equal to '+max+ ' and only 2 decimal places.');
							}
							break;
						case 'v7' :
							let newVal = value.replace('%','')
							if(Number(newVal) >= Number(0) && Number(newVal) <= Number(100)){
								isValid = true;
								$('.res_'+Id).removeClass('error');
							}else{
								isValid = false;
								//$('.res_'+Id).val('');
								$('.res_'+Id).addClass('error');
								alert('The value should be greater than or equal 0% and less than or equal 100%.');
							}
							break;
						case 'v8' :
							ex = /[-]?[0-9]+[,.]?[0-9]*([\/][0-9]+[,.]?[0-9]*)*/;
							if(ex.test(value)==true){
								isValid = true;
								$('.res_'+Id).removeClass('error');
							}else{
								isValid = false;
								//$('.res_'+Id).val('');
								$('.res_'+Id).addClass('error');
								alert('Please enter valid value.(e.g 1, 3/4, 7, 1/2.5)');
							}
							break;
						case 'v9' :
						
							var date = new Date().toLocaleString("en-US", {timeZone: "America/New_York"}).split(',')[0];
							var dateParts = value.split("/");
							var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
							
							if(dateObject <= new Date(date)){
								isValid = true;
								$('.res_'+Id).removeClass('error');
							}else{
								isValid = false;
								alert('The Date should be less than or equal the current date.');
								setTimeout(function(){
									//$('.res_'+Id).val('');
									$('.res_'+Id).addClass('error'); 
								}, 2000);
							}
							break;
						case 'v10' :
							var date = new Date().toLocaleString("en-US", {timeZone: "America/New_York"}).split(',')[0];
							var dateParts = value.split("/");
							//var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
							var dateObject2 = dateParts[1]+'/'+dateParts[0]+'/'+dateParts[2];
							
							if(dateObject2 == date){
								isValid = true;
								$('.res_'+Id).removeClass('error');
							}else{
								isValid = false;
								alert('The Date should be current date.');
								setTimeout(function(){
									//$('.res_'+Id).val('');
									$('.res_'+Id).addClass('error'); 
								}, 2000);
							}
							break;
						case 'v11' :
							var date = new Date().toLocaleString("en-US", {timeZone: "America/New_York"}).split(',')[0];
							var dateParts = value.split("/");
							var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
							
							if(dateObject >= new Date(date)){
								isValid = true;
								$('.res_'+Id).removeClass('error');
							}else{
								isValid = false;
								alert('The Date should be greater than or equal to current date.');
								setTimeout(function(){
									//$('.res_'+Id).val('');
									$('.res_'+Id).addClass('error'); 
								}, 2000);
							}
							break;
						case 'v12' :
							let str1 =  value.split(':');
							let str2 =  min.split(':');
							let str3 =  max.split(':');
							str1 = parseFloat(str1[0] * 3600 + str1[1] * 60 + str1[2]);
							str2 = parseFloat(str2[0] * 3600 + str2[1] * 60 + str2[2]);
							str3 = parseFloat(str3[0] * 3600 + str3[1] * 60 + str3[2]);
							
							if(Number(str1) >= Number(str2) && Number(str1) <= Number(str3)){
								isValid = true;
								$('.res_'+Id).removeClass('error');
							}else{
								isValid = false;
								//$('.res_'+Id).val('');
								$('.res_'+Id).addClass('error');
								alert('The time should be greater than or equal '+min+' and less than or equal '+max+'. Please start again.');
							}
							break;
						case 'v13' :
							let strr1 =  value.split(':');
							let strr2 =  min.split(':');
							let strr3 =  max.split(':');
							strr1 = parseFloat(strr1[0] * 3600 + strr1[1] * 60);
							strr2 = parseFloat(strr2[0] * 3600 + strr2[1] * 60);
							strr3 = parseFloat(strr3[0] * 3600 + strr3[1] * 60);
							
							if(Number(strr1) >= Number(strr2) && Number(strr1) <= Number(strr3)){
								isValid = true;
								$('.res_'+Id).removeClass('error');
							}else{
								isValid = false;
								//$('.res_'+Id).val('');
								$('.res_'+Id).addClass('error');
								alert('The time should be greater than or equal '+min+' and less than or equal '+max+'. Please start again.');
							}
							break;
						case 'v14' :
							//ex = /^\d{0,9}(\.\d{0,2})?$/;
							if(Number(value) < 0 && Number(value) >= Number(min) && Number(value) <= Number(max)){
								isValid = true;
								$('.res_'+Id).removeClass('error');
							}else{
								isValid = false;
								$('.res_'+Id).val('');
								$('.res_'+Id).addClass('error');
								alert('The value should be Negative and greater than or equal to '+min+' and less than or equal to '+max+ ' and no Zero.');
							}
							break;
							
						case 'v15' :
							if(Number(value) < 0.1 && Number(value) >= Number(min) && Number(value) <= Number(max)){
								isValid = true;
								$('.res_'+Id).removeClass('error');
							}else{
								isValid = false;
								$('.res_'+Id).val('');
								$('.res_'+Id).addClass('error');
								alert('The value should be Negative & Zero and greater than or equal to '+min+' and less than or equal to '+max);
							}
							break;
						case 'v16' :
							ex = /^-?\d+(\.\d{0,1})?$/;
							if(Number(value) < 0.1 && Number(value) >= Number(min) && Number(value) <= Number(max) && ex.test(Number(value))==true){
								isValid = true;
								$('.res_'+Id).removeClass('error');
							}else{
								//$('.res_'+Id).val('');
								$('.res_'+Id).addClass('error');
								isValid = false;
								alert('The value should be Negative & Zero and greater than or equal to '+min+' and less than or equal to '+max+ ' and only 1 decimal place.');
							}
							break;
						case 'v17' :
							ex = /^-?\d+(\.\d{1,2})?$/;
							if(Number(value) < 0.1 && Number(value) >= Number(min) && Number(value) <= Number(max) && ex.test(Number(value))==true){
								isValid = true;
								$('.res_'+Id).removeClass('error');
							}else{
								//$('.res_'+Id).val('');
								$('.res_'+Id).addClass('error');
								isValid = false;
								alert('The value should be Negative & Zero and greater than or equal to '+min+' and less than or equal to '+max+ ' and only 2 decimal place.');
							}
							break;
						case 'v18' :
							let nal = value.replace('%','')
							if(Number(nal) >= Number(0) && Number(nal) <= Number(100)){
								isValid = true;
								$('.res_'+Id).removeClass('error');
							}else{
								isValid = false;
								//$('.res_'+Id).val('');
								$('.res_'+Id).addClass('error');
								alert('The value should be Negative and greater than or equal -100% and less than or equal 0%.');
							}
							break;
						case 'v19' :
							ex = /^-\d+(\.\d+)?\/\d+(\.\d+)?$/;
							if(ex.test(value)==true){
								isValid = true;
								$('.res_'+Id).removeClass('error');
							}else{
								isValid = false;
								//$('.res_'+Id).val('');
								$('.res_'+Id).addClass('error');
								alert('Please enter valid value.(e.g -3/4, -7/5, -1/2.5)');
							}
							break;
						case 'v20' :
							if(Number(value) >= Number(min) && Number(value) <= Number(max)){
								isValid = true;
								$('.res_'+Id).removeClass('error');
							}else{
								isValid = false;
								$('.res_'+Id).val('');
								$('.res_'+Id).addClass('error');
								alert('The value should be greater than or equal to '+min+' and less than or equal to '+max);
							}
							break;
						case 'v21' :
							ex = /^[-+]?[1-9]+\.[1-9]+$/;
							found = value.match( ex );
							
							if(Number(value) >= Number(min) && Number(value) <= Number(max) && !found){
								isValid = true;
								$('.res_'+Id).removeClass('error');
							}else{
								isValid = false;
								//$('.res_'+Id).val('');
								$('.res_'+Id).addClass('error');
								alert('The value should be greater than or equal to '+min+' and less than or equal to '+max+' and no Zero.');
							}
							break;
						case 'v22' :
							ex = /^[-+]?\d+\.\d{1}$/;
							if(Number(value) >= Number(min) && Number(value) <= Number(max) && ex.test(Number(value))==true){
								isValid = true;
								$('.res_'+Id).removeClass('error');
							}else{
								//$('.res_'+Id).val('');
								$('.res_'+Id).addClass('error');
								isValid = false;
								alert('The value should be greater than or equal to '+min+' and less than or equal to '+max+ ' and only 1 decimal place.');
							}
							break;
						case 'v23' :
							ex = /^[-+]?(?:0|[1-9]\d*)\.\d{2}$/;
							if(Number(value) >= Number(min) && Number(value) <= Number(max) && ex.test(Number(value))==true){
								isValid = true;
								$('.res_'+Id).removeClass('error');
							}else{
								//$('.res_'+Id).val('');
								$('.res_'+Id).addClass('error');
								isValid = false;
								alert('The value should be greater than or equal to '+min+' and less than or equal to '+max+ ' and only 2 decimal place.');
							}
							break;
						case 'v24' :
							let nalb = value.replace('%','')
							if(Number(nalb) >= Number(-100) && Number(nalb) <= Number(100)){
								isValid = true;
								$('.res_'+Id).removeClass('error');
							}else{
								isValid = false;
								//$('.res_'+Id).val('');
								$('.res_'+Id).addClass('error');
								alert('The value should be greater than or equal -100% and less than or equal 100%.');
							}
							break;
						case 'v25' :
							ex = /^[-+]?[1-9]\d*\/[1-9]\d*$/;
							if(ex.test(value)==true){
								isValid = true;
								$('.res_'+Id).removeClass('error');
							}else{
								isValid = false;
								//$('.res_'+Id).val('');
								$('.res_'+Id).addClass('error');
								alert('Please enter valid value.(e.g -3/4, -7/5, -1/2.5)');
							}
							break;
							
						default:
						isValid = true;
					}
				}				
			}
        })
		
		return isValid;
	}
	
	calculationResponse =(Id, value)=>{
		
		this.state.allData.map((rowDatas,i)=>{
			if(rowDatas[5] == 'calculation' && rowDatas[14] == 'Y'){
				let calType = rowDatas[113];
				if(rowDatas[114]){
					let fields = rowDatas[114].split(',');
					let kioskResponse = this.state.kioskResponse;
					let fieldsRes = [];
					let timer = false;
					fields.map((field,j)=>{
						let ID = '';
						this.state.allData.map((row,i)=>{
							if(row[117] == field){
								ID = row[0]
							}
						})
						
						let res = kioskResponse.get(ID);
						
						if(res){
							if(res.indexOf(':') != -1){
								timer = true;
								let str1 =  res.split(':');
								res = parseFloat((+str1[0]) * 60 * 60 + (+str1[1]) * 60 + (+str1[2]));
								fieldsRes.push(Number(res));
							}else{
								fieldsRes.push(Number(res));
							}
						}
					});
					var response = '';
					if(fieldsRes.length > 0){
						//switch (calType.toLowerCase()) {
						switch (calType) {
							
							case 'Sum' :
								response = fieldsRes.reduce(function(a, b){
									return a + b;
								}, 0);
								break;
							case 'Subtract' :
								if(fieldsRes.length > 0){
									response = fieldsRes.reduce(myFunc)
									function myFunc(total, num) {
									  return total - num;
									}
								}
								break;
							case 'Average' :
								let average = fieldsRes => fieldsRes.reduce((a,b) => a + b, 0) / fieldsRes.length;
								response = average( fieldsRes );
								break;
							
								
							case 'HighestNumber' :
								response = Math.max.apply(Math, fieldsRes);
								break;
							case 'LowestNumber' :
								response = Math.min.apply(Math, fieldsRes);
								break;
							case 'ShortestTime' :
								response = Math.min.apply(Math, fieldsRes);
								break;
							case 'LongestTime' :
								response = Math.max.apply(Math, fieldsRes);
								break;
							default:
							response = 0;
						}
						
					}
					
					if(timer){
						let totalSeconds = response;
						let hours = Math.floor(totalSeconds / 3600);
						totalSeconds %= 3600;
						let minutes = Math.floor(totalSeconds / 60);
						let seconds = totalSeconds % 60;
						
						minutes = String(minutes).padStart(2, "0");
						hours = String(hours).padStart(2, "0");
						seconds = String(seconds).padStart(2, "0");
						
						let dec = (seconds - Math.floor(seconds)) !== 0;
						
						if(dec){	
							seconds = parseFloat(seconds).toFixed(1);
						}
						
						response = hours + ":" + minutes + ":" + seconds;
						
					}else{
						let decimal = (response - Math.floor(response)) !== 0;
						if(decimal){	
							response = response.toFixed(2);
						}
					}
					
					let userClassResponse = this.state.userClassResponse;
					if(response){
						$('.cal-res-'+rowDatas[0]).text( response );
						kioskResponse.set(rowDatas[0], response);
						userClassResponse.set(rowDatas[0], this.state.kioskUsers);
					}else{  
						kioskResponse.delete(rowDatas[0]);    
						userClassResponse.delete(rowDatas[0]);    
					}
					//console.log(kioskResponse);
					this.setState({kioskResponse:kioskResponse});
					this.setState({userClassResponse:userClassResponse});
				}

			}
			
		})
	}
	
	wCalculationResponse =(Id, value)=>{
		
		this.state.allData.map((rowDatas,i)=>{
			if(rowDatas[5] == 'wcalculation' && rowDatas[14] == 'Y'){
				let calType = rowDatas[113];
				if(rowDatas[114]){
					let field = rowDatas[114];
					var allCheckbox = '';
					this.state.allData.map((data,i)=>{
						if(field == data[0]){
							var options = data[6];
					
							if(options){    
								var str = options.split('_');
								allCheckbox = str[0].split(',');
							}
						}
						
					})
					
					
					let kioskResponse = this.state.kioskResponse;
					let fieldsRes = [];
					
					let res = kioskResponse.get(field);
					if(res){
						if(res.indexOf(',') != -1){
							res = res.split(',');
							res.map((val,i)=>{
								val = val.split(':');
								fieldsRes.push(Number(val[1]));
							})
							
						}else{
							
							let val = res.split(':');
							fieldsRes.push(Number(val[1]));
						}
					}
					
					var response = '';
					if(fieldsRes.length > 0){
						switch (calType.toLowerCase()) {
							
							case 'wsum' :
								response = fieldsRes.reduce(function(a, b){
									return a + b;
								}, 0);
								break;
							case 'wcount' :
								response = fieldsRes.length;
								break;
							case 'wavg' :
								let average = fieldsRes => fieldsRes.reduce((a,b) => a + b, 0) / fieldsRes.length;
								response = average( fieldsRes );
								let decimal = (response - Math.floor(response)) !== 0;
								if(decimal){	
									response = response.toFixed(2);
								}
								break;
							
							case 'wrcount' :
								response = fieldsRes.length+'/'+allCheckbox.length;
								break;
							
							default:
							response = 0;
						}
						
					}
					
					let userClassResponse = this.state.userClassResponse;
					if(response){
						$('.cal-res-'+rowDatas[0]).text( response );
						kioskResponse.set(rowDatas[0], response);
						userClassResponse.set(rowDatas[0], this.state.kioskUsers);
					}else{  
						kioskResponse.delete(rowDatas[0]);    
						userClassResponse.delete(rowDatas[0]);    
					}
					//console.log(kioskResponse);
					this.setState({kioskResponse:kioskResponse});
					this.setState({userClassResponse:userClassResponse});
				}

			}
			
		})
	}
	
	idOf(i){
        return (i >= 26 ? this.idOf((i / 26 >> 0) - 1) : '') +  'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[i % 26 >> 0];
    }
	
	postMergeEdit=(Id,Value)=>{
		let allData = this.state.allData;
		let updateVal = 'Yes';
		if(Value == 'Yes'){
			updateVal = 'No';
		}
		allData.map((rowDatas, i) => {
			if(rowDatas[0] == Id){
				rowDatas[17] = updateVal;
			}
		});
		this.setState({allData});
	}
	
	allPostMergeEdit=(Value)=>{
		let allData = this.state.allData;
		let updateVal = 'Yes';
		if(Value == 'Yes'){
			updateVal = 'No';
		}
		allData.map((rowDatas, i) => {
			//if(rowDatas[0] == Id){
				rowDatas[17] = updateVal;
			//}
		});
		this.setState({allData,mergeEdit:updateVal});
	}
	
	storeFormReviewData=(fieldGuid)=>{
		let LayoutGuid = this.state.selectedLayoutGuid;
		let reviewStatus = this.state['reviewStatus-'+fieldGuid];
		let reVisibleTest = this.state.reVisibleTest;
		let reOutputText = this.state.reOutputText;
		let reTags = this.state.reTags;
		let reFieldResponse = this.state.reFieldResponse;
		let reviewerComments = this.state.reviewerComments;
		let reviewAppropriate = this.state.reviewAppropriate;
		let reviewBetter = this.state.reviewBetter;
		let reviewPresented = this.state.reviewPresented;
		
		let userReviewData = this.state.userReviewData;
		let reviewSameForm = this.state.reviewSameForm;
		
		
		let reviewData = {
			"reviewStatus": reviewStatus,
			"reVisibleTest": reVisibleTest,
			"reOutputText": reOutputText,
			"reTags": reTags,
			"reFieldResponse": reFieldResponse,
			"reviewerComments": reviewerComments,
			"reviewAppropriate": reviewAppropriate,
			"reviewBetter": reviewBetter,
			"reviewPresented": reviewPresented,
		}
		if(reviewStatus == 'acceptable'){
			reviewData = {
				"reviewStatus": reviewStatus,
			}
		}
		let fieldReview = [];
		if(reviewStatus != ''){
			userReviewData.set(fieldGuid, reviewData);
			let that = this;
			setTimeout(function(){
				let currentdate = new Date().toLocaleString("en-US", {timeZone: "America/New_York"}).replace(',','');
				let allData = that.state.allData;
				let hasReview = false;
				allData.map((rowDatas,i)=>{
					let review = userReviewData.get(rowDatas[0]);
					if(review){
						hasReview = true;
					}
					if(review){
						let rData = {
							"FieldGUID": rowDatas[117],
							"FieldName": rowDatas[0],
							"FieldType": rowDatas[5],
							"VisibleText": rowDatas[4],
							"OutputText": rowDatas[9],
							"Status": 'Active',
							"Review": review,
						}
						fieldReview.push(rData);
					}
					
				})
				if(hasReview){
					let reviewJson ={
						"LayoutGuid": that.state.selectedLayoutGuid,
						"reviewSameForm": that.state.reviewSameForm,
						"LayoutName": that.state.LayoutName,
						"UserGuid": that.state.userGuid,
						"UserName": that.state.CreatedBy,
						"SaveTime": moment(currentdate).format('YYYY-MM-DD HH:mm:ss'),
						'Fields': fieldReview,
					}
					
					that.storeFormReview(reviewJson);
					
				}
			}, 2000);

			this.setState({reviewStatus:'',reVisibleTest:'',reOutputText:'',reTags:'',reviewerComments:'',reviewAppropriate:false,reviewBetter:false,reviewPresented:false});		
		}
	}
	
	handleSubmitSave=(msg)=>{
		let responseArray = this.state.responseArray;
		this.setState({responseArray:[]});			
        let uld = ulid();
        let kioskResponse = this.state.kioskResponse;
		
        let userClassResponse = this.state.userClassResponse;
        let userResponseDate = this.state.userResponseDate;
        let userReviewData = this.state.userReviewData;
        let PatientId = this.state.PatientId;
        let PatientName = this.state.PatientName;
        let userGuid = this.state.userGuid;
        let userName = this.state.CreatedBy;
        let formRating = this.state.formRating;
        let formDescription = this.state.formDescription;

        let required = 0;
        
		let allData = this.state.allData;
		if(!PatientId){
			alert('Please select the Patient first!');
			return false;
		}
		//console.log('allData->',allData);
		let layoutGuid = allData[0][91];
		let formName = allData[0][118];
		let dates = [];
		let fields = [];
		let fieldReview = [];
		let hasReview = false;
        allData.map((rowDatas,i)=>{
            $('#'+rowDatas[0]).removeClass("error");
            let res = kioskResponse.get(rowDatas[0]);
            let review = userReviewData.get(rowDatas[0]);
			if(review){
				hasReview = true;
			}
            if(rowDatas[14] == 'Y' && rowDatas[15] == 'Y' && typeof res == "undefined"){
                required = 1;
                $('#'+rowDatas[0]).addClass("error");
                
            }
			let urdate = userResponseDate.get(rowDatas[0]);
			let fieldData = {
				"FieldGUID": rowDatas[117],
				"FieldName": rowDatas[0],
				"FieldType": rowDatas[5],
				"VisibleText": rowDatas[4],
				"OutputText": rowDatas[9],
				"Response": res ? res : '',
				"ResponseTime": urdate ? urdate : '',
				"Review": review ? review : '',
			}
			
			//if(res){
				fields.push(fieldData);
			//}
			
			if(urdate){
				dates.push(new Date(urdate));
			}
			
			if(review){
				let rData = {
					"FieldGUID": rowDatas[117],
					"FieldName": rowDatas[0],
					"FieldType": rowDatas[5],
					"VisibleText": rowDatas[4],
					"OutputText": rowDatas[9],
					"Status": 'Active',
					"Review": review,
				}
				
				fieldReview.push(rData);
			}
			
        })
        //console.log('dates->',dates);
        if(required > 0){
            alert('Please fill answer all required questions');
			let nav = $('.error');
			if(nav.length){
				$('html, body').animate({
					scrollTop: $('.error').offset().top - 50
				}, 2000);
			}
            return false;
        }
		let currentdate = new Date().toLocaleString("en-US", {timeZone: "America/New_York"}).replace(',','');
		let minimumDate = new Date(Math.min.apply(null, dates));
		let startedDate = new Date(minimumDate).toLocaleString("en-US").replace(',','');
		//console.log('startedDate->',startedDate);
		
		let responseJson ={
			"ResponseID": uld,
			"UserGuid": userGuid,
			"UserName": userName,
			"LayoutGuid": layoutGuid,
			"LayoutName": this.state.LayoutName,
			"PatientID": PatientId,
			"PatientName": PatientName,
			"StartTime": moment(startedDate).format('YYYY-MM-DD HH:mm:ss'),
			"EndTime": moment(currentdate).format('YYYY-MM-DD HH:mm:ss'),
			'StarScore': formRating,
			'Feedback': formDescription,
			//'hasReview': hasReview,
			'Fields': fields,
		}
		//this.notesTemplateModal();
		this.storeFormResponse(responseJson);
		//console.log('responseJson->',responseJson);
		
		if(hasReview){
			let reviewJson ={
				"LayoutGuid": layoutGuid,
				"reviewSameForm": this.state.reviewSameForm,
				"LayoutName": this.state.LayoutName,
				"UserGuid": userGuid,
				"UserName": userName,
				"SaveTime": moment(currentdate).format('YYYY-MM-DD HH:mm:ss'),
				'Fields': fieldReview,
			}
			
			this.storeFormReview(reviewJson);
			let that = this;
			setTimeout(function(){
				that.setState({reviewSameForm:ulid()});
			}, 2000);
		}
		
    }
	
	storeFormResponse(responseJson){
		let mongoApiUrl = config.mongoApiUrl;
		let url = mongoApiUrl+'store-response';
		let role = localStorage.getItem('role');
		axios({
			method: 'POST',
			url: url,
			data: JSON.stringify(responseJson),
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			let responseArray = this.state.responseArray;
			this.setState({responseArray:responseJson});	
			if(role == 'Administrator' || role == 'NotesLetters'){
				this.notesTemplateModal();
			}
			
			this.emptyState();
			this.setState({allData:[],sheetData:[], formRating:'',formDescription:'',responseSaved:true});
			this.getLayoutData();

		}).catch(error => {
			console.log('error::', error);
		})
	}
	
	storeFormReview(reviewJson){
		let mongoApiUrl = config.mongoApiUrl;
		let url = mongoApiUrl+'store-review';
		axios({
			method: 'POST',
			url: url,
			data: JSON.stringify(reviewJson),
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {

		}).catch(error => {
			console.log('error::', error);
		})
	}
	
	getNotesTemplateUrl(){
		let responseArray = this.state.responseArray;
		
		let ApiUrl = config.mongoApiUrl;
		let url = ApiUrl+'template-data-v2/'+responseArray.LayoutGuid;
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
            const formData = response.data;
			
			let data ={
			   "userGuid": responseArray.UserGuid,
			   "userName": responseArray.UserName,
			   "formName": responseArray.LayoutName,
			   "layoutData": formData,
			   "responseData": responseArray,
			}
			
			this.state.patients.map(function(val,i) {
				if(val.PatientID == responseArray.PatientID){
					data['patientData'] = val;
				}
			})
			
			let url = 'https://poc1.solutionsaas.live/api/form-data/get-link';
			axios({
				method: 'POST',
				url: url,
				data: JSON.stringify(data),
				headers: {
					'x-api-key': '6f6fbe91-b521-4fac-bdfe-42c114f50c52',
					'Content-Type': 'application/json',
				}
			})
			.then(response => {
				$('#notesTemplate').modal('hide');
				window.open(response.data);
				
			}).catch(error => {
				console.log('error::', error);
			})

		}).catch(error => {
			console.log('error::', error);
		})
	}
	
	notesTemplateModal(){
		$('#notesTemplate').modal('show');
	}
	
	filterFieldSet=(event)=>{
		let item = event.target.name;
		let value = event.target.value.toLowerCase();
		let childSheetNames = this.state.childSheetNames;
		
		if(value.length > 1){
			$("#loadFeildSet").children('option').hide();
			childSheetNames.map((sheet,i)=>{
				let sheetName = sheet.name.toLowerCase();
				sheetName = sheetName.substring(0, 10);
				
				if(sheetName.indexOf(value) > -1){
					let sheetValue = sheet.name.replaceAll(' ','-');
					$("#loadFeildSet").children("option[value^=" + sheetValue + "]").show();
				}
			})
		}else{
			$("#loadFeildSet").children('option').show();
		}
	}
	
	selectPatient=(event)=>{
		let item = event.target.name;
		let value = event.target.value.toLowerCase();
		let patient = $("#PatientBox option:selected").text();
		this.setState({[item]:value, PatientName:patient});
	}
	
	filterLayout=(event)=>{
		let item = event.target.name;
		let value = event.target.value.toLowerCase();
		let layoutSheetNames = this.state.layoutSheetNames;
		
		if(value.length > 1){
			$("#loadLayout").children('option').hide();
			layoutSheetNames.map((sheet,i)=>{
				let sheetName = sheet.name.toLowerCase();
				sheetName = sheetName.substring(0, 10);
				
				if(sheetName.indexOf(value) > -1){
					//console.log('sheetName->',sheetName);
					let sheetValue = sheet.name.replaceAll(' ','-');
					$("#loadLayout").children("option[value^=" + sheetValue + "]").show();
				}
			})
		}else{
			$("#loadLayout").children('option').show();
		}
	}
	
	filterLayoutType=(event)=>{
		let name = event.target.name;
		let value = event.target.value;
		this.setState({[name]:value});
		let childSheets = this.state.childSheets;
		let layoutType = this.state.layoutType;
		let layoutDeviceType = this.state.layoutDeviceType;
		let layoutVisitType = this.state.layoutVisitType;
		
		if(name == 'layoutType'){
			layoutType = value;
		}else if(name == 'layoutDeviceType'){
			layoutDeviceType = value;
		}else if(name == 'layoutVisitType'){
			layoutVisitType = value;
		}
		
		if(layoutType || layoutDeviceType || layoutVisitType){
			$("#loadFeildSet").children('option').hide();
			childSheets.map((sheet,i)=>{
				let Types = sheet.Types;
				let dTypes = sheet.DeviceTypes;
				let vTypes = sheet.VisitTypes;
				
				if(layoutType && layoutDeviceType && layoutVisitType){
					if(Types.indexOf(layoutType) != -1 && dTypes.indexOf(layoutDeviceType) != -1 && vTypes.indexOf(layoutVisitType) != -1){
						$("#loadFeildSet").children("option[value^=" + sheet.LayoutName + "]").show();
					}
				}
				
				if(layoutType && layoutDeviceType && !layoutVisitType){
					if(Types.indexOf(layoutType) != -1 && dTypes.indexOf(layoutDeviceType) != -1){
						$("#loadFeildSet").children("option[value^=" + sheet.LayoutName + "]").show();
					}
				}
				
				if(layoutType && !layoutDeviceType && layoutVisitType){
					if(Types.indexOf(layoutType) != -1 && vTypes.indexOf(layoutVisitType) != -1){
						$("#loadFeildSet").children("option[value^=" + sheet.LayoutName + "]").show();
					}
				}
				
				if(!layoutType && layoutDeviceType && layoutVisitType){
					if(dTypes.indexOf(layoutDeviceType) != -1 && vTypes.indexOf(layoutVisitType) != -1){
						$("#loadFeildSet").children("option[value^=" + sheet.LayoutName + "]").show();
					}
				}
				
				if(layoutType && !layoutDeviceType && !layoutVisitType){
					if(Types.indexOf(layoutType) != -1 ){
						$("#loadFeildSet").children("option[value^=" + sheet.LayoutName + "]").show();
					}
				}
				
				if(!layoutType && layoutDeviceType && !layoutVisitType){
					if(dTypes.indexOf(layoutDeviceType) != -1){
						$("#loadFeildSet").children("option[value^=" + sheet.LayoutName + "]").show();
					}
				}
				
				if(!layoutType && !layoutDeviceType && layoutVisitType){
					if(vTypes.indexOf(layoutVisitType) != -1){
						$("#loadFeildSet").children("option[value^=" + sheet.LayoutName + "]").show();
					}
				}
			})
			
		}else{
			$("#loadFeildSet").children('option').show();
		}
	}
	
	setDelegateFilter=(event)=>{
		let val = event.target.value;
		$('.custom-TestForm').css('backgroundColor','#ffffff');
		if(val == 'PhT'){
            $('.custom-TestForm').css('backgroundColor','#FFCCE5');
        }else if(val == 'CPO'){
            $('.custom-TestForm').css('backgroundColor','#FFFFFF');
        }else if(val == 'Int' || val == 'Res' || val == 'PrA' || val == 'PA' ){
            $('.custom-TestForm').css('backgroundColor','#B2FF66');
        }else if(val == 'PhA' || val == 'PmD'){
             $('.custom-TestForm').css('backgroundColor','#DCDCDC');
        }else if(val == 'Pat'){
             $('.custom-TestForm').css('backgroundColor','#ccf5ff');
        }else if(val == 'CC'){
            $('.custom-TestForm').css('backgroundColor','#FFFF99');
        }
		
		this.setState({delegateFilter:val});
	}
	
	showOnlyRequired=()=>{
		let allData = this.state.allData;
		if($("input[name='customSwitchRequired']").prop("checked") == true){
			$(".field-required").show();
			$(".field-not-required").hide();
			this.setState({showOnlyRequired:true});
			allData.map((comment,i)=>{
				if(($('#'+comment[0]).find('.question').not(".field-not-required").length < 1 || $('#'+comment[0]).find('.question').not(".not-response").length < 1) && (comment[5].toLowerCase() == 'parent header' || comment[5].toLowerCase() == 'child header 1' || comment[5].toLowerCase() == 'child header 2' || comment[5].toLowerCase() == 'child header 3')){
					$('#'+comment[0]).addClass("not-r");	
				} 
			});
		}else{
			$(".field-required").show();
			$(".field-not-required").show();
			this.setState({showOnlyRequired:false});
			allData.map((comment,i)=>{
				if(($('#'+comment[0]).find('.question').not(".field-not-required").length < 1 || $('#'+comment[0]).find('.question').not(".not-response").length < 1) && (comment[5].toLowerCase() == 'parent header' || comment[5].toLowerCase() == 'child header 1' || comment[5].toLowerCase() == 'child header 2' || comment[5].toLowerCase() == 'child header 3')){
					$('#'+comment[0]).removeClass("not-r");	
				} 
			});
		}
		
	}
	
	getFormReviewValue=(event)=>{
		let name = event.target.name;
		let res = event.target.value;
		//let data_id = event.target.id;
		this.setState({reviewStatus:''});
		this.setState({[event.target.name]:event.target.value});
	}
	
	getFormReviewValue2=(event)=>{
		let name = event.target.name;
		if(name == 'reviewAppropriate'){
			if ($("input[name='reviewAppropriate']:checked").length > 0) {;
				this.setState({reviewAppropriate:true});
			}else{
				this.setState({reviewAppropriate:false});
			}
		}
		
		if(name == 'reviewBetter'){
			if($("input[name='reviewBetter']:checked").length > 0) {
				this.setState({reviewBetter:true});
			}else{
				this.setState({reviewBetter:false});
			}
		}
		
		if(name == 'reviewPresented'){
			if($("input[name='reviewPresented']:checked").length > 0) {
				this.setState({reviewPresented:true});
			}else{
				this.setState({reviewPresented:false});
			}
		}
	}
	
	onSortEnd = ({oldIndex, newIndex}) => {
		this.setState(({allData}) => ({
		    allData: arrayMove(allData, oldIndex, newIndex),
		}));
	};
	
	uploadMdsJsonMongoDb =(sheetName)=> {
		let ApiUrl = config.mongoApiUrl;
		let url = ApiUrl+'mds-file/'+sheetName;
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
            const allData = response.data.Fields;
			let mode = response.data.Mode ? response.data.Mode : 'Test';
			let CreatedBy = response.data.CreatedBy ? response.data.CreatedBy : 'admin';
			let currentDate = new Date().toLocaleString("en-US", {timeZone: "America/New_York"}).replace(',','');
			let parentMds = [];
			if(allData){
				let mdsGuid = response.data.MDSGuid;
				let version = response.data.Version;
				let dates = [];
				let fields = [];
				allData.map((field,i)=>{
					if(i > 0){
						
						let date = new Date(field[98]);
						if(date != 'Invalid Date'){
							dates.push(date);
						}
						
						let notes = field[12] = field[12].replaceAll('\n','');
						notes = notes.replaceAll('<p></p>','');
						let customNotes = field[116] = field[116].replaceAll('\n','');
						customNotes = customNotes.replaceAll('<p></p>','');
						
						let preId = '';
						let parentGuid = '';
						allData.map((pre_field,i)=>{
							if(field[7] && field[7] == pre_field[0]){
								preId = pre_field[117];
							}
							
							if(pre_field[1] == field[2]){
								parentGuid = pre_field[117];
							}
						})

						let delegateTypes = this.state.delegateTypes;
						//console.log('delegateTypes->',delegateTypes);
						let kioskT = [];
						delegateTypes.map((val,i)=>{
							let fieldk = val.split(':');
							let fd = {
								['ID']: parseInt(i+1),
								['delegate']: fieldk[1].trim(),
							}
							kioskT.push(fd);
						});

						field[91] = '';
						field[129] = '';
						field[130] = '';
						field[131] = '';
						
						let rqFields = [];
						let requiredFields = '';
						if(field[142] && field[5] == 'launchpad'){
							let rfStr = field[142].split(',');
							rfStr.map((rfield,i)=>{
								rfield = rfield.split('|');
								rqFields.push(rfield[0]+','+rfield[1]);
							});
							requiredFields = rqFields.join('|');
							
						}
						
						let opFields = [];
						let optionalFields = '';
						if(field[143] && field[5] == 'launchpad'){
							let opStr = field[143].split(',');
							opStr.map((ofield,i)=>{
								ofield = ofield.split('|');
								opFields.push(ofield[0]+','+ofield[1]);
							});
							optionalFields = opFields.join('|');
							
						}
						let createdDate = new Date(field[97]).toLocaleString("en-US").replace(',','');
						let lastDate = new Date(field[98]).toLocaleString("en-US").replace(',','');
						
						let options = [];
						if(field[6]){
							options = field[6].split(',');
						}
						
						let dateValidation = '';
						if(field[48] == 'V9'){
							dateValidation = 'past'
						}else if(field[48] == 'V10'){
							dateValidation = 'today'
						}else if(field[48] == 'V11'){
							dateValidation = 'future'
						}
						let validation = field[48].split(',');
						//console.log('validation->',validation);
						let gridLabel = [];
						if(field[5] == 'basicgrid' || field[5] == 'grid5point' || field[5] == 'grid-multicheck' || field[5] == 'grid-singlecheck'){
							let str = field[41] ? field[41].split('_') : [];
							
							if(str.length > 0){
								
								let columns = str[0].split(',');
								let clabel = [];
								
								
								columns.map((val,i)=>{
									//let fieldN = 'columnlabel'+parseInt(i+1);
									let strVali = validation[i] ? validation[i].split(':') : [];
									
									let fieldType = 'Q6';
									if(strVali[1] == 'V9' || strVali[1] == 'V10' || strVali[1] == 'V11' || strVali[1] == 'V12'){
										fieldType = 'Q8';
									}
									let fd = {
										['ID']: parseInt(i+1),
										['label']: val.trim(),
										['columnFieldType']: fieldType,
										['columnValidationType']: strVali[1] ? strVali[1] : [],
										['columnValidationMin']: strVali[2] ? strVali[2] : [],
										['columnValidationMax']: strVali[3] ? strVali[3] : [],
									}
									clabel.push(fd);
								});
								
								let rows = str[1].split(',');
								let crow = [];
								rows.map((val,i)=>{
									//let fieldN = 'rowlabel'+parseInt(i+1);
									let fd = {
										['ID']: parseInt(i+1),
										['label']: val.trim(),
										//['type']: field[5],
									}
									crow.push(fd);
								});
								gridLabel = {
									"ColumnLabelValues": clabel,
									"RowLabelValues": crow,
								}
							}
						}
						
						if(field[5] == 'basicgrid2'){
							let str = field[41] ? field[41].split('_') : [];
							
							if(str.length > 0){
								let columns = str[0].split('|');
								let rows = str[1].split(',');
								let crow = [];
								rows.map((val,i)=>{
									//let fieldN = 'rowlabel'+parseInt(i+1);
									let strVali = validation[i] ? validation[i].split(':') : [];
									let fd = {
										['ID']: parseInt(i+1),
										['label']: val.trim(),
										//['columnFieldType']: strVali[1] ? strVali[1].replace("V", "Q") : [],
										//['ColumnValidationType']: strVali[1] ? strVali[1] : [],
									}
									crow.push(fd);
								});
								
								let columnslable = [];
								let columnstd = [];
								let columnopt = [];
								columns.map((val,i)=>{
									let strVali = validation[i] ? validation[i].split(':') : [];
									let cm = val.split(':');
									//let fieldN = 'columnlabel'+parseInt(i+1);
									let fieldType = 'Q6';
									if(strVali[1] == 'V9' || strVali[1] == 'V10' || strVali[1] == 'V11' || strVali[1] == 'V12'){
										fieldType = 'Q8';
									}else if(cm[1] == 'limited'){
										fieldType = 'Q1';
									}
									
									let fd = {
										['ID']: parseInt(i+1),
										['label']: cm[0].trim(),
										['columnFieldType']: fieldType,
										['columnValidationType']: strVali[1] ? strVali[1] : [],
										['columnValidationMin']: strVali[2] ? strVali[2] : [],
										['columnValidationMax']: strVali[3] ? strVali[3] : [],
									}
									
									columnslable.push(fd);
									columnstd.push(cm[1]);
									if(cm[2]){
										columnopt.push(cm[2]);
									}else{
										columnopt.push('');
									}
								});
								let columnstd2 = [];
								columnstd.map((val,i)=>{
									let fieldm = 'column'+parseInt(i+1);
									let fds = {
										['ID']: parseInt(i+1),
										['option']: val.trim(),
									}
									
									columnstd2.push(fds);
								});
								
								let columnopt2 = [];
								columnopt.map((val,i)=>{
									let fieldm = 'column'+parseInt(i+1);
									let fds = {
										['ID']: parseInt(i+1),
										['option']: val.split(','),
									}
									
									columnopt2.push(fds);
								});
								
								gridLabel = {
									"ColumnLabelValues": columnslable,
									"RowLabelValues": crow,
									"ColumnOption": columnopt2,
									"ColumnDataType": columnstd2,
								}
							}
						}
						
						let optionValue = [];
						if(field[5] == 'weighted'){
							let str = field[41] ? field[41].split(',') : [];
							str.map((val,i)=>{
								let op = val.split(':');
								options.push(op[0]);
								optionValue.push(op[1]);
							});
						}
						
						if(field[5] == 'grid-dropdown'){
							let str = field[41] ? field[41].split('_') : [];
							
							if(str.length > 0){
								let columns = str[0].split(',');
								let clabel = [];
								columns.map((val,i)=>{
									//let fieldN = 'columnlabel'+parseInt(i+1);
									let fd = {
										['ID']: parseInt(i+1),
										['label']: val.trim(),
										//['type']: field[5],
									}
									clabel.push(fd);
								});
								let rows = str[1].split('|');
								
								//let columnslable = [];
								let rowValue = [];
								let coption = [];
								rows.map((val,i)=>{
									let cm = val.split(':');
									//columnslable.push(cm[0]);
									//rowValue.push(cm[0]);
									let fieldN = 'rowlabel'+parseInt(i+1);
									let fd = {
										['ID']: parseInt(i+1),
										['label']: cm[0].trim(),
									}
									rowValue.push(fd);
									
									cm.map((val,j)=>{
										if(j > 0){
											let fieldN = 'row'+parseInt(i+1)+'_columnoption'+parseInt(j);
											let fd = {
												['ID']: parseInt(j+1),
												['option']: val.split(','),
											}
											coption.push(fd);
										}
										
									});
									
								});
								
								gridLabel = {
									"ColumnLabelValues": clabel,
									"RowLabelValues": rowValue,
									"ColumnOption": coption,
									//"ColumnDataType": columnstd,
								}
							}
						}
						
						let ctype = field[114];
						let ctypeVal = [];
						let calculationType = [];
						if(field[5] == 'calculation'){
							if(ctype.indexOf(',') > -1) {
								let ctypearr = ctype.split(',');
								ctypearr.map((val,i)=>{
									//let fieldN = 'field'+parseInt(i+1);
									let fd = {
										['ID']: parseInt(i+1),
										['field']: val.trim(),
									}
									ctypeVal.push(fd);
								});
								
							}
							
							calculationType = ["Sum", "Average", "Subtract", "Highest Number", "Lowest Number", "Longest Time", "Shortest Time"]
						}
						
						let opVal = [];
						let optionSorting = field[69] ? field[69] : false;
						if(options.length > 0){
							options.map((val,i)=>{
								//let fieldN = 'option'+parseInt(i+1);
								let optionKey = val.split('|');
								let fd = {
									['ID']: parseInt(i+1),
									['guid']: optionKey[0].trim(),
									['option']: optionKey[1] ? optionKey[1].trim() : '',
									['isDefault']: true,
									['OPIE_ENUM']: optionKey[2] ? optionKey[2].trim() : '',
								}
								opVal.push(fd);
							});
						}
						
						if(field[5] == 'Q11b' && options.length > 0){
							opVal = [];
							options.map((val,i)=>{
								//let fieldN = 'option'+parseInt(i+1);
								let optionKey = val.split('|');
								let fd = {
									['ID']: parseInt(i+1),
									['guid']: optionKey[0].trim(),
									['option']: optionKey[1] ? optionKey[1].trim() : '',
									['isDefault']: true,
									['OPIE_ENUM']: optionKey[2] ? optionKey[2].trim() : '',
									['addDetails']: optionKey[3] == 'Y' ? true : false,
								}
								opVal.push(fd);
							});
						}
						
						if(field[5] == 'Q14' && options.length > 0){
							
							opVal = [];
							options.map((val,i)=>{
								if(val != ''){
									let txt = val.split('|');
									let fd = {
										['ID']: parseInt(i+1),
										['guid']: txt[0].trim(),
										['option']: txt[1].trim(),
										['value']: txt[2] ? txt[2].trim() : '',
										['OPIE_ENUM']: txt[3] ? txt[3].trim() : '',
									}
									
									if(optionSorting){
										fd['rank'] = parseInt(i+1);
									}
									opVal.push(fd);
								}
							});
						}
						
						if(field[5] == 'smartest' && options.length > 0){
							
							opVal = [];
							options.map((val,i)=>{
								if(val != ''){
									let txt = val.split('|');
									let fd = {
										['ID']: parseInt(i+1),
										['guid']: txt[0].trim(),
										['option']: txt[1].trim(),
										['isDefault']: true,
										['OPIE_ENUM']: txt[3] ? txt[3].trim() : '',
									}
									
									if(optionSorting){
										fd['rank'] = parseInt(i+1);
									}
									opVal.push(fd);
								}
							});
						}

						if(field[5] == 'gridcheck'){
							
							if(options.length > 0){
								
								let clabel = [];
								let clabel2 = [];
								
								options.map((val,i)=>{
									let fieldType = 'Q5';
									let txt = val.split('|');
									let fd = {
										['ID']: parseInt(i+1),
										//['label']: val.trim(),
										['label']: txt[1].trim(),
										['columnFieldType']: fieldType,
									}
									
									/* let fd2 = {
										['ID']: parseInt(i+1),
										['guid']: txt[0].trim(),
										['option']: txt[1].trim(),
									} */
									
									let fd2 = {
										['ID']: parseInt(i+1),
										['option']: txt[1].trim(),
										['isDefault']: true,
										['isVisible']: true,
									}
									
									//clabel.push(fd);
									clabel2.push(fd2);
								});
								
								//let rows = field[41] ? field[41].split(',') : [];
								
								let str = field[41] ? field[41].split('_') : [];
								if(str.length > 0){
								let columns = str[0].split(',');
								columns.map((val,i)=>{
									//let fieldN = 'columnlabel'+parseInt(i+1);
									let fd = {
										['ID']: parseInt(i+1),
										['label']: val.trim(),
										//['type']: field[5],
									}
									clabel.push(fd);
								});
								}
								let crow = [];
								if(str[1]){
									let rows = str[1].split(',');
									rows.map((val,i)=>{
										//let fieldN = 'rowlabel'+parseInt(i+1);
										let fd = {
											['ID']: parseInt(i+1),
											['label']: val.trim(),
											//['type']: field[5],
										}
										crow.push(fd);
									});
								}
								
								gridLabel = {
									"ColumnLabelValues": clabel,
									"RowLabelValues": crow,
									//"Options": clabel2,
								}
								
								opVal = clabel2;
							}
						}
	
						if(field[5] == 'likert'){
							let str = field[41] ? field[41].split('_') : [];
							if(str.length > 0){
								let columns = str[0].split(',');
								let clabel = [];
								columns.map((val,i)=>{
									clabel.push(val.trim());
								});
								
								let rows = str[1].split(',');
								let crow = [];
								rows.map((val,i)=>{
									crow.push(val.trim());
								});
								
								opVal = {
									"Questions": crow,
									"LabelValues": clabel,
								}
							}
						}
						
						let FieldTypeOptions = {
							"Options": opVal.length > 0 || Object.keys(opVal).length !== 0 ? opVal : '',
							//"OptionsValue": optionValue.length > 0 ? optionValue : '',
							"GridColumns": field[136],
							"GridRows": field[137],
							"GridLabelValue": Object.keys(gridLabel).length !== 0 ? gridLabel : '',
							"CalculationType": field[113],
							//"CalculationType": calculationType.length > 0 ? calculationType : '',
							"CalculationFields": ctypeVal.length > 0 ? ctypeVal : '',
							"WebsiteLink": field[78],
							//"TrackingCode": field[125] ? field[125].split(',') : '',
							//"TrackingCode": TrackingCode.length > 0 ? TrackingCode : '',
							//"DateValidation": dateValidation.length > 0 ? dateValidation : '',
							"DateValidation": dateValidation,
						}
						
						if(field[5] == 'slider'){
							let str = field[41].split(',');
							if(str.length > 1){
								options = {
									"LabelLeft": str[0],
									"LabelRight": str[1],
								}
							}
						
							FieldTypeOptions['Options'] = options;
							FieldTypeOptions['StepValue'] = field[36];
							FieldTypeOptions['MinValue'] = field[50];
							FieldTypeOptions['MaxValue'] = field[51];
						}
						
						if(field[5] == 'hidden'){
							FieldTypeOptions['Options'] = options;
							FieldTypeOptions['HiddenDimensionOptions'] = field[70];
						}
						
						const filteredObj2 = (obj) =>
						  Object.entries(obj)
							.filter(([_, value]) => !!value || typeof value === "boolean")
							.reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
						
						FieldTypeOptions = filteredObj2(FieldTypeOptions);
						
						let DataLowLimit = '';
						let DataHighLimit = '';
						
						if(field[5] == 'Q6' || field[5] == 'timer'){
							DataLowLimit = field[50];
							DataHighLimit = field[51];
						}
						let FieldType = field[5];
						
						if(field[5] == 'Q1' || field[5] == 'Q2' || field[5] == 'Q3' || field[5] == 'Q4' || field[5] == 'Q5' || field[5] == 'Q6' || field[5] == 'Q7' || field[5] == 'Q8' || field[5] == 'Q9' || field[5] == 'Q10' || field[5] == 'Q11' || field[5] == 'Q12' || field[5] == 'Q13' || field[5] == 'Q14'){
							FieldType = field[5].toUpperCase();;
						}

						let fieldData = {
							"FieldGUID": field[117],
							"MasterDataSetGUID": mdsGuid,
							"FieldName": field[0].replaceAll("<<", "").replaceAll(">>", "").trim(),
							"StaticFieldID": field[63],
							"FieldAltText": field[64],
							"FieldNameIdentifier_STATIC": field[61],
							"VisibleText": field[4],
							"FieldType": field[5],
							"FieldTypeOptions": Object.keys(FieldTypeOptions).length !== 0 ? FieldTypeOptions : '',
							"PrefilteredDelegates": kioskT.length > 0 ? kioskT : '',
							"ButtonLabel": field[40],
							"VisibleTxtBoxLabel": field[45],
							"OutputTxtBoxLabel": field[46],
							"ImageLocationReferenceInfo": field[99],
							"OutputText": field[9],
							"Notes": notes,
							"InternalDataPersistenceLabel": field[110],
							"Tags": field[13],
							"DataAgg": field[3] == 'Y' ? true:false,
							"AutoTags": field[106] ? field[106].replaceAll("<<", "").replaceAll(">>", "").trim() : '',
							"ValidationType": field[48],
							"DataLowLimit": field[5] != 'Q8' ? DataLowLimit : '',
							"DataHighLimit":field[5] != 'Q8' ? DataHighLimit : '',
							"PreserveOrder": field[69] == 'preserveOrder' ? true : false,
							"Randomize": field[69] == 'randomize' ? true : false,
							"AlphaNumeric": field[69] == 'alphaNum' ? true : false,

							//"OptionSorting": field[69] ? field[69] : false,
							"MinOptionSelection": field[30] ? field[30] : '',
							"MaxOptionSelection": field[31] ? field[31] : '',
							"DataElement": field[100] ? field[100] : '',
							"DataElementOption": field[101] ? field[101] : '',
							"ResponseDataFormat": field[102] ? field[102] : '',
							"LeftGridLabel": field[53] ? field[53] : '',
							"FieldRegistry": field[57] ? field[57] : '',
							"BuilderNoteField": field[58] ? field[58] : '',
							
							"CreatedDate": field[97] ? moment(createdDate).format('YYYY-MM-DD HH:mm:ss') : moment(lastDate).format('YYYY-MM-DD HH:mm:ss'),
							"ModifiedDate": moment(lastDate).format('YYYY-MM-DD HH:mm:ss'),
							"IsActive": field[60] == 'N' || field[60] == '' ? true:false,
							"Translations": false,
						}
						
						const filteredObj = (obj) =>
						  Object.entries(obj)
							.filter(([_, value]) => !!value || typeof value === "boolean")
							.reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
						
						fieldData = filteredObj(fieldData);
						fields.push(fieldData);
						
					}
				})

				let maximumDate = new Date(Math.max.apply(null, dates));
				let minimumDate = new Date(Math.min.apply(null, dates));
				let newDate = new Date(maximumDate).toLocaleString("en-US").replace(',','');
				let minDate = new Date(minimumDate).toLocaleString("en-US").replace(',','');
				//let lastUpDate = new Date(maximumDate).toLocaleString("en-US").replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
				
				parentMds = parentMds.filter(function(x) {
					 return x !== undefined;
				});
				let parentMdsGuid = this.uniqueArray2(parentMds);
				let itemString = parentMdsGuid.toString();
				
				let layout ={
					"MDSGuid": mdsGuid,
					"MDSName": sheetName,
					"CreatedDate": moment(minDate).format('YYYY-MM-DD HH:mm:ss'),
					"ModifiedDate": moment(newDate).format('YYYY-MM-DD HH:mm:ss'),
					"Version": version,
					"Mode": mode,
					"CreatedBy": CreatedBy,
					"Fields": fields,
				}
				//console.log('layout->',layout);
				let user_id = this.state.userGuid;
				if(sheetName != 'Temp-File-'+user_id){
					this.insertMdsJsonMongo(JSON.stringify(layout));
				}
			}

		},function(reason) {
			//alert(reason.result.error.message);
		});
	}
	
	uploadLayoutJsonMongoDb = (sheetName,type) => {
		
		let ApiUrl = config.mongoApiUrl;
		let url = ApiUrl+'layout-file/'+sheetName;
		let data = [];
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
            const data = response.data;
			//console.log('data->',data);
			let currentDate = new Date().toLocaleString("en-US", {timeZone: "America/New_York"}).replace(',','');
			let parentMds = [];
			let allData = data.Fields;
			let layoutGuid = data.LayoutGuid;
			let LayoutCategory = data.LayoutCategory;
			let associatedAnatomy = data.AssociatedAnatomy;
			let InternalNote = data.InternalNote ? data.InternalNote : '';
			let JobInitiator = data.JobInitiator ? data.JobInitiator : false;
			let mode = data.Mode ? data.Mode : 'Build';
			let CreatedBy = data.CreatedBy ? data.CreatedBy : 'admin';
			let version = data.Version ? data.Version : '1.01';
			if(allData.length > 0){
				let associatedType = allData[1][92];
				let associatedForm = allData[1][93];
				let associatedDevice = allData[1][94];
				let associatedVisit = allData[1][95];
				
				//let version = allData[1][59] ? allData[1][59] : '1.01';
				let friendly_name = allData[1][62] ? allData[1][62] : '';
				let Public = allData[1][111] ? allData[1][111] : 'Yes';
				let PrivateLayoutOwner = allData[1][115] ? allData[1][115] : '';
				let AssignedTrack = allData[1][125] ? allData[1][125].split(',') : '';
				
				let dates = [];
				let fields = [];
				let mdsFiles = [];
				allData.map((field,i)=>{
					if(i > 0){
						let date = new Date(field[98]);
						if(date != 'Invalid Date'){
							dates.push(date);
						}
						
						parentMds.push(field[129]);
						
						mdsFiles.push(field[118]);
								
						let preId = '';
						let parentGuid = '';
						allData.map((pre_field,i)=>{
							if(field[7] && field[7] == pre_field[0]){
								preId = pre_field[117];
							}
							
							if(pre_field[1] == field[2]){
								parentGuid = pre_field[117];
							}
						})

						let oldP = field[16];
						let userArray = oldP.split(',');
						userArray.splice(0, 9);
						
						let uArray = userArray.filter(function(v){return v!==''});
						let kioskTypes = uArray.toString();
						kioskTypes = kioskTypes.replaceAll(',','|');

						
						let fieldData = {
							"FieldGUID": field[131] ? field[131] : field[117],
							"Position#": field[10],
							"Include": field[14] == 'Y' ? true:false,
							"Required": field[15] == 'Y' ? true:false,
							"DelegateTypes": "["+kioskTypes+"]",
							"DefaultLayoutGuid": layoutGuid,
							"ParentGUID": parentGuid,
							"PostMergeEdit": field[17] ? field[17] : 'Yes',
							//"Public": field[111] == 'Y' ? true:false,
						}
						
						const filteredObj = (obj) =>
						  Object.entries(obj)
							.filter(([_, value]) => !!value || typeof value === "boolean")
							.reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
						
						fieldData = filteredObj(fieldData);
						fields.push(fieldData);
						
					}
				})

				let minimumDate = new Date(Math.min.apply(null, dates));
				let maximumDate = new Date(Math.max.apply(null, dates));
				let minDate = new Date(minimumDate).toLocaleString("en-US").replace(',','');
				let newDate = new Date(maximumDate).toLocaleString("en-US").replace(',','');
				//let lastUpDate = new Date(maximumDate).toLocaleString("en-US").replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
				
				parentMds = parentMds.filter(function(x) {
					 return x !== undefined;
				});
				
				let parentMdsGuid = this.uniqueArray2(parentMds);
				
				let mdsFilesArray = this.uniqueArray2(mdsFiles);
				
				if(mdsFilesArray.length > 0){
					mdsFilesArray.map((fls,i)=>{
						//this.uploadMdsJsonMongoDb(fls);
					});
				}
				
				let itemString = parentMdsGuid.toString();
				
				let layout ={
					"DefaultLayoutName": sheetName,
					"DefaultLayoutGuid": layoutGuid,
					"FriendlyName": friendly_name,
					"LayoutCategory": LayoutCategory,
					"Public": Public,
					"JobInitiator": JobInitiator,
					"PrivateLayoutOwner": PrivateLayoutOwner,
					"IncludedMDSGUIDs": itemString,
					"AssociatedAnatomy": associatedAnatomy,
					"AssociatedType": associatedType,
					"AssociatedDeviceTypes": associatedDevice,
					"AssociatedVisitTypes": associatedVisit,
					"AssignedTrack": AssignedTrack,
					"BuilderNoteLayout": InternalNote,
					//"AssociatedTrack": [],
					"Version": version,
					"CreatedDate": moment(minDate).format('YYYY-MM-DD HH:mm:ss'),
					"ModifiedDate": moment(newDate).format('YYYY-MM-DD HH:mm:ss'),
					"Mode": mode,
					"CreatedBy": CreatedBy,
					"showInTemplate": false,
					"Fields": fields,
				}
				let user_id = this.state.userGuid;
				if(sheetName != 'Temp-File-'+user_id){
					this.insertLayoutJsonMongo(JSON.stringify(layout));
				}
			}
				
		})
	}
	
	insertMdsJsonMongo(data){
		let mongoApiUrl = config.mongoApiUrl;
		let url = mongoApiUrl+'insert-mds-v2';
		axios({
			method: 'POST',
			url: url,
			data: data,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			console.log('response::', response.data);
		}).catch(error => {
			console.log('error::', error);
		})
	}
	
	insertLayoutJsonMongo(data){
		
		let mongoApiUrl = config.mongoApiUrl;
		let url = mongoApiUrl+'insert-layout-v2';
		axios({
			method: 'POST',
			url: url,
			data: data,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			//console.log('response::', response.data);
			/* let that = this;
			setTimeout(function(){
				that.getLayoutJsonFileVersion();
			}, 1000); */
		}).catch(error => {
			console.log('error::', error);
		})
	}
	
	updateLayoutJsonMongo(data){
		
		let mongoApiUrl = config.mongoApiUrl;
		let url = mongoApiUrl+'update-layout-v2';
		axios({
			method: 'POST',
			url: url,
			data: data,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			//console.log('response::', response.data);
			/* let that = this;
			setTimeout(function(){
				that.getLayoutJsonFileVersion();
			}, 1000); */
		}).catch(error => {
			console.log('error::', error);
		})
	}
	
	editImpField = (reviewStatus,reviewData,value) => {
		if(reviewStatus == 'suggestion'){
			
			let optionTxt = value[6];
			
			if(value[6].indexOf('|') > -1){
					let opArray = value[6].split(',');
					if(opArray.length > 0){
						let st = [];
						opArray.map((row, i) => {
							let tx = row.split('|')[1].trim();
							st.push(tx);
						});
						optionTxt = st.join(',');
					}	
			}	
			let rData = {
				"MDSGuid": value[129],
				"LayoutGuid": value[91],
				"FieldGuid": value[117],
				"VisibleText": value[4],
				"OutputText": value[9],
				"Options": optionTxt,
				"Updated": value[98],
				"reviews": reviewData,
			}
			this.setState({fieldReviewData:rData,rEditField:value[117]});
			$("#wrapperImp").addClass('toggled-3');
			$(".fadeInRight").addClass('is-open');
			$(".fadeInRight").removeClass('is-closed');
		}
		this.setState({preSugg:false});
	}
	
	getReviewValue = (e) => {
		let name = e.target.name;
		let val = e.target.value;
		let fieldReviewData = this.state.fieldReviewData;
		if(name == 'VisibleText'){
			fieldReviewData['VisibleText'] = val;
			this.setState({fieldReviewData});
		}else if(name == 'OutputText'){
			fieldReviewData['OutputText'] = val;
			this.setState({fieldReviewData});
		}else if(name == 'Options'){
			fieldReviewData['Options'] = val;
			this.setState({fieldReviewData});
		}
		
	}
	
	handleReviewField = (e) => {
		let item = e.target.name;
		let val = e.target.value;
        let isChecked = e.target.checked;
        if(isChecked == true){
			 this.setState({[item]: val});
			
        }else{
             this.setState({[item]: ''});
        }
    }
	
	reviewEdit = (type) => {
		if(type == 'VisibleText'){
			$("#rVisibleText").removeAttr("disabled");
		}else if(type == 'OutputText'){
			$("#rOutputText").removeAttr("disabled");
		}else if(type == 'Options'){
			$("#rOptions").removeAttr("disabled");
		}
	}
	
	reviewReplace = (type) => {
		
		if(this.state.reviewVisibleTxt != undefined && type == 'VisibleText'){
			let rTxt = this.state.reviewVisibleTxt;
			let fieldReviewData = this.state.fieldReviewData;
			fieldReviewData['VisibleText'] = rTxt;
			this.setState({fieldReviewData});
		}else if(this.state.reviewOutputTxt != undefined && type == 'OutputText'){
			
			let rTxt = this.state.reviewOutputTxt;
			let fieldReviewData = this.state.fieldReviewData;
			fieldReviewData['OutputText'] = rTxt;
			this.setState({fieldReviewData});
		}else if(this.state.reviewOptions != undefined && type == 'Options'){
			let rTxt = this.state.reviewOptions;
			let fieldReviewData = this.state.fieldReviewData;
			fieldReviewData['Options'] = rTxt;
			this.setState({fieldReviewData});
		}
		
	}
	
	reviewAppend = (type) => {
		if(this.state.reviewVisibleTxt != undefined && type == 'VisibleText'){
			let rTxt = this.state.reviewVisibleTxt;
			let fieldReviewData = this.state.fieldReviewData;
			fieldReviewData['VisibleText'] = fieldReviewData['VisibleText']+' '+rTxt;
			this.setState({fieldReviewData});
		}else if(this.state.reviewOutputTxt != undefined && type == 'OutputText'){
			
			let rTxt = this.state.reviewOutputTxt;
			let fieldReviewData = this.state.fieldReviewData;
			fieldReviewData['OutputText'] = fieldReviewData['OutputText']+' '+rTxt;
			this.setState({fieldReviewData});
			
		}else if(this.state.reviewOptions != undefined && type == 'Options'){
			let rTxt = this.state.reviewOptions;
			let fieldReviewData = this.state.fieldReviewData;
			fieldReviewData['Options'] = fieldReviewData['Options']+','+rTxt;;
			this.setState({fieldReviewData});
		}
	}
	
	reviewUndo = () => {
		let fieldReviewGuid = this.state.fieldReviewData['FieldGuid'];
		$("#review-"+fieldReviewGuid).trigger("click");
		//this.getLayoutData();
	}
	
	saveImprovedField = (fieldReviewData) => {
		
		let mongoApiUrl = config.mongoApiUrl;
		let url = mongoApiUrl+'improve-field';
		axios({
			method: 'POST',
			url: url,
			data: fieldReviewData,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			this.getLayoutData();
		}).catch(error => {
			console.log('error::', error);
		})
	
	}
	
	clearAllComments = (layoutGuid,fieldGuid) => {
		//alert(fieldGuid);
		let mongoApiUrl = config.mongoApiUrl;
		let url = mongoApiUrl+'clear-reviews/'+layoutGuid+'/'+fieldGuid;
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			//console.log('response::', response);
			this.getFieldReview(layoutGuid);
			this.getLayoutData();
			setTimeout(function(){
				$("#review-"+fieldGuid).trigger("click");
			}, 2000);
		}).catch(error => {
			console.log('error::', error);
		})
	}
	
	preSuggestionsShow=()=>{
		this.setState({preSugg:true});
	}
	
	preSuggestionsHide=()=>{
		this.setState({preSugg:false});
	}
	
	getDirectoryImages=(evt)=>{
		var reader = new FileReader();
		var file = evt.target.files[0];
		let that = this;
		reader.onload = function (e) {
			that.setState({imagePath:e.target.result});
		};
		reader.readAsDataURL(file);
	}
	
	showCopyModal=(val)=>{
		this.setState({copyValue:val});
		$('#copyModal').modal('show')
	}
	
	copyField(data){
		let that = this;
		let allData = this.state.allData;
		let fieldPrefix = this.state.fieldPrefix;
		let suffix = this.state.suffix;
		let IncludeCopy = this.state.IncludeCopy;
		
		let fieldPos = data[10];
		
		let id = allData.length+1

		let ttevalId = fieldPrefix+'-'+id;
		let position = id;
		let optionType = data[5];
		let guids_dn = ulid();
		let inputText = data[4] ? data[4] : '';
		if(IncludeCopy == 'Yes'){
			inputText = data[4] ? data[4]+''+suffix : '';
		}
		let answers = data[6];
		let outputText = data[9];
		let tags = data[13];
		let note = data[12];
		let numberOfColumn = parseInt(data[136]);
		let numberOfRow = parseInt(data[137]);
		let buttonlabel = data[40];
		let label = data[41];
		let validation = data[48];
		let min = data[50];
		let max = data[51];
		let step = data[36];
		
		let currentDate = new Date().toLocaleString("en-US", {timeZone: "America/New_York"}).replace(',','');
		let newField = [ ttevalId,'','','',inputText,optionType,answers,'','',outputText,position,'',note,tags,'Y','N','','','','','','','','','','','','','','','','','Y','N','','',step,'N','','',buttonlabel,label,'','','','','','',validation,'',min,max,'','','','','','','','','','','','','','','','','','','','','','','','','','','','','','','','','','','','','','','','','','','','','','',currentDate,'','','','','','','','','','','','','Y','','','','','',guids_dn,'','','','','','','','','','','','','','','','','','',numberOfColumn,numberOfRow,'' ];
		
		allData.push(newField);
		if(fieldPos){
			allData = arrayMove(allData, allData.length-1, fieldPos);
		}
		this.setState({allData});
		setTimeout(function(){
			that.updateData();
		}, 1000);
		
	}
	
	copyGroupFields(data){
		let allData = this.state.allData;
		let selectedSheet = this.state.selectedSheet;
		let currentDate = new Date().toLocaleString("en-US", {timeZone: "America/New_York"}).replace(',','');
        let that = this;
		let suffix = this.state.suffix;
		let IncludeCopy = this.state.IncludeCopy;
		let row = Object.assign([], data);
		let guid = ulid();
		let pos = row[10];
		let type = row[5];
		row[117] = guid;
		row[98] = currentDate;
		if(row[4] != '' && IncludeCopy == 'Yes'){
			row[4] = row[4]+''+suffix;
		}
		
		let dataRows = JSON.parse(JSON.stringify(allData));
		let newSetsArr = [row];
		for (var i = pos; i < dataRows.length; i++) {
			let guids_dn = ulid();
			if(i > pos && (dataRows[i][5] == type || (type.toLowerCase() == 'child header 2' && dataRows[i][5].toLowerCase() == 'child header 1') || (type.toLowerCase() == 'child header 3' && (dataRows[i][5].toLowerCase() == 'child header 2' || dataRows[i][5].toLowerCase() == 'child header 1'))) ){
				break;
			}
			if(dataRows[i][4] != '' && IncludeCopy == 'Yes'){
				dataRows[i][4] = dataRows[i][4]+''+suffix;
			}
			
			dataRows[i][7] = '';
			dataRows[i][8] = '';
			//dataRows[i][39] = '';
			dataRows[i][71] = '';
			dataRows[i][91] = '';
			dataRows[i][92] = '';
			dataRows[i][93] = '';
			dataRows[i][94] = '';
			dataRows[i][95] = '';
			
			dataRows[i][98] = currentDate;
			dataRows[i][117] = guids_dn;
			
			dataRows[i][124] = '';
			dataRows[i][125] = '';
			dataRows[i][126] = '';
			dataRows[i][127] = '';
			dataRows[i][129] = '';
			dataRows[i][130] = '';
			dataRows[i][131] = '';
			
			newSetsArr.push(dataRows[i]);  
		}
		
		if(newSetsArr.length > 0){
			let allDatas = allData.concat(newSetsArr);
			this.setState({allData:allDatas});
			setTimeout(function(){
				that.updateData();
			}, 1000);
		}

	}
	
	saveAsCopyMds=()=>{
		
		let selectedSheet = this.state.selectedSheet;
		let newMdsName = this.state.newMdsName;
		let originalData = this.state.originalData;
		
		let originalMDSGuide = originalData[1][91];
		
		if(newMdsName == ''){
			alert('Please insert New MDS file name!');
			return false;
		}
		
		//let currentDate = new Date().toLocaleString("en-US", {timeZone: "America/New_York"}).replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
		let currentDate = new Date().toLocaleString("en-US", {timeZone: "America/New_York"}).replace(',','');
		
        let mdsDataName = this.state.mdsDataName;
		let tempName = "Copy-of-"+originalMDSGuide+"-"+newMdsName;
		let mdsUld = ulid();
		originalData.map((row, i) => {
			let uld = ulid();
			if(i > 0){
				row[11] = '';
				row[59] = 1.01;
				row[91] = mdsUld;
				row[92] = '';
				row[93] = '';
				row[94] = '';
				row[95] = '';
				row[96] = '';
				row[97] = currentDate;
				row[98] = currentDate;
				row[115] = '';
				row[117] = uld;
				row[118] = newMdsName;
				row[121] = '';
			}
		});
		let that = this;
		setTimeout(function(){
			let fieldData = {
				"MDSGuid": mdsUld,
				"MDSName": tempName,
				"InstanceName": that.state.selectedInstanceName,
				"InstanceGuild": that.state.selectedInstanceId,
				"CreatedDate": moment(currentDate).format('YYYY-MM-DD HH:mm:ss'),
				"ModifiedDate": moment(currentDate).format('YYYY-MM-DD HH:mm:ss'),
				"Version": 1.01,
				"Mode": 'Test',
				"CreatedBy": that.state.CreatedBy,
				"Fields": originalData,
			}
			
			let mongoApiUrl = config.mongoApiUrl;
			let url = mongoApiUrl+'store-mds-files';
			axios({
				method: 'POST',
				url: url,
				data: JSON.stringify(fieldData),
				headers: {
					'Content-Type': 'application/json',
				}
			})
			.then(response => {
				let res = response.data;
				if(res == 'Inserted Successfully!'){
					that.uploadMdsJsonMongoDb(tempName);
					that.getMdsSheets(that.state.selectedInstanceId);
					that.getMdsData();
					alert('MDS Copy created successfully!');
				}else if(res == 'Already Exist!'){
					alert('MDSName Already Exist!');
				}
			}).catch(error => {
				console.log('error::', error);
			})
		}, 3000);

	}
	
	saveAsCopyLayout=()=>{
		
		let selectedSheet = this.state.selectedSheet;
		let newLayoutName = this.state.newLayoutName;
		let originalData = this.state.originalData;
		
		let originalMDSGuide = originalData[1][91];
		
		if(newLayoutName == ''){
			alert('Please insert New Layout name!');
			return false;
		}
		
		//let currentDate = new Date().toLocaleString("en-US", {timeZone: "America/New_York"}).replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
		let currentDate = new Date().toLocaleString("en-US", {timeZone: "America/New_York"}).replace(',','');

        let tempName = "Copy-of-"+originalMDSGuide+"-"+newLayoutName;
		let mdsUld = ulid();
		originalData.map((row, i) => {
			//let uld = ulid();
			if(i > 0){
				row[11] = '';
				row[59] = 1.01;
				row[91] = mdsUld;
				row[92] = '';
				row[93] = '';
				row[94] = '';
				row[95] = '';
				row[96] = '';
				row[97] = currentDate;
				row[98] = currentDate;
				row[115] = '';
				//row[117] = uld;
				row[118] = newLayoutName;
				row[121] = '';
			}

		});
		
		let fieldData = {
			"LayoutName": tempName,
			"LayoutGuid": mdsUld,
			"InstanceName": this.state.selectedInstanceName,
			"InstanceGuild": this.state.selectedInstanceId,
			"LayoutCategory": this.state.layoutCategory,
			"AssociatedAnatomy": this.state.associatedAnatomy,
			"JobInitiator": this.state.JobInitiator,
			"startWorkflow": this.state.startWorkflow,
			"workflowCategory": this.state.workflowCategory,
			"CreatedDate": moment(currentDate).format('YYYY-MM-DD HH:mm:ss'),
			"ModifiedDate": moment(currentDate).format('YYYY-MM-DD HH:mm:ss'),
			"Version": 1.01,
			"Mode": 'Test',
			"CreatedBy": this.state.CreatedBy,
			"Fields": originalData,
		}
		
		//this.mongoStoreNewLayout(fieldData,tempName);
		
		let mongoApiUrl = config.mongoApiUrl;
		let url = mongoApiUrl+'store-layout-files';
		axios({
			method: 'POST',
			url: url,
			data: JSON.stringify(fieldData),
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			let res = response.data;
			
			if(res == 'Inserted Successfully!'){
				this.getLayoutSheets(this.state.selectedInstanceId);
				this.getLayoutData();
				this.uploadLayoutJsonMongoDb(tempName,'create');
				alert('Layout Copy created successfully!');
			}
		}).catch(error => {
			console.log('error::', error);
		})

	}
	
	uploadVideoPath=(embedCode, errorMessage)=>{
		if(!errorMessage && embedCode){
			$( "#inlineVideo").html(embedCode);
			this.setState({inlineVideo:embedCode});
		}else{
			alert(errorMessage);
		} 
    }
	
	insertVideo=()=>{
		this.getVideoFromApi();
		$('#videoList').modal('show')
	}
	
	insertInlinVideo=()=>{
		this.getVideoFromApi();
		$('#inlineVideoList').modal('show')
	}
	
	insertFylesImage=()=>{
		this.getImagesFromApi();
		$('#imageList').modal('show')
	}
	
	insertFylesImageNote=()=>{
		this.getImagesFromApi();
		$('#imageList2').modal('show')
	}
	
	uploadFylesVideo=()=>{
		this.setState({FylesVideoPopup:true});
		this.allVideoTags();
		$('#uploadflyingVideo').modal('show')
	}
	
	inserEmbedCode=(embedcode)=>{
		let editorState = this.state.editorState;
		let editorSourceHTML = this.state.editorSourceHTML;
		
		let addNoteText = editorSourceHTML;
		const html = addNoteText+'<p></p>'+embedcode+'<p></p>';
		
		const contentBlock = htmlToDraft(html);
		if (contentBlock) {
			const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
			const editorState = EditorState.createWithContent(contentState);
			this.setState({
			  editorState,editorSourceHTML:html
			});
			
			$('#videoList').modal('hide');
		}
	}
	
	inserInlineEmbedCode=(embedcode)=>{
		let fieldId = this.state.fieldId;
		if(embedcode){
			$("#inlineVideo-"+fieldId).html(embedcode);
			this.setState({inlineVideo:embedcode});
		}
	}
	
	inserImageUrl=(url)=>{
		this.setState({imagePath:url});
		$('#imageList').modal('hide');
	}
	
	inserImageUrlNote=(url)=>{
		let editorState = this.state.editorState;
		let editorSourceHTML = this.state.editorSourceHTML;
		
		//this.setState({editorState:'',editorSourceHTML:''});
		
		let addNoteText = editorSourceHTML;
		const html = addNoteText+'<p><img class="note-img" src="'+url+'" alt="" width="400" /></p>';
		
		const contentBlock = htmlToDraft(html);
		if (contentBlock) {
			const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
			const editorState = EditorState.createWithContent(contentState);
			this.setState({
			  editorState,editorSourceHTML:html
			});
			
			$('#imageList2').modal('hide');
		}
		
	}
	
	previewEmbedCode=(embed)=>{
		//this.setState({previewCode:embed});
		$('#videoPreview').modal('show');
		$('#preView').html(embed);	
	}
	
	previewImage=(url)=>{
		//this.setState({previewCode:embed});
		$('#imagePreview').modal('show');
		let html = '<img src="'+url+'" alt="" width="400">';
		$('#preImgView').html(html);	
	}
	
	filterVideoList=()=>{
		let videoList = this.state.videoList;
		let videoTags = this.state.videoTags;
		let filterVideo = this.state.filterVideo;
		let filterVd = [];
		videoTags.map((tag, i) => {
			if($("input[name='"+tag+"']").prop("checked") == true){
				this.setState({[tag]:true});
				
				videoList.map((video, i) => {
					if(video.tags.indexOf(tag) != -1){
						filterVd[video._id] = video;
					}
				})
			}
			if($("input[name='"+tag+"']").prop("checked") == false){
				this.setState({[tag]:false});
			}
		})
		
		filterVd =  Object.values(filterVd);
		this.setState({filterVideo:filterVd});
	}
	
	filterImageList=()=>{
		let imageList = this.state.imageList;
		let imageTags = this.state.imageTags;
		let filterImage = this.state.filterImage;
		let filterVd = [];
		imageTags.map((tag, i) => {
			if($("input[name='"+tag+"']").prop("checked") == true){
				this.setState({[tag]:true});
				
				imageList.map((video, i) => {
					if(video.tags.indexOf(tag) != -1){
						filterVd[video._id] = video;
					}
				})
			}
			if($("input[name='"+tag+"']").prop("checked") == false){
				this.setState({[tag]:false});
			}
		})
		
		filterVd =  Object.values(filterVd);
		this.setState({filterImage:filterVd});
	}
	
	getWorkflowData=()=>{
		let workflowApi = config.workflowApi;
		let that = this;
		let url = workflowApi+'workflow-categories';
		let data = [];
		this.setState({catList:[],workflows:[]});
		axios.get(url)
        .then(response => {
            data = response.data;
			this.setState({catList:data});
        })
	}
	
	getWorkflows=()=>{
		let res = this.state.workflowCategory;
		if(res){
			let workflowApi = config.workflowApi;
			let that = this;
			let url = workflowApi+'cat-workflow/'+res;
			let data = [];
			axios.get(url)
			.then(response => {
				data = response.data;
				this.setState({workflows:data});
			})
		}else{
			this.setState({workflows:[]});
		}
	}
	
	workflowInitiate=()=>{
		let workflowId = $('#workflows').find("option:selected").val();
		if(workflowId){
			let PatientId = $('#PatientBox').find("option:selected").val();
			let PatientFirstName = '';
			let PatientLastName = '';
			let VisitID = '';
			let VisitType = '';

			this.state.patients.map(function(val,i) {
				if(val.PatientID == PatientId){
					PatientFirstName = val.PatientFirstName;
					PatientLastName = val.PatientLastName;
					VisitID = val.VisitID;
					VisitType = val.VisitType;
				}
			})
			
			let workflowData = {
			  "Facility_ID":this.state.mdsFacility,
			  "Patient_Branch_ID": "50"+PatientId,
			  "Branch_ID": this.state.Branch_ID ? this.state.Branch_ID : '55'+PatientId,
			  "User_ID": this.state.userGuid,
			  "Username": this.state.CreatedBy,
			  "TreatingPractitioner_ID": "13"+PatientId,
			  "Patient_ID": PatientId,
			  "Patient_FirstName": PatientFirstName,
			  "Patient_LastName": PatientLastName,
			  "Wip_ID": this.state.Wip_ID ? this.state.Wip_ID : '56'+PatientId,
			  "Type": VisitType,
			  "Insurance_Company": "Insurance Company #1",
			  "Rx_ID": "634"+PatientId,
			  "Claim_ID": "12"+PatientId,
			  "Visit_ID": VisitID,
			  "InitiatingForm_ID": "ECE9E8AF-2743-4BE6-BFF1-137EA6F"+PatientId,
			  "Workflow_ID": workflowId,
			  "Link_Url": this.state.Link_Url ? this.state.Link_Url : 'https://Opieanywhere.com'
			}

			let workflowApi = config.workflowApi;
			let url = workflowApi+'workflow-initiate-v2';
			
			axios({
				method: 'POST',
				url: url,
				data: JSON.stringify(workflowData),
				headers: {
					'Content-Type': 'application/json',
				}
			})
			.then(response => {
				let res = response.data;
				$('#startWorkflow').modal('hide');
			}).catch(error => {
				console.log('error::', error);
			})
			
		}else{
			alert('Please select workflow first!');
		}
	}
	
	mdsFromGoogleSheet=(mdsSpreadsheetId)=>{
		
		gapi.client.sheets.spreadsheets
		.get({
			spreadsheetId: mdsSpreadsheetId, 
		})
		.then(
			response => {
				const sheets = response.result;
				let sheetData = { 
					"title": sheets['properties']['title'],
					"spreadsheetId": sheets['spreadsheetId'],
					"sheets": sheets['sheets'],
					"spreadsheetUrl": sheets['spreadsheetUrl'],
				};
				sheets['sheets'].map((val, i) => {
					if(val['properties']['title'] != 'Temp File'){
						this.storeMdsInMongo(mdsSpreadsheetId,val['properties']['title']);
					}
				});

			},function(reason) {
				alert(reason.result.error.message);
			}	
		);
		
    }
	
	storeMdsInMongo=(spreadsheetId,sheetName)=>{
		
		gapi.client.sheets.spreadsheets.values
		.get({
			spreadsheetId: spreadsheetId,
			range:sheetName, 
		})
		.then(
			response => {
				const allData = response.result.values;
				
				let uld = allData[1][91];
				let dates=[];
				allData.map((rowDatas, i) => {
					let date = new Date(rowDatas[98]);
					if(date != 'Invalid Date'){
						dates.push(date);
					}
				});
				
				let maximumDate = new Date(Math.max.apply(null, dates));
				let minimumDate = new Date(Math.min.apply(null, dates));
				let modifiedDate = new Date(maximumDate).toLocaleString("en-US").replace(',','');
				let createdDate = new Date(minimumDate).toLocaleString("en-US").replace(',','');
				
				let fieldData = {
					"MDSGuid": uld,
					"MDSName": sheetName,
					"InstanceName": this.state.selectedInstanceName,
					"InstanceGuild": this.state.selectedInstanceId,
					"CreatedDate": moment(createdDate).format('YYYY-MM-DD HH:mm:ss'),
					"ModifiedDate": moment(modifiedDate).format('YYYY-MM-DD HH:mm:ss'),
					"Version": 1.01,
					"Mode": 'Test',
					"CreatedBy": this.state.CreatedBy,
					"Fields": allData,
				}
				if(fieldData){
					this.mongoStoreNewMds2(fieldData,sheetName);
				}	
			},function(reason) {
				console.log(reason.result.error.message);
			}
		);
	}
	
	mongoStoreNewMds2=(data,mdsDataName)=>{
		
		let mongoApiUrl = config.mongoApiUrl;
		let url = mongoApiUrl+'store-mds-files';
		axios({
			method: 'POST',
			url: url,
			data: JSON.stringify(data),
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			let res = response.data;
			if(res == 'Inserted Successfully!'){
				this.uploadMdsJsonMongoDb(mdsDataName);
				this.getMdsSheets(this.state.selectedInstanceId);
			}
		}).catch(error => {
			console.log('error::', error);
		})
	}
	
	handleSearch = (event) => {
		let that = this;
		this.setState({searchMDS:event.target.value});
		setTimeout(function(){
			that.filterMdsForms2();
		}, 1000);
		
    };
	
	loadMDSform = (MDSName) => {
		let that = this;
		this.setState({selectedSheet:MDSName});
		setTimeout(function(){
			that.getMdsData();
		}, 1000);
	}
	
	filterMdsForms2=()=>{
		let mdsSheets = this.state.mdsSheets;
		
		let mdsForms = [];
		mdsSheets.map((sheet,i)=>{
			if(this.state.filterMode && this.state.filterMode != sheet.Mode){
				return false;
			}
			sheet['type'] = sheet.Fields[1][92];
			sheet['dtype'] = sheet.Fields[1][94];
			sheet['vtype'] = sheet.Fields[1][95];
			sheet['anatomy'] = sheet.Fields[1][96];
			
			let visibleTxt = [];
			let outputTxt = [];
			sheet.Fields.map((txt,i)=>{
				if(i > 0){
					if(txt[4]){
						visibleTxt.push(txt[4]);
					}
					if(txt[9]){
						outputTxt.push(txt[9]);
					}
				}
			});
			
			sheet['visibleTxt'] = visibleTxt.join(',');
			sheet['outputTxt'] = outputTxt.join(',');
			mdsForms.push(sheet);
		});
		
		let searchQuery = this.state.searchMDS;
		
		if(searchQuery){
			mdsForms = mdsForms.filter((row) =>
				row.MDSName.toLowerCase().includes(searchQuery.toLowerCase()) ||
				//row.Mode.toLowerCase().includes(searchQuery.toLowerCase()) ||
				row.visibleTxt && row.visibleTxt.toLowerCase().includes(searchQuery.toLowerCase()) ||
				row.outputTxt && row.outputTxt.toLowerCase().includes(searchQuery.toLowerCase())
				//row.type && row.type.toLowerCase().includes(searchQuery.toLowerCase()) ||
				//row.dtype && row.dtype.toLowerCase().includes(searchQuery.toLowerCase()) ||
				//row.vtype && row.vtype.toLowerCase().includes(searchQuery.toLowerCase())
			);
		}
		
		//console.log('mdsForms->',mdsForms);
		this.setState({filteredmdsSheets:mdsForms});
	}
	
	auditLog=(data)=>{
		let mongoApiUrl = config.mongoApiUrl;
		let url = mongoApiUrl+'audit-log';
		axios({
			method: 'POST',
			url: url,
			data: JSON.stringify(data),
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			
		}).catch(error => {
			console.log('error::', error);
		})
	}
	
	saveSuggestReview=()=>{
		let suggest1 = this.state.suggest1;
		let suggest2 = this.state.suggest2;
		let suggest2a = this.state.suggest2a;
		let suggest3 = this.state.suggest3;
		let suggest4 = this.state.suggest4;
		let suggest5 = this.state.suggest5;
		let suggestGuid = ulid();
		let currentDate = new Date().toLocaleString("en-US", {timeZone: "America/New_York"}).replace(',','');
		let fieldData = {
			"UID": suggestGuid,
			"MDSName": this.state.selectedSheet,
			"Goal": suggest1,
			"FieldType": suggest2a ? suggest2a : suggest2,
			"VisibleText": suggest3,
			"Options": suggest4,
			"AdditionalInformaton": suggest5,
			"InternalReview": 'New',
			"Status": 'Active',
			"Note": '',
			"UserName": this.state.CreatedBy,
			"Date": moment(currentDate).format('YYYY-MM-DD HH:mm:ss'),
		}
		
		let mongoApiUrl = config.mongoApiUrl;
		let url = mongoApiUrl+'field-suggestion';
		axios({
			method: 'POST',
			url: url,
			data: JSON.stringify(fieldData),
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			alert('The Field Suggestion saved successfully!');
			this.setState({suggest1:'',suggest2:'',suggest2a:'',suggest3:'',suggest4:'',suggest5:''});
		}).catch(error => {
			console.log('error::', error);
		})
		
		setTimeout(function(){
			$('#suggestNewFiels').modal('hide');
		}, 2000);
		
		console.log('fieldData->',fieldData);
	}
	
	render() {
		
		const {allData, originalData, copyAllData, copySheetData, showBuilder, mdsSheets, mdsSheetNames, childSheetNames, childSheets, layoutSheetNames, delegateTypes, dataMode, loadDataSet, showView,kioskResponse, savedResponse, savedResponseForm, selectedRForm, facilityIds, showTrackerTable,practitioners, reasonNotes, mdsHasFieldSet, showMdsList,checkedCopyFields,mdsSpreadsheets,mdsJsonFilesVersion,layoutJsonFilesVersion,layoutTranslation,showMongoSection,showTestSection,showMongoMdsSection,showMongoMoveMdsSection,showTranslationManager,showLookDataManager,showSuggestManager,showUserSection,assignTracks,patients,PatientId,PatientName,flayoutTypes,fdeviceTypes,fvisitTypes,ftrack,fieldReviewData,mdsCreate,videoList,filterVideo,videoTags,imageList,filterImage,imageTags,catList,workflows,assInstances,assignInstances,searchMDS,filteredmdsSheets,formMode,suggestOp} = this.state;

		let categoryOption = catList.map(function(val,i) {
			return (
				<option value={val.id} key={i}>{val.name}</option>
			);
		})
		
		let workflowsOption = workflows.map(function(val,i) {
			return (
				<option value={val.id} key={i}>{val.name}</option>
			);
		})
		
		let trackList = '';
		let that = this;
		if(assignTracks){
			trackList = assignTracks.map(function(val,i) {
				return (
					<li key={i}><div className="list-li-name"><p className="mb-0">{val.trackName}</p><button type="button" style={{color:'red'}} className="btn code-dialog btn-delete track-delete" onClick={() => {if (window.confirm('Are you sure you want to Delete this Track Name?')) that.deleteTrack(val.trackName)}}><i className="fa fa-trash"></i></button></div> </li>
				);
			})
		}
		
		let role = localStorage.getItem('role');
		let href = window.location.href.split('?')[0];
		const DragHandle = sortableHandle(() => <span className="showcase"></span>);
		
		let totalFieldCountM = 0;
		let totalFieldCountC = 0;
		let optionsHtml = delegateTypes.map(function(val,i) {
			let delegateName = val.split(':');
			let delegateInFile = that.state.delegateInFile;
			if(delegateInFile.indexOf(delegateName[1]) != -1){
				return (
					<option value={delegateName[1]} key={i}>{delegateName[0]}</option>
				);
			}
			
		})
		
		let optionsHtml2 = delegateTypes.map(function(val,i) {
			let delegateName = val.split(':');
			return (
				<option value={delegateName[1]} key={i}>{delegateName[0]}</option>
			);
			
		})
		
		let optionPatients = '';
		
		if(patients.length > 0){
			optionPatients = patients.map(function(val,i) {
				return (
					<option value={val.PatientID} key={i}>{val.PatientFirstName+' '+val.PatientLastName}</option>
				);
				
			})
		}
		let optionInstance = '';
		let existInstance = [];
		if(this.state.instances){
			let ins = this.state.instances;
			childSheetNames.map(function(val,i) {
				existInstance.push(val.InstanceName);
			})
			optionInstance = ins.map(function(val,i) {
				if(role == 'Tester'){
					if(assInstances.indexOf(val.InstanceGuild) != -1){
						return (
							<option value={val.InstanceGuild} key={i}>{val.InstanceName}</option>
						);
					}
				}else if(role == 'Builder'  || role == 'MdsBuilder'  || role == 'LayoutBuilder'){
					if(assignInstances.indexOf(val.InstanceGuild) != -1){
						return (
							<option value={val.InstanceGuild} key={i}>{val.InstanceName}</option>
						);
					}
				}else if(role == 'Reviewer'){
					if(existInstance.indexOf(val.InstanceName) != -1 || assInstances.indexOf(val.InstanceGuild) != -1){ 
						return (
							<option value={val.InstanceGuild} key={i}>{val.InstanceName}</option>
						);
					}
				}else{
					return (
						<option value={val.InstanceGuild} key={i}>{val.InstanceName}</option>
					);
				}
				
			})
		}
			
		let completedForms = layoutSheetNames.map(function(val,i) {
			
			if(savedResponseForm.indexOf(val.name) > -1){
				return (
					<option data-type="" key={i} value={val.name}>{val.name}</option>
				);
			}
		})
		
		let facilityOption = facilityIds.map(function(val,i) {
			let facility = val.split('|');
			return (
				<option value={facility[1]} key={i}>{facility[0]}</option>
			);
		})
		
		let practitionerOption = practitioners.map(function(val,i) {
			let optn = val.split('|');
			return (
				<option data-email={optn[1]} value={optn[0]} key={i}>{optn[0]}</option>
			);
		})
		
		let reviewVisibletxt = '';
		let rVisibleTxtCount = 0;
		let reviewAppropriate = 0;
		let reviewBetter = 0;
		let reviewPresented = 0;
		let reviewSuggCount = 0;
		
		if("reviews" in fieldReviewData === true) {
			fieldReviewData['reviews'].map(function(val,i) {
				
				if(that.state.preSugg){
					if(val['reviewStatus'] == "suggestion"){
						reviewSuggCount = reviewSuggCount+1;
					}
					
					if(val['reviewAppropriate']){
						reviewAppropriate = reviewAppropriate+1;
					}
					
					if(val['reviewBetter']){
						reviewBetter = reviewBetter+1;
					}
					
					if(val['reviewPresented']){
						reviewPresented = reviewPresented+1;
					}
					
				}else if(val['Status'] == 'Active'){
					if(val['reviewStatus'] == "suggestion"){
						reviewSuggCount = reviewSuggCount+1;
					}
					
					if(val['reviewAppropriate']){
						reviewAppropriate = reviewAppropriate+1;
					}
					
					if(val['reviewBetter']){
						reviewBetter = reviewBetter+1;
					}
					
					if(val['reviewPresented']){
						reviewPresented = reviewPresented+1;
					}
				}
			})
		}
		
		
		if("reviews" in fieldReviewData === true) {
			reviewVisibletxt = fieldReviewData['reviews'].map(function(val,i) {
				if(val['reVisibleTest'] && that.state.preSugg){
					rVisibleTxtCount = rVisibleTxtCount+1;
					return (
						<div><input value={val['reVisibleTest']} className="btn code-dialog rTextCheckbox" name={'reviewVisibleTxt'} type="radio" onChange={that.handleReviewField} /> <b>{val['reVisibleTest']}</b> &nbsp;&nbsp;{val['SaveTime']}&nbsp;&nbsp;<b>{val['UserName']}</b></div>
					);
				}else if(val['reVisibleTest'] && val['Status'] == 'Active'){
					rVisibleTxtCount = rVisibleTxtCount+1;
					return (
						<div><input value={val['reVisibleTest']} className="btn code-dialog rTextCheckbox" name={'reviewVisibleTxt'} type="radio" onChange={that.handleReviewField} /> <b>{val['reVisibleTest']}</b> &nbsp;&nbsp;{val['SaveTime']}&nbsp;&nbsp;<b>{val['UserName']}</b></div>
					);
				}					
			})
		}
		
		let reviewOutputtxt = '';
		let rOutputTxtCount = 0;
		if("reviews" in fieldReviewData === true) {
			reviewOutputtxt = fieldReviewData['reviews'].map(function(val,i) {
				if(val['reOutputText'] && that.state.preSugg){
					rOutputTxtCount = rOutputTxtCount+1;
					return (
						<div><input value={val['reOutputText']} className="btn code-dialog" name={'reviewOutputTxt'} type="radio" onChange={that.handleReviewField}/> <b>{val['reOutputText']}</b> &nbsp;&nbsp;{val['SaveTime']}&nbsp;&nbsp;<b>{val['UserName']}</b></div>
					);
				}else if(val['reOutputText'] && val['Status'] == 'Active'){
					rOutputTxtCount = rOutputTxtCount+1;
					return (
						<div><input value={val['reOutputText']} className="btn code-dialog" name={'reviewOutputTxt'} type="radio" onChange={that.handleReviewField}/> <b>{val['reOutputText']}</b> &nbsp;&nbsp;{val['SaveTime']}&nbsp;&nbsp;<b>{val['UserName']}</b></div>
					);
				}
			})
		}
		
		let fieldResponseTxt = '';
		let rfieldResponseCount = 0;
		if("reviews" in fieldReviewData === true) {
			fieldResponseTxt = fieldReviewData['reviews'].map(function(val,i) {
	
				if(val['reFieldResponse'] && that.state.preSugg){
					rfieldResponseCount = rfieldResponseCount+1;
					return (
						<div><input value={val['reFieldResponse']} className="btn code-dialog" name={'reviewOptions'} type="radio" onChange={that.handleReviewField} /><b>{val['reFieldResponse']}</b> &nbsp;&nbsp;{val['SaveTime']} &nbsp;&nbsp;<b>{val['UserName']}</b></div>
					);
				}else if(val['reFieldResponse'] && val['Status'] == 'Active'){
					rfieldResponseCount = rfieldResponseCount+1;
					return (
						<div><input value={val['reFieldResponse']} className="btn code-dialog" name={'reviewOptions'} type="radio" onChange={that.handleReviewField} /><b>{val['reFieldResponse']}</b> &nbsp;&nbsp;{val['SaveTime']}&nbsp;&nbsp;<b>{val['UserName']}</b></div>
					);
				}
			})
		}
		
		let reviewCommentTxt = '';
		let rCommentTxtCount = 0;
		if("reviews" in fieldReviewData === true) {
			reviewCommentTxt = fieldReviewData['reviews'].map(function(val,i) {
				if(val['reviewerComments'] && that.state.preSugg){
					rCommentTxtCount = rCommentTxtCount+1;
					return (
						<div><b>{val['reviewerComments']}</b> &nbsp;&nbsp;{val['SaveTime']}&nbsp;&nbsp;<b>{val['UserName']}</b></div>
					);
				}else if(val['reviewerComments'] && val['Status'] == 'Active'){
					rCommentTxtCount = rCommentTxtCount+1;
					return (
						<div><b>{val['reviewerComments']}</b> &nbsp;&nbsp;{val['SaveTime']}&nbsp;&nbsp;<b>{val['UserName']}</b></div>
					);
				}
			})
		}
		
		let fieldButtons = props => {
			if(props){
				let include = false;
				let require = false;
				let kiosk = false;
				
				let deleStyle = {
					visibility: "hidden"
				};
				
				if(this.state.checkedInc.get(props[0]) == 'Y'){
					include = true;
				}
				
				if(this.state.checkedReq.get(props[0]) == 'Y'){
					require = true;
				}
				
				if(this.state.checkedKiosk.get(props[0]) == 'Y'){
					kiosk = true;
				}
				
				if(kiosk){
					deleStyle = {
						visibility: "visible"
					};
				}
				
				return(<div className="check-list-popup">
				<div className="check-list-cm">
					<input id={"include-"+props[0]} className="btn code-dialog inc-btn css-checkbox" name={props[0]} type="checkbox" checked={include} onChange={this.handleInclude}/>
					<label htmlFor={"include-"+props[0]} className="css-label lite-green-check"></label>
				</div>
				<div className="check-list-cm">
					<input id={"require-"+props[0]} className="btn code-dialog css-checkbox" name={props[0]} type="checkbox" checked={require} onChange={this.handleRequire}/>
					<label htmlFor={"require-"+props[0]} className={require ? 'css-label lite-gray-check' : 'css-label lite-red-check' }></label>
				</div>
				<div className="check-list-cm">
					<input id={"kiosk-"+props[0]} className="btn code-dialog css-checkbox" name={props[0]} type="checkbox" checked={kiosk} onChange={this.handleKiosk} />
					<label htmlFor={"kiosk-"+props[0]} className="css-label lite-kiosk-check"></label>
				</div>
				
				<div className="check-list-cm">
					<button style={deleStyle} id={'btn'+props[0]} type="button" onClick={()=>this.showAddUsersModal(props[0])} className="btn code-dialog btn-edit add-delegate"><i className="fa fa-users"></i></button>
				</div>
				
				</div>);
			}
		}
		
		const SortableItem = sortableElement(({value}) => {

			let placeholder = this.getPlaceholder(value[5]);
			let include = false;
			let require = false;
			let kiosk = false;
			let pos = false;
			let type = value[5].toLowerCase();
			
			if(this.state.checkedInc.get(value[0]) == 'Y'){
				include = true;
			}
			
			if(this.state.checkedReq.get(value[0]) == 'Y'){
				require = true;
			}
			
			let requirefield = true;
			
			if(type != 'parent header' && type != 'child header 1' && type != 'child header 2' && type != 'child header 3' && type != 'boxbegin' && type != 'boxend' && type != 'title' && type != 'image' && type != 'calculation' && type != 'wcalculation' && type != 'inlinevideo' && type != 'link'){
				requirefield = false;
			}
			
			if(this.state.checkedKiosk.get(value[0]) == 'Y'){
				kiosk = true;
			}
			
			if(this.state.fieldPos && this.state[value[0]]){
				pos = true;
			}
			
			let deleStyle = {
			    display: "none"
			};
			
			if(kiosk){
				deleStyle = {
					display: "inline-block"
				};
			}
			
			//let qTitle = value[4] ? value[4].substr(0,22) : placeholder;
			let qTitle = value[4] ? value[4]: placeholder;
			let fsqTitle = value[4] ? value[4]: placeholder;
			
			if(this.state.outputText){
				//qTitle = value[9] ? value[9].substr(0,22) : value[4] ? value[4].substr(0,22) : placeholder;
				//fsqTitle = value[9] ? value[9].substr(0,32) : value[4] ? value[4].substr(0,32) : placeholder;
				qTitle = value[9] ? value[9]: value[4] ? value[4]: placeholder;
				fsqTitle = value[9] ? value[9]: value[4] ? value[4]: placeholder;
			}
			let hightlight = '';
			if(dataMode == 'searchMode'){
				let searchQuery = this.state.searchMDS;
				if(qTitle.toLowerCase().includes(searchQuery.toLowerCase())){
					hightlight = 'hightlight';
				}	
			}
			let hightlight2 = '';
			if(value[60] == 'Y'){
				hightlight2 = 'hightlight2';
			}
			
			if(dataMode == 'MDS'){
				return (<div id={value[0]} className={'field-div '+this.classTypes(value)+' '+hightlight2}><DragHandle /><span className="input-title">{qTitle}</span>
				
				<div className="edit-btns d-flex">
				
					<div className="check-list-cm">
					<button type="button" className="btn code-dialog btn-copy" onClick={()=>this.showCopyModal(value)}><i className="fa fa-copy"></i></button>
					</div>
					
					<div className="check-list-cm">
					<button id={'fId-'+value[0]} type="button" className="btn code-dialog btn-edit" onClick={()=>this.editField(value[0],value[5],value)}><i className="fa fa-edit"></i></button>
					</div>
					<div className="check-list-cm">
					
					{formMode == 'Prod' ? 
					<button type="button" style={{color:'red'}} className="btn code-dialog btn-delete " onClick={() => {this.softDeleteField()}}><i className="fa fa-trash"></i></button> 
					: 
					<button type="button" style={{color:'red'}} className="btn code-dialog btn-delete " onClick={() => {if (window.confirm('Are you sure you want to Delete this field?')) this.deleteField(value[0])}}><i className="fa fa-trash"></i></button>
					}
					
					</div>
					<div className="check-list-cm">
					<input id={"include-"+value[0]} className="btn code-dialog css-checkbox" name={value[0]} type="checkbox" checked={include} onChange={this.handleInclude}/>
					<label htmlFor={"include-"+value[0]} className="css-label lite-green-check"></label>
					</div>
					
					<div className="check-list-cm">
					<input id={"require-"+value[0]} className="btn code-dialog css-checkbox" name={value[0]} type="checkbox" checked={require} onChange={this.handleRequire} disabled={requirefield}/>
					<label htmlFor={"require-"+value[0]} className={requirefield ? 'css-label lite-gray-check' : 'css-label lite-red-check' }></label>
					</div>
					
					<div className="check-list-cm">
					<input id={"kiosk-"+value[0]} className="btn code-dialog css-checkbox" name={value[0]} type="checkbox" checked={kiosk} onChange={this.handleKiosk} />
					<label htmlFor={"kiosk-"+value[0]} className="css-label lite-kiosk-check"></label>
					</div>
					
					<div className="check-list-cm">
					<input id={"addfield-"+value[0]} className="btn code-dialog add-new-pos select-pos css-checkbox" name={value[0]} value={value[10]} type="checkbox" checked={pos} onChange={this.handleAddNewFiled} />
					<label htmlFor={"addfield-"+value[0]} className="css-label lite-plus"></label>
					</div>
					
					<div className="check-list-cm">
					<button style={deleStyle} id={'btn'+value[0]} type="button" onClick={()=>this.showAddUsersModal(value[0])} className="btn code-dialog btn-edit add-delegate"><i className="fa fa-users"></i></button>
					</div>
					
					<div className="check-list-cm">
					<button id={'btn-eye'+value[0]} type="button" onClick={()=>this.showPreviewModal(value)} className="btn code-dialog btn-eye"><i className="fa fa-eye"></i></button>
					</div>
				</div>
				</div>);
			}else if(dataMode == 'TestForm'){
				return (<div id={value[0]} className={'field-div '+this.classTypes(value)}><span className="fs-input-title">{fsqTitle}</span>
				<div className="edit-btns">
				<button id={'btn-eye'+value[0]} type="button" onClick={()=>this.showPreviewModal(value)} className="btn code-dialog btn-eye-fset"><i className="fa fa-eye"></i></button>
				</div>
				</div>);
			}else if(dataMode == 'searchMode'){
				return (<div id={value[0]} className={'field-div '+this.classTypes(value)}><span className={"fs-input-title2 "+hightlight}>{fsqTitle}</span>
				</div>);
			}else{
				return (<div id={value[0]} className={'field-div '+this.classTypes(value)}><DragHandle /><span className="fs-input-title">{fsqTitle}</span>
				<div className="edit-btns1 d-flex">
				
					<div className="check-list-cm">
					<input id={"include-"+value[0]} className="btn code-dialog css-checkbox" name={value[0]} type="checkbox" checked={include} onChange={this.handleInclude}/>
					<label htmlFor={"include-"+value[0]} className="css-label lite-green-check"></label>
					</div>
					
					<div className="check-list-cm">
					<input id={"require-"+value[0]} className="btn code-dialog css-checkbox" name={value[0]} type="checkbox" checked={require} onChange={this.handleRequire} disabled={requirefield}/>
					<label htmlFor={"require-"+value[0]} className={requirefield ? 'css-label lite-gray-check' : 'css-label lite-red-check' }></label>
					</div>
					
					<div className="check-list-cm">
					<input id={"kiosk-"+value[0]} className="btn code-dialog css-checkbox" name={value[0]} type="checkbox" checked={kiosk} onChange={this.handleKiosk} />
					<label htmlFor={"kiosk-"+value[0]} className="css-label lite-kiosk-check"></label>
					</div>
					
					<div className="check-list-cm">
					<input id={"addfield-"+value[0]} className="btn code-dialog add-new-pos select-pos css-checkbox" name={value[0]} value={value[10]} type="checkbox" checked={pos} onChange={this.handleAddNewFiled} />
					<label htmlFor={"addfield-"+value[0]} className="css-label lite-plus"></label>
					</div>
					
					<div className="check-list-cm">
					<button style={deleStyle} id={'btn'+value[0]} type="button" onClick={()=>this.showAddUsersModal(value[0])} className="btn code-dialog btn-edit add-delegate"><i className="fa fa-users"></i></button>
					</div>
					
					<div className="check-list-cm">
					<button id={'btn-eye'+value[0]} type="button" onClick={()=>this.showPreviewModal(value)} className="btn code-dialog btn-eye"><i className="fa fa-eye"></i></button>
					</div>
					<div className="check-list-cm">
					{ formMode == 'Prod' ?
					<button type="button" style={{color:'red'}} className="btn code-dialog btn-delete " onClick={() => {this.softDeleteField()}}><i className="fa fa-trash"></i></button>
					:
					<button type="button" style={{color:'red'}} className="btn code-dialog btn-delete" onClick={() => { if (window.confirm('Are you sure you want to Delete this field?')) this.deleteField(value[0])}}><i className="fa fa-trash"></i></button>
					}
					</div>
					<div className="check-list-cm">
					<button className="btn merge-code-btn" type="button" ><i className={value[17] == 'Yes' ? 'fa fa-unlock' : 'fa fa-lock' } aria-hidden="true" onClick={()=>this.postMergeEdit(value[0],value[17])} ></i></button>
					</div>
				</div>
				
				</div>);
			}
		});
		
		const SortableItemImp = sortableElement(({value}) => {
			
			let placeholder = this.getPlaceholder(value[5]);
			let fieldReviews = this.state.fieldReviews;
			let reviewStatus = '';
			let reviewData = [];
			Object.keys(fieldReviews).map(function(keyName,i) {
				if(value[117] == keyName){
					reviewStatus = 'acceptable';
					fieldReviews[keyName].map(function(val,i) {
						if(val['reviewStatus'] == 'suggestion'){
							reviewStatus = 'suggestion';
						}
					})
					reviewData=fieldReviews[keyName];
					
				}
			})
			let img = 'review-1.png';
			if(reviewStatus == 'suggestion'){
				img = 'review-2.png';
			}else if(reviewStatus == 'acceptable'){
				img = 'review-3.png';
			}
			
			let fsqTitle = value[4] ? value[4]:placeholder;
			
			if(this.state.outputText){
				fsqTitle = value[9] ? value[9]:value[4] ? value[4]: placeholder;
			}
			
			return (<div id={value[0]} className={'field-div '+this.classTypes(value)}><span className="showcase"></span><span className="fs-input-title">{fsqTitle}</span>
				<div className="edit-btns1">
				{/* <button id={'fId-'+value[0]} type="button" className="btn code-dialog btn-edit" onClick={()=>this.editField(value[0],value[5],value)}><i className="fa fa-edit"></i></button> */}
					<div className={reviewStatus == 'suggestion' ? "tst-imp pointer" : 'tst-imp'} ><img id={'review-'+value[117]}src={href+'/'+img} className="review-img" alt="Field Review" onClick = {()=>this.editImpField(reviewStatus,reviewData,value)} /></div>
					
				</div>
				
			</div>);
		});
		
		const SortableContainer = sortableContainer(({children}) => {
			return <div className="fields-row">{children}</div>;
		});
		
		let optionHtmlsheets = '';
		if(this.state.mdsSpreadSheetData){
			optionHtmlsheets = this.state.mdsSpreadSheetData.map(function(val,i) {
				return (
					<option value={val["spreadsheetId"]} key={i}>{val["title"]}</option>
				);
			})
		}

		let leftTitle = 'Builder';
		if(dataMode == 'MDS'){
			leftTitle = 'MDS Builder';
		}else if(dataMode == 'Child'){
			leftTitle = 'Layout Builder';
		}else if(dataMode == 'TestForm'){
			leftTitle = '';
		}
		
		
        return(
            <div className="container-fluid">
				<MainHeader builderOption = {this.builderOption} dataMode = {dataMode} />
				<div className="content-container">
					{this.state.selectedSheet ? 
					<div className="loaded-file-name">{this.state.selectedSheet && !this.state.showMongoSection && !this.state.showMongoMdsSection && !this.state.showMongoMoveMdsSection && !this.state.showTranslationManager && !this.state.instanceManager && !this.state.showMdsList && dataMode != 'mdsFieldCopy' ? this.state.selectedSheet : ''} <span className="top-version">{this.state.selectedSheet && !this.state.showMongoSection && !this.state.showMongoMdsSection && !this.state.showMongoMoveMdsSection && !this.state.showTranslationManager && !this.state.instanceManager && !this.state.showMdsList && allData.length > 0 ? ' V'+this.state.selectedSheetversion : ''}</span>
					
					{dataMode == 'TestForm' && this.state.PatientName && allData.length > 0 ?
						<span className="selected-patient">{this.state.PatientName}</span>
					:null}
					</div>
					:null}
					<div id="wrapperImp" className="improve-mode">
					{this.state.viewMode == 'improve' || this.state.viewMode == 'improve_view' ?
						<div className="content-improve">
							<div className="row">
								<div className="col-md-8">
									
									{ showView && this.state.sheetData.length > 0 ? 
										<div className="from-mds-view">
										<div className="preview-mode-off" onClick={this.preViewModeOffImprove}><i className="fa fa-eye-slash" aria-hidden="true"></i> Off Preview Mode</div>
										
										<MainData 
											sheetData = {this.state.sheetData}
											showFieldCopyView = {this.state.showFieldCopyView}
											getPlaceholder = {this.getPlaceholder}
											outputText = {this.state.outputText}
											dataMode = {this.state.dataMode}
											role = {this.state.role}
											loadDataSet = {this.state.loadDataSet}
											showResponseData = {this.state.showResponseData}
											apiPdfs = {this.state.apiPdfs}
											delegateUsers = {this.state.delegateUsers}
											delegateFilter = {this.state.delegateFilter}
											allData = {this.state.allData}
											copyAllData = {this.state.copyAllData}
											kioskResponse = {this.state.kioskResponse}
											needsNote = {this.state.needsNote}
											checkedNeeds = {this.state.checkedNeeds}
											handleNeeds = {this.handleNeeds}
											checkedCopyFields = {this.state.checkedCopyFields}
											handleMdsCopyFields = {this.handleMdsCopyFields}
											handleMdsCopyAllFields = {this.handleMdsCopyAllFields}
											getResponseValue={this.getResponseValue}
											saveNeedsNote={this.saveNeedsNote}
											removeNeedsNote={this.removeNeedsNote}
											getFormReviewValue={this.getFormReviewValue}
											getFormReviewValue2={this.getFormReviewValue2}
											storeFormReviewData={this.storeFormReviewData}
											userReviewData={this.state.userReviewData}
											responseSaved={this.state.responseSaved}
										/>
										
										<div className="show-output-txt">
										<label className="showAllSwitch">
											<input id="showOutputText" type="checkbox" name="showOutputText" onClick={this.showOutputText}/>
											<span className="slider round showAllSlide"></span>
										</label> Show Output Text
										</div>
										
										</div>
									:
									<div className="build-section">
										<div className="build-page-title">
											<div className="row align-items-center">
												<div className="col">
													<h5 className="mb-0"> Build Page - Improve Mode </h5>
												</div>
												<div className="col text-right">
													<button type="button" className="btn btn-link" onClick={this.preViewModeOnImprove}> <i className="fa fa-eye" aria-hidden="true"></i> Preview Mode</button>
												</div>
											</div>
										</div>
										<div className="page-builder">
										{ this.state.allData && dataMode ?
											<SortableContainer onSortEnd={this.onSortEnd} useDragHandle>
												{allData.map((value, index) => (
												  <SortableItemImp key={index} index={index} value={value} /> 
												))}
											</SortableContainer>
										:null}
										</div>	
									</div>
									}
									
								</div>
								<div className="col-md-4">
									<nav className="custom-navbar-2" id="sidebar-wrapper-right" role="navigation">
										<div className="nav-content-right nav-right-improve-mode">
											<h5 className="page-title">Improve Mode</h5>
											<div className="item-fields">
												<div className="build-details">
													<p><b>Field Guid: </b>{fieldReviewData['FieldGuid']}</p>
													<p><b>Updated: </b>{fieldReviewData['Updated']}</p>
													<br/>
													<div className="review-txt-1">
														<h6>Visible Text</h6>
														<div className="visible-txt-imp"><textarea id="rVisibleText" name="VisibleText" className="form-control" value={fieldReviewData['VisibleText']} onChange={this.getReviewValue} disabled></textarea>
														</div>
													</div>
													<div className="accordion" id="accordionExample">
														{rVisibleTxtCount > 0 ?
														<div className="card">
															<div className="" id="headingOne">
															  <h4 className="mb-0">
																<button className="btn-header-link collapsed" type="button" data-toggle="collapse" data-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
																  Visible Text Reviewer Feedback ({rVisibleTxtCount})
																</button>
															  </h4>
															</div>

															<div id="collapse1" className="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
																<div className="review-txt-1">
																	{reviewVisibletxt}
																</div>
																<div className="review-btn-1">
																	<button className="btn btn-link" type="button" onClick={()=> this.reviewEdit('VisibleText')} >Edit</button>
																	<button className="btn btn-link" type="button" onClick={()=> this.reviewReplace('VisibleText')}>Replace</button>
																	<button className="btn btn-link" type="button" onClick={()=> this.reviewAppend('VisibleText')} >Append</button>
																</div>
															</div>
														</div>
														:null}
														{fieldReviewData['Options'] && rfieldResponseCount > 0 ?
														<div className="card">
															<div className="" id="headingOne">
															  <h4 className="mb-0">
																<button className="btn-header-link collapsed" type="button" data-toggle="collapse" data-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
																  Option Reviewer Feedback ({rfieldResponseCount})
																</button>
															  </h4>
															</div>

															<div id="collapse2" className="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
																<div className="review-txt-1">
																	<div className="visible-txt-imp">
																	<textarea id="rOptions" name="Options" className="form-control" value={fieldReviewData['Options']} onChange={this.getReviewValue} disabled></textarea>
																	</div>
																</div>
															
																<div className="review-txt-1">
																	{fieldResponseTxt}
																</div>
																<div className="review-btn-1">
																	<button className="btn btn-link" type="button" onClick={()=> this.reviewEdit('Options')} >Edit</button>
																	<button className="btn btn-link" type="button" onClick={()=> this.reviewReplace('Options')} >Replace</button>
																	<button className="btn btn-link" type="button" onClick={()=> this.reviewAppend('Options')} >Append</button>
																</div>
															</div>
														</div>
														:null}
														
														{rOutputTxtCount > 0 ?
														<div className="card">
															<div className="" id="headingOne">
															  <h4 className="mb-0">
																<button className="btn-header-link collapsed" type="button" data-toggle="collapse" data-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
																  Output Text Reviewer Feedback({rOutputTxtCount})
																</button>
															  </h4>
															</div>

															<div id="collapse3" className="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
																<div className="review-txt-1">
																	<div className="visible-txt-imp">
																	<textarea id="rOutputText" name="OutputText" className="form-control" value={fieldReviewData['OutputText']} onChange={this.getReviewValue} disabled></textarea>
																	</div>
																</div>
																<div className="review-txt-1">
																	{reviewOutputtxt}
																</div>
																<div className="review-btn-1">
																	<button className="btn btn-link" type="button" onClick={()=> this.reviewEdit('OutputText')} >Edit</button>
																	<button className="btn btn-link" type="button" onClick={()=> this.reviewReplace('OutputText')} >Replace</button>
																	<button className="btn btn-link" type="button" onClick={()=> this.reviewAppend('OutputText')} >Append</button>
																</div>
															</div>
														</div>
														:null}
														
														{rCommentTxtCount > 0 ?
														<div className="card">
															<div className="" id="headingOne">
															  <h4 className="mb-0">
																<button className="btn-header-link collapsed" type="button" data-toggle="collapse" data-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
																  Comments and Suggestions ({rCommentTxtCount})
																</button>
															  </h4>
															</div>

															<div id="collapse4" className="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
																<div className="review-txt-2">
																	{reviewCommentTxt}
																</div>
															</div>
														</div>
														:null}
													  
													</div>
													<div className="review-txt-1">
													<p>This field type is appropriate for the question.&nbsp;<b>({reviewAppropriate}/{reviewSuggCount})</b></p>
													<p>Another field type would be better for the question.&nbsp;<b>({reviewBetter}/{reviewSuggCount})</b></p>
													<p>This question could also be presented well by using other field types. &nbsp;<b>({reviewPresented}/{reviewSuggCount})</b></p>
													</div>
												</div>
												
											</div>
										</div>
										<div className="imp-panel-btn">
											{this.state.preSugg ?
											<div className="btn-sm btn" onClick={this.preSuggestionsHide}><i className="fa fa-eye mr-1" aria-hidden="true"></i>Previous Suggestions</div>
											:
											<div className="btn-sm btn" onClick={this.preSuggestionsShow}><i className="fa fa-eye-slash mr-1" aria-hidden="true"></i>Previous Suggestions</div>
											}
											<button type="button" className="btn btn-info btn-sm mr-1" onClick={()=> this.clearAllComments(fieldReviewData['LayoutGuid'],fieldReviewData['FieldGuid'])} >Clear Comments</button>
											<button type="button" className="btn btn-sm mr-1 btn-success" onClick={()=> this.saveImprovedField(fieldReviewData)} >Save & Update</button>
											<button type="button" className="btn btn-info btn-sm imp-undo btn-danger" onClick={this.reviewUndo}>
											<i className="fa fa-undo" aria-hidden="true"></i>
											</button>
										</div>
									</nav>
								</div>
							</div>	
						</div>
					:null}
					<button type="button" className={"hamburger animated fadeInRight is-closed imp-left"} data-toggle="offcanvas-3"></button>
					</div>
					
					<div id="wrapper" className="toggled">
					{this.state.viewMode != 'improve' ?
						<div>
							<aside className="sidebar">
							  <div className="toggle toggle-btn">
								<a href="#" className="burger js-menu-toggle active" data-toggle="collapse" data-target="#main-navbar">
									  <span></span>
									</a>
							  </div>
							  <div className="side-inner align-items-end" >
								<div className="sidebar-content">
									<div className="nav-content">
										<h5 className="page-title">{leftTitle}</h5>
										<div className="panel-btn">
											{/*<button type="button" className="btn btn-info" onClick={this.buildDetails}>Build New MDS</button>
												<button type="button" className="btn btn-primary">Load MDS</button>*/}
											<div className="show-hide-forms">
												<label className="showAllSwitch">
													<input id="showHide" type="checkbox" name="showHide" onClick={this.showHideForm}/>
													<span className="slider round showAllSlide"></span>
												</label> Hide Publish Forms
												</div>
											<div className="load-mds-button">
												{role == 'Administrator' || role == 'Builder' ?
												<div>
												<label> Select Mode </label>
												<select id="selectMode" className="form-control" value={this.state.dataMode} name="dataMode" onChange={this.selectMode}>
													<option value="">Please Select</option>
													<option value="MDS">Create and Manage Fields</option>
													<option value="Child">Build Forms</option>
													<option value="TestForm">Test Forms</option>
													<option value="searchMode">Search Mode</option>
												</select>
												</div>
												:null}
												
												{role == 'MdsBuilder' ?
												<div>
												<label> Select Mode </label>
												<select id="selectMode" className="form-control" value={this.state.dataMode} name="dataMode" onChange={this.selectMode}>
													<option value="">Please Select</option>
													<option value="MDS">Create and Manage Fields</option>
												</select>
												</div>
												:null}
												
												{role == 'LayoutBuilder' ?
												<div>
												<label> Select Mode </label>
												<select id="selectMode" className="form-control" value={this.state.dataMode} name="dataMode" onChange={this.selectMode}>
													<option value="">Please Select</option>
													<option value="Child">Build Forms</option>
												</select>
												</div>
												:null}
												
												{/* role == 'Tester' || role == 'Reviewer' ?
													<select id="selectMode" className="form-control" name="dataMode" onChange={this.selectMode}>
														<option value="TestForm">Test Form</option>
													</select>
												:null */}
											</div>
											
											{role == 'Administrator' && (dataMode == 'MDS' || dataMode == 'Child') ?
											<div className="load-mds-button">
												<label>Instance</label>
												<select id="selectedInstance" className="form-control" name="selectedInstance" value={this.state.selectedInstance} onChange={this.getValue}>
													<option value="">Please Select</option>
													{optionInstance}
												</select>
											</div>
											:null}
											
											{(role == 'Tester' || role == 'Reviewer') && assInstances.length > 0 ?
											<div className="load-mds-button">
												<label>Instance</label>
												<select id="selectedInstance" className="form-control" name="selectedInstance" value={this.state.selectedInstance} onChange={this.getValue}>
													<option value="">Please Select</option>
													{optionInstance}
												</select>
												
											</div>
											:null}
											
											{(role == 'Builder' || role == 'MdsBuilder' || role == 'LayoutBuilder' || dataMode == 'searchMode') && assignInstances.length > 0 ?
											<div className="load-mds-button">
												<label>Instance</label>
												<select id="selectedInstance" className="form-control" name="selectedInstance" value={this.state.selectedInstance} onChange={this.getValue}>
													<option value="">Please Select</option>
													{optionInstance}
												</select>
												
											</div>
											:null}
											
											
											{ dataMode == 'MDS' ?
											<div className="load-mds-button">
												<label> Filter MDS </label>
												<DebounceInput debounceTimeout={4000} type="text" className="form-control" name="filterMds" onChange={this.filterMdsForms}/>
											</div>
											:null}
											
											{ dataMode == 'MDS' ?
											<div className="load-mds-button">
												<label> Load MDS  </label>
												<select id="loadSelectMds" className="form-control load-select-mds" name="loadMds" value={this.state.selectedSheet} onChange={this.loadMdsSheet}>
													<option value="">Please Select</option>
													{mdsSheets.map((val, i) => (
														<option className={'mode-'+val.Mode} key={i} value={val.MDSName}>{val.MDSName}</option>
													))}
												</select>
											</div>
											:null}
											
											{ dataMode == 'Child' || dataMode == 'Layout' ?
											<div className="load-mds-button">
												<label> Filter Default Layout </label>
												<DebounceInput debounceTimeout={4000} type="text" className="form-control" name="filterSet" onChange={this.filterFieldSet}/>
											</div>
											:null}
											{ dataMode == 'TestForm' ?
												<div className="load-mds-button2">
												<label> Patient </label>
												<select id="PatientBox" className="form-control load-select-child" name="PatientId" onChange={this.selectPatient}>
													<option value="">Please Select</option>
													{optionPatients}
												</select>
											</div>
											:null}
											
											{ dataMode == 'Child' ?
											<div className="load-mds-button2">
												<label> Load Default Layout </label>
												<select id="loadFeildSet" value={this.state.selectedSheet} className="form-control load-select-child" name="loadChild" onChange={this.loadMdsSheet}>
													<option value="">Please Select</option>
													{childSheetNames.map((val, i) => (
														<option className={'mode-'+val.mode} key={i} value={val.name}>{val.name}</option>
													))}
												</select>
											</div>
											:null}
											
											{ dataMode == 'TestForm' && this.state.PatientId ?
											<div className="load-mds-button2">
												<label> Select a form </label>
												<button className="form-control text-left mb-3 btn-header-link" type="button" data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
													Filter Forms
												</button>
												
												<div className="collapse" id="collapseExample">
												  <div className="">
													<div className="form-group mb-2">
														<select className="form-control layout-filter" name="layoutType" onChange={this.filterLayoutType}>
															<option value="">Select Type</option>
															{flayoutTypes.map((val, i) => (
																<option key={i} value={val}>{val}</option>
															))}
														</select>
													</div>
													<div className="form-group mb-2">
														<select className="form-control layout-filter" name="layoutDeviceType" onChange={this.filterLayoutType}>
															<option value="">Select Device Type</option>
															{fdeviceTypes.map((val, i) => (
																<option key={i} value={val}>{val}</option>
															))}
														</select>
													</div>
													<div className="form-group mb-0">
														<select className="form-control layout-filter" name="layoutVisitType" onChange={this.filterLayoutType}>
															<option value="">Select Visit Type</option>
															{fvisitTypes.map((val, i) => (
																<option key={i} value={val}>{val}</option>
															))}
														</select>
													</div>
												  </div>
												</div>
											</div>
											:null}
											
											{ dataMode == 'TestForm' && this.state.PatientId ?
											<div className="load-mds-button2">
												<select id="loadFeildSet" className="form-control load-select-child" name="loadChild" onChange={this.loadMdsSheet}>
													<option value="">Please Select Form</option>
													{childSheetNames.map((val, i) => (
														<option key={i} value={val.name}>{val.name}</option>
													))}
												</select>
											</div>
											:null}
											
											{ dataMode == 'searchMode' ?
											<div className="wp-search-mds">
													<TextField
														label="Search"
														size="small"
														variant="outlined"
														fullWidth
														value={searchMDS}
														onChange={this.handleSearch}
														style={{ width: '200px' }}
													/>
													<i className="fa fa-search search-icon" aria-hidden="true"></i>
											</div>
											:null}
											
											{this.state.filteredmdsSheets.length > 0 ?
												<div className="mds-go-to-link">
													<label>MDS forms </label>
													{filteredmdsSheets.map((val, i) => (
														<div key={i} className={"mds-filter-form"} >
															<input className="field-btn-new" type="button" value={val.MDSName} onClick={()=>this.loadMDSform(val.MDSName)} />
														</div>
													))}
												</div>
											:null}
										</div>
										
										<div className="item-fields">
											<LeftPanel
												loadMdsSpreadSheet = {this.loadMdsSpreadSheet}
												addField = {this.addNewField}
												addNewPreField = {this.addNewPreField}
												addParentSets = {this.addParentSets}
												mdsSheets = {this.state.mdsSheets}
												parentDataSets = {this.state.parentDataSets}
												textfields = {this.state.textfields}
												basicfields = {this.state.basicfields}
												functionfields = {this.state.functionfields}
												gridfields = {this.state.gridfields}
												formattingfields = {this.state.formattingfields}
												addNewGroup = {this.addNewGroup}
												getPlaceholder = {this.getPlaceholder}
												dataMode = {this.state.dataMode}
												mdsSpreadsheetId = {this.state.mdsSpreadsheetId}
												mdsSpreadsheets = {this.state.mdsSpreadSheetData}
											/>
										</div>
									</div>
								</div>
							  </div>
							</aside>
							<div id="page-content-wrapper" className={this.state.copySelectedSheet ? 'has-copy-sheet custom-'+dataMode : 'custom-'+dataMode} >
								{ showView && this.state.sheetData.length > 0 ? 
									<div className="from-mds-view">
									<h4 className="from-title">{dataMode == 'mdsFieldCopy' ? 'Copy From: '+this.state.selectedSheet : ''}</h4>
									{role != 'Tester' && role != 'Reviewer' && role != 'NotesLetters' ?
									<div className="preview-mode-off" onClick={this.preViewModeOff}><i className="fa fa-eye-slash" aria-hidden="true"></i> Off Preview Mode</div>
									:null}
									{/* !this.state.showResponseData && dataMode == 'TestForm' ?
									<div className="select-attention-filter">
										<b>Needs attention:</b>
										<select className="form-control filter-attention" onChange={this.setAttentionFilter}>
											<option value="all">All</option>
											<option value="attention">Needs attention</option>
										</select>	
									</div>
									:null */}
									
									{!this.state.showResponseData && dataMode == 'TestForm' ?
									<div className="select-delegate-filter">
										<b>Delegate Mode:</b>
										<select className="form-control filter-delegate" onChange={this.setDelegateFilter}>
											<option value="">All</option>
											{optionsHtml}
										</select>								
									</div>
									:null}
									
									{!this.state.showResponseData && dataMode == 'TestForm' ?
									<div className="custom-switch custom-switch-required text-right">
									  <input type="checkbox" className="custom-control-input" id="customSwitch" name="customSwitchRequired" onClick={this.showOnlyRequired} />
									  <label className="custom-control-label" htmlFor="customSwitch">Only Required</label>
									</div>
									:null}
									
									{!this.state.showResponseData && dataMode == 'TestForm' ?
										<div className="suggest-field"><Button type="button" className="btn btn-primary pl-5 pr-5 start-w-btn" data-target="#suggestNewFiels" data-toggle="modal">Suggest a New Field </Button></div>
									:null}
									
									<MainData 
										sheetData = {this.state.sheetData}
										showFieldCopyView = {this.state.showFieldCopyView}
										getPlaceholder = {this.getPlaceholder}
										outputText = {this.state.outputText}
										dataMode = {this.state.dataMode}
										role = {this.state.role}
										loadDataSet = {this.state.loadDataSet}
										showResponseData = {this.state.showResponseData}
										apiPdfs = {this.state.apiPdfs}
										delegateUsers = {this.state.delegateUsers}
										delegateFilter = {this.state.delegateFilter}
										allData = {this.state.allData}
										copyAllData = {this.state.copyAllData}
										kioskResponse = {this.state.kioskResponse}
										needsNote = {this.state.needsNote}
										checkedNeeds = {this.state.checkedNeeds}
										handleNeeds = {this.handleNeeds}
										checkedCopyFields = {this.state.checkedCopyFields}
										handleMdsCopyFields = {this.handleMdsCopyFields}
										handleMdsCopyAllFields = {this.handleMdsCopyAllFields}
										getResponseValue={this.getResponseValue}
										saveNeedsNote={this.saveNeedsNote}
										removeNeedsNote={this.removeNeedsNote}
										getFormReviewValue={this.getFormReviewValue}
										getFormReviewValue2={this.getFormReviewValue2}
										storeFormReviewData={this.storeFormReviewData}
										userReviewData={this.state.userReviewData}
										responseSaved={this.state.responseSaved}
									/>
									<div className="test-bottom-button">
										{dataMode == 'TestForm' && this.state.startWorkflow ?
											<div className="begin-workflow"><Button type="button" className="btn btn-primary pl-5 pr-5 start-w-btn" data-target="#startWorkflow" data-toggle="modal" onClick={this.getWorkflows}>Begin Workflow </Button></div>
										:null}
										
										
										
										{/* onClick={()=> this.handleSubmitSave()}  */}
										<div className="show-output-txt">
										<label className="showAllSwitch">
											<input id="showOutputText" type="checkbox" name="showOutputText" onClick={this.showOutputText}/>
											<span className="slider round showAllSlide"></span>
										</label> Show Output Text
										</div>
										
										{dataMode == 'TestForm' ?
										<div className="save-output-response"><Button type="button" className="float-right" data-target="#formRating" data-toggle="modal">Save </Button></div>
										:null}
										
										
									</div>
									</div>
								: !showTrackerTable ?
								<div className="container-2 build-section">
									<div className="build-page-title">
									{dataMode != 'TestForm' && dataMode != 'mdsFieldCopy'?
									<h5 className="page-title">Build Page {dataMode == 'MDS' ? ' - MDS Mode' : ''} {dataMode == 'Child' ? ' - Default Layout Mode' : ''} {dataMode == 'Layout' ? ' - Layout Mode' : ''} {dataMode == 'mdsFieldCopy' ? ' - Copy from MDS file' : ''}</h5>
									:null}
									{this.state.allData.length > 0 && dataMode == 'Layout' && this.state.viewMode == 'builder' ?
									<div className="include-btn">
									<button className="btn btn-primary mr-2 clear-temp-top" onClick={() => { if(window.confirm('Do you want to include all?')) this.setAllChecked() }}>Include All </button>
									<button className="btn btn-danger mr-2 clear-temp-top" onClick={() => { if(window.confirm('Do you want to exclude all?')) this.setAllUnChecked() }}>Exclude All </button>
									</div>
									:null}
									{ this.state.allData.length > 0 && dataMode ?
									<div className="top-right-btn">
									{dataMode == 'Child' ?
										<div className="unselect-all"><span>Unselect All :</span> <span className="un-all" onClick={this.unSelectAllIn}>IN</span><span className="un-all" onClick={this.unSelectAllRq}>RQ</span></div>
									:null}
									{dataMode == 'Child' ?
										<div className="lock-unlock" onClick={() => {if (window.confirm('Are you sure you want to lock/unlock all fields?')) this.allPostMergeEdit(this.state.mergeEdit)}}><i className={this.state.mergeEdit == 'Yes' ? 'fa fa-unlock' : 'fa fa-lock' } aria-hidden="true"></i></div>
									:null}
									
									<div className="preview-mode" onClick={this.preViewModeOn}><i className="fa fa-eye" aria-hidden="true"></i> Preview Mode</div> 
									<div className="preview-mode-2" onClick={this.preViewModeOnLink}><i className="fa fa-external-link" aria-hidden="true"></i></div> 
									
									{dataMode == 'MDS' ?
									<button type="button" className="btn btn-info clear-temp-top" onClick={this.buildDetails}>
									 {this.state.loadDataSet == 'loadMds' ? 'Edit MDS Details':'Create New MDS'}
									</button>
									: dataMode == 'Child' ?
									<button type="button" className="btn btn-info clear-temp-top" onClick={this.buildDetails}>
									 {this.state.loadDataSet == 'loadChild' ? 'Edit Default Layout':'Create New Default Layout'}
										 {/* Save New Default Layout */}
									</button>
									:null}
									
									{this.state.selectedSheet == '' ?
									<button type="button" className="btn btn-danger clear-temp-top" onClick={() => { if (window.confirm('Are you sure you want to Clear the Page?')) this.clearTempData() } }>Clear Build Page</button>
									:
									null
									}
									
									</div>
									:null}
									</div>
									{this.state.allData.length > 0 && dataMode ?
									<div className="page-builder">
										{dataMode == 'MDS' ?
										<div className="action-btn"><span className="field-text-btn">Field Text</span><span>Edit</span><span>Delete</span><span>Include</span><span>Require</span><span>Delegate</span><span>Select Delegate</span><span>Insert Field</span><span>Preview</span></div>
										:null}
										{dataMode == 'Child' ?
										<div className="action-btn"><span className="field-text-btn">Field Text</span><span>Include</span><span>Require</span><span>Delegate</span><span>Select Delegate</span><span>Insert Field</span><span>Preview</span><span>Delete</span></div>
										:null}
										<SortableContainer onSortEnd={this.onSortEnd} useDragHandle>
											{allData.map((value, index) => (
											  <SortableItem key={index} index={index} value={value} /> 
											))}
										</SortableContainer>
									</div>
									:null}
									{this.state.allData.length > 0 && dataMode ?
										<div className="bottom-btn">
											<div className="show-output-text">
											<label className="showAllSwitch">
												<input type="checkbox" name="showOutputText" onClick={this.showOutputText}/>
												<span className="slider round showAllSlide"></span>
											</label> Show Output Text
											</div>
											<button type="button" className="btn btn-info btn-update-data" onClick={this.updateData}>Update</button>
											<button type="button" className="btn btn-danger btn-undo-data" onClick={this.clearLastData} style={{display:'none'}}>Undo</button>
											
											{this.state.loadDataSet == 'loadMds' && this.state.mdsCreate == true ?
											<button type="button" className="btn btn-info" data-target="#newMdsPopup" data-toggle="modal">Save AS New MDS</button>
											:null}
											
											{this.state.loadDataSet == 'loadChild' ?
											<button type="button" className="btn btn-info" data-target="#newLayoutPopup" data-toggle="modal">Save AS New Layout</button>
											:null}
											
										</div>
									:null}
								</div>
								:null}
								{this.state.sheetData.length > 0 && dataMode != 'TestForm' ?
								<button type="button" className={"hamburger animated fadeInRight is-closed"} data-toggle="offcanvas-2"></button>
								:
								<button type="button" className={"hamburger animated fadeInRight is-closed hide-arrow"} data-toggle="offcanvas-2"></button>
								}
							</div>
							
							{this.state.sheetData.length > 0 && dataMode == 'TestForm' ?
							<div className="full-close-screen">
							<button className="full-screen btn btn-primary btn-sm mr-1" onClick={this.openFullscreen} ><i className="fa fa-expand-arrows-alt" aria-hidden="true"></i></button>
							<button className="close-screen btn btn-primary btn-sm mr-1" style={{display:'none'}} onClick={this.closeFullscreen} ><i className="fa fa-compress-arrows-alt"></i></button>
							<button type="button" value="increase" className="increaseFont btn btn-success btn-sm mr-1" onClick = {()=>this.increaseFont('increase')} ><i class="fa fa-plus" aria-hidden="true"></i></button>
							<button type="button" value="decrease" className="decreaseFont btn btn-danger btn-sm" onClick = {()=>this.increaseFont('decrease')} ><i class="fa fa-minus" aria-hidden="true"></i></button>
							</div>
							:null}
							
							{dataMode != 'TestForm' ?
							<nav className="custom-navbar-2" id="sidebar-wrapper-right" role="navigation">
								<div className="nav-content-right">
									<h5 className="page-title">Details Panel</h5>
									{this.state.showBuildEdit ?
									<div className="panel-btn">
									{/*<button type="button" className="btn btn-info">Build New MDS Details</button>*/}
									</div>
									:null}
									<div className="item-fields">
										<BuildDetails 
											getValue = {this.getValue}
											getDueDate = {this.getDueDate}
											allData = {this.state.allData}
											getRqAndOpFields = {this.getRqAndOpFields}
											handleLaunchPadItem = {this.handleLaunchPadItem}
											delegateTypes = {this.state.delegateTypes}
											types = {this.state.types}
											deviceTypes = {this.state.limitDeviceTypes}
											//pDeviceTypes = {this.state.pDeviceTypes}
											showFieldEdit = {this.state.showFieldEdit}
											fieldId = {this.state.fieldId}
											showBuildEdit = {this.state.showBuildEdit}
											visitTypes = {this.state.visitTypes}
											companies = {this.state.companies}
											//trackingCode = {this.state.trackingCode}
											groupId = {this.state.groupId}
											mdsSheets = {this.state.mdsSheets}
											facilityIds = {this.state.facilityIds}
											responsibleRole = {this.state.responsibleRole}
											responsiblePerson = {this.state.responsiblePerson}
											persons = {this.state.persons}
											statusType = {this.state.statusType}
											statusByfacility = {this.state.statusByfacility}
											facilityData = {this.state.facilityData}
											fileArray = {this.state.fileArray}
											imagePath = {this.state.imagePath}
											defaultProps = {this.state}
											_uploadImageCallBack = {this._uploadImageCallBack}
											onEditorStateChange = {this.onEditorStateChange}
											updateField = {this.updateField}
											insertVideo = {this.insertVideo}
											insertInlinVideo = {this.insertInlinVideo}
											insertFylesImage = {this.insertFylesImage}
											insertFylesImageNote = {this.insertFylesImageNote}
											uploadFylesVideo = {this.uploadFylesVideo}
											uploadVideoPath = {this.uploadVideoPath}
											setAsGroup = {this.setAsGroup}
											getDirectoryImages = {this.getDirectoryImages}
											calculationFields = {this.calculationFields}
											wcalculationFields = {this.wcalculationFields}
											addOption = {this.addOption}
											addOptionKey = {this.addOptionKey}
											addOptionKeyName = {this.addOptionKeyName}
											deleteOptionKey = {this.deleteOptionKey}
											deleteOptionKeyValue = {this.deleteOptionKeyValue}
											editOptionKey = {this.editOptionKey}
											editOptionKey2 = {this.editOptionKey2}
											changeOptionKey = {this.changeOptionKey}
											parentDataSets = {this.state.parentDataSets}
											addParentSets = {this.addParentSets}
											dataMode = {this.state.dataMode}
											showTrackerDetails = {this.state.showTrackerDetails}
											showTrackerViewFun = {this.showTrackerViewFun}
											trackerRow = {this.state.trackerRow}
											trackerTableData = {this.state.trackerTableData}
											ogTags = {this.state.ogTags}
											statusLogs = {this.state.statusLogs}
											assignTracks = {this.state.assignTracks}
											catList = {this.state.catList}
											role = {this.state.role}
											showDimantionPop = {this.showDimantionPop}
											anatomyList={this.state.anatomyList} 
										/>
										<div className="panel-btn">
										<br />
										{this.state.showBuildEdit ?
											<div>
											{this.state.loadDataSet == 'loadMds' || this.state.loadDataSet == 'loadLayout' || this.state.loadDataSet == 'loadChild' ?
												<button type="button" className="btn btn-primary" onClick = {()=>this.buildMds('Update')} >Update</button>
											: 
												<button type="button" data-target="#createBuild" data-toggle="modal" className="btn btn-primary" >Build </button>
											}
											</div>
										:null}
										</div>
									</div>
								</div>
							</nav>
							:null}
							<div className="modal" id="assignTrack">
								<div className="modal-dialog modal-lg">
									<div className="modal-content">
									  <div className="modal-header">
										<h5 className="modal-title">Assigned Track</h5>
										<button type="button" className="close" data-dismiss="modal">&times;</button>
									  </div>
									  <div className="modal-body">
										<div className="add-track">
										<DebounceInput debounceTimeout={4000} type="text" className="form-control add-track-n"  name="trackName" onChange={this.getValue} /> 
										<button type="button" className="btn btn-info" onClick={this.addTrackMongo}>Add</button>
										</div>
										<div className="track-list">
										   <h6 className="modal-title">Track List</h6>
										   <ul className="track-list-ul">
										   {trackList}
										   </ul>
										</div>
									  </div>
									  <div className="modal-footer">
									  <button type="button" className="btn btn-danger float-right" data-dismiss="modal">Close</button>
									  </div>

									</div>
								</div>
							</div>
							
							<div className="modal" id="dimention">
							<div className="modal-dialog modal-lg">
								<div className="modal-content">
									<div className="modal-header">
										<h5 className="modal-title">Field : {this.state.selectedKeyTxt}</h5>
										<button type="button" className="close" data-dismiss="modal">&times;</button>
									</div>
									<div className="modal-body">
										<p><b>Option : </b>{this.state.selectedKeyOpt} <b>Key Value :</b> {this.state.selectedKeyOptVal}</p>
										<p>Enter Value for each Hidden Dimension for the selected Option</p>
										{ this.state.SelectedKeyNamesArray ?
											this.state.SelectedKeyNamesArray.map((val, i) =>{
												let str = this.state.selectedKeyOpt;
												str = str.replaceAll(' ','');
												let str2 = val.replaceAll(' ','');
												let inputVal = this.state[str+'-'+str2] ? this.state[str+'-'+str2] : '';
												if(val){
													return (
														<div className="col-md-12 form-group">
															<label>{val}</label>
															<DebounceInput debounceTimeout={4000} type="text" className="form-control" value={inputVal} name={str+'-'+str2} onChange={this.getValue} />
														</div>
													);
												}
											}) 
										:null}
									</div>
								  <div className="modal-footer">
								  <button type="button" className="btn btn-primary float-right" data-dismiss="modal" onClick={this.saveDimensions}>Save</button>
								  <button type="button" className="btn btn-danger float-right" data-dismiss="modal">Close</button>
								  </div>

								</div>
							</div>
							</div>

							<div className="modal" id="createBuild">
								<div className="modal-dialog modal-lg">
									<div className="modal-content">
										<div className="modal-header">
											<button type="button" className="close" data-dismiss="modal">&times;</button>
										</div>
										<div className="modal-body">
											{this.state.dataMode == 'MDS' ? 'The MDS was saved!':''}
											{this.state.dataMode == 'Child' ? 'The Default Layout was saved!':''}
										</div>
										<div className="modal-footer">
											{this.state.dataMode == 'MDS' || this.state.dataMode == 'Child' ?
												<button type="button" className="btn btn-primary float-left" onClick={this.buildMds} >Ok</button>
											:null}
											{/* this.state.dataMode == 'Child' ?
												<button type="button" className="btn btn-primary float-left" onClick={this.buildMds} >Ok</button>
											:null */}
											<button type="button" className="btn btn-danger float-right" data-dismiss="modal">Cancel</button>
										</div>
									</div>
								</div>
							</div>
							{dataMode == 'TestForm' ?
							<div className="modal" id="notesTemplate">
								<div className="modal-dialog modal-lg">
									<div className="modal-content">
										<div className="modal-header">
											<button type="button" className="close" data-dismiss="modal">&times;</button>
										</div>
										<div className="modal-body">
											<p>Test Notes and Letter Templates with this entry?</p>
										</div>
										<div className="modal-footer">
											<button type="button" className="btn btn-primary float-left" onClick={this.getNotesTemplateUrl} >Yes</button>
											<button type="button" className="btn btn-danger float-right" data-dismiss="modal">No</button>
										</div>
									</div>
								</div>
							</div>
							:null}
							</div>
					:null}
					</div>
					{showUserSection ?
						<MongoUserManager 
							instances={this.state.instances} 
						/>
					:null}
					
					{showLookDataManager ?
						<LookDataManager 
							getLookUpData={this.getLookUpData} 
							instances={this.state.instances} 
							delegateTypes={this.state.delegateTypes} 
							assTypes={this.state.types} 
							deviceTypes={this.state.deviceTypes} 
							visitTypes={this.state.visitTypes} 
							anatomyList={this.state.anatomyList} 
						/>
					:null}
					
					{showSuggestManager ?
						<SuggestFields 
							//getLookUpData={this.getLookUpData} 
						/>
					:null}
					
					{showMongoMoveMdsSection ?
					<MongoDBMoveMdsManager 
						mdsSheets={this.state.mdsSheets}
						selectedInstanceId={this.state.selectedInstanceId}
						//getMdsSheets={this.getMdsSheetsWithfields}
						getMdsSheets={this.getMdsSheets}
						delegateTypes={this.state.delegateTypes}
						selectedInstance={this.selectedInstance}
						instances={this.state.instances}
						getValue2={this.getValue}
						auditLog={this.auditLog}
						
					/>
					:null}
					
					{showMongoMdsSection ?
					<MongoDBMdsManager 
						mdsSheets={this.state.mdsSheets}
						selectedInstanceName={this.state.selectedInstanceName}
						selectedInstanceId={this.state.selectedInstanceId}
						//getMdsSheets={this.getMdsSheetsWithfields}
						getMdsSheets={this.getMdsSheets}
						delegateTypes={this.state.delegateTypes}
						selectedInstance={this.selectedInstance}
						instances={this.state.instances}
						getValue2={this.getValue}
						auditLog={this.auditLog}
						
					/>
					:null}
					{showMongoSection ?
					<MongoDBLayoutManager 
						childSheets={this.state.childSheets}
						getLayoutSheets={this.getLayoutSheets}
						delegateTypes={this.state.delegateTypes}
						selectedInstanceId={this.state.selectedInstanceId}
						selectedInstance={this.selectedInstance}
						instances={this.state.instances}
						getValue2={this.getValue}
						auditLog={this.auditLog}
					/>
					:null}
					
					{showTestSection ?
					<TestReviewManager 
						improveMode={this.improveMode}
						childSheets={this.state.childSheets}
						flayoutTypes={this.state.flayoutTypes}
						fdeviceTypes={this.state.fdeviceTypes}
						fvisitTypes={this.state.fvisitTypes}
						selectedInstanceId={this.state.selectedInstanceId}
						instancesList={this.state.instances}
						getValue2={this.getValue}
						getLayoutSheetsV2={this.getLayoutSheetsV2}
						ftrack={this.state.ftrack}
					/>
					:null}
					
					{ this.state.instanceManager ?
						<InstanceManager getInstances={this.getInstances} getValue={this.getValue} defaultProps={this.state} mdsSheets={this.state.mdsSheets} resetInstance={this.resetInstance} mdsFromGoogleSheet={this.mdsFromGoogleSheet} selectedInstanceName={this.state.selectedInstanceName} selectedInstanceId={this.state.selectedInstanceId} mongoStoreNewMds={this.mongoStoreNewMds}/>
					:null}
					
					{showTranslationManager ?
					<TranslationManager 
						selectedInstanceName={this.state.selectedInstanceName}
						selectedInstanceId={this.state.selectedInstanceId}
					/>
					:null}
					
				</div>
				
				<div className="modal" id={"suggestNewFiels"} role="dialog">
					<div className="modal-dialog modal-lg modal-dialog-2">
						<div className="modal-content">
						  <div className="modal-header">
							<h4 className="modal-title">New Field suggestion</h4>
							<button type="button" className="close" data-dismiss="modal">&times;</button>
						  </div>
						  <div className="modal-body">
								<div className="suggest-f">
									<label> What is the goal of the new field? </label>
									<DebounceInput value={this.state.suggest1} element="textarea" rows="2" debounceTimeout={4000} className="form-control" name='suggest1' onChange={this.getValue} />
								</div>
								<div className="suggest-f">
									<label> What type of field would be best? </label>
									<select value={this.state.suggest2} className="form-control" name={'suggest2'} onChange={this.getValue}>
										<option value="Free Text">Free Text</option>
										<option value="Single Checkbox">Single Checkbox</option>
										<option value="Drop down select from fixed list">Drop down select from fixed list</option>
										<option value="Drop down select with blue plus box">Drop down select with blue plus box</option>
										<option value="Yes">Drop down select with Zeus-Admin managed blue plus box</option>
										<option value="Multiple selection">Multiple selection</option>
										<option value="Free Text">Checkbox with required description</option>
										<option value="Other">Other</option>
									</select>
								</div>
								{suggestOp ?
									<div className="suggest-f">
										<label> Type of field:</label>
										<DebounceInput value={this.state.suggest2a} type="text" debounceTimeout={4000} className="form-control" name='suggest2a' onChange={this.getValue} />
									</div>
								:null}
								<div className="suggest-f">
									<label> Suggested text for the field:</label>
									<DebounceInput value={this.state.suggest3} element="textarea" rows="2" debounceTimeout={4000} className="form-control" name='suggest3' onChange={this.getValue} />
								</div>
								
								<div className="suggest-f">
									<label> Selection Options:</label>
									<DebounceInput value={this.state.suggest4} element="textarea" rows="2" debounceTimeout={4000} className="form-control"name='suggest4' onChange={this.getValue} />
								</div>
								
								<div className="suggest-f">
									<label> Additional Information that would be helpful when creating this field:</label>
									<DebounceInput value={this.state.suggest5} element="textarea" rows="3" debounceTimeout={4000} className="form-control" name='suggest5' onChange={this.getValue} />
								</div>
						  </div>
						  <div className="modal-footer">
								<div className="popup-btn-com">
									<button type="button" className="btn btn-primary float-left mr-2" onClick={this.saveSuggestReview}>Submit Suggestion</button>
									<button type="button" className="btn btn-danger float-right" data-dismiss="modal">Close</button>
								</div>
						  </div>
						</div>
					</div>
				</div>
				
				
				<div className="modal" id={'kioskUser'}>
					<div className="modal-dialog modal-lg modal-sm select-modal">
						<div className="modal-content">
							<div className="modal-header">
								<h4 className="modal-title">Delegate Mode</h4>
								<button type="button" className="close" data-dismiss="modal">&times;</button>
							</div>
							<div className="modal-body">
								<label> Select Users Type: </label>
								<select className="form-control dele-select" name={this.state.fieldId} onChange={this.selectKioskUsers} value={this.state.delegateUsers.get(this.state.fieldId)} multiple>
								{optionsHtml2}
								</select>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn btn-primary float-left" data-dismiss="modal" onClick={()=>this.updateDataKiosk(this.state.fieldId)}> Save </button>
								<button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
							</div>
						</div>
					</div>
				</div>
				
				<div className="modal" id={'fieldPreview'}>
					<div className="modal-dialog modal-lg modal-sm select-modal modal-dialog-2">
						<div className="modal-content">
							<div className="modal-header">
								<h4 className="modal-title">Field Preview</h4>
								<button type="button" className="close" data-dismiss="modal">&times;</button>
							</div>
							<div className="modal-body">
								{this.state.previewData ? 
									generatehtmlforFiled(this.state.previewData,this.subQuestions,this.state.kioskResponse,this.state.apiPdfs,this.state.outputText)
								:null}
							</div>
							<div className="modal-footer custom-preview">
								<div className="action-btn-2"><span>Include</span><span>Require</span><span>Delegate</span><span>Select Delegate</span></div>
								{fieldButtons(this.state.previewData)}
								<button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
							</div>
						</div>
					</div>
				</div>
				
				<div className="modal" id={'copyModal'}>
					<div className="modal-dialog modal-lg modal-sm select-modal">
						<div className="modal-content">
							<div className="modal-header">
								<button type="button" className="close" data-dismiss="modal">&times;</button>
							</div>
							<div className="modal-body">
								<label> Suffix (copy): </label>
								<DebounceInput debounceTimeout={4000} className="form-control" type="text" name='suffix' onChange={this.getValue} value={this.state.suffix} />
								<label> Include (copy): </label>
								<select className="form-control" name='IncludeCopy' onChange={this.getValue}>
								<option value="Yes">Yes</option>
								<option value="No">No</option>
								</select>
							</div>
							<div className="modal-footer">
								{ this.state.copyValue && this.state.copyValue[126] == 'Y' ||  this.state.copyValue[127] == 'Y' ?
								<button type="button" className="btn btn-primary float-left" data-dismiss="modal" onClick={()=>this.copyGroupFields(this.state.copyValue)}> Save </button>
								:
								<button type="button" className="btn btn-primary float-left" data-dismiss="modal" onClick={()=>this.copyField(this.state.copyValue)}> Save </button>
								}
								<button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
							</div>
						</div>
					</div>
				</div>
				
				<div className="modal" id={"newMdsPopup"} role="dialog">
					<div className="modal-dialog modal-lg">
						<div className="modal-content">
						  <div className="modal-header">
							<button type="button" className="close" data-dismiss="modal">&times;</button>
						  </div>
						  <div className="modal-body">
								<label> New MDS file name: </label>
								<DebounceInput debounceTimeout={4000} id="newMdsName" className="form-control" type="text" name='newMdsName' onChange={this.getValue} />
						  </div>
						  <div className="modal-footer">
								<div className="popup-btn-com">
									<button type="button" className="btn btn-primary float-left mr-2" onClick={this.saveAsCopyMds} data-dismiss="modal">Save</button>
									<button type="button" className="btn btn-danger float-right" data-dismiss="modal">Close</button>
								</div>
						  </div>
						</div>
					</div>
				</div>
				
				<div className="modal" id={"newLayoutPopup"} role="dialog">
					<div className="modal-dialog modal-lg">
						<div className="modal-content">
						  <div className="modal-header">
							<button type="button" className="close" data-dismiss="modal">&times;</button>
						  </div>
						  <div className="modal-body">
								<label> New Layout name: </label>
								<DebounceInput debounceTimeout={4000} id="newLayoutName" className="form-control" type="text" name='newLayoutName' onChange={this.getValue} />
						  </div>
						  <div className="modal-footer">
								<div className="popup-btn-com">
									<button type="button" className="btn btn-primary float-left mr-2" onClick={this.saveAsCopyLayout} data-dismiss="modal">Save</button>
									<button type="button" className="btn btn-danger float-right" data-dismiss="modal">Close</button>
								</div>
						  </div>
						</div>
					</div>
				</div>
				
				
				<div className="modal" id='startWorkflow'>
					<div className="modal-dialog modal-lg modal-sm select-modal">
						<div className="modal-content">
							<button type="button" className="close custom-close-btn" data-dismiss="modal">&times;</button>
							<div className="modal-body start-w-modal">
							<div className="row justify-content-center">
								<div className="col-md-10">
								{/* <div className="form-group">
									<select className="form-control" name="workflowCategory" onChange={this.getWorkflows}>
										<option value={''}>Select Category</option>
										{categoryOption}
									</select>
								</div>	 */}
								<div className="form-group">
									<select id="workflows" className="form-control" name="workflows">
										<option value={''}>Select Workflow</option>
										{workflowsOption}
									</select>
								</div>
								
								<div className="form-group">
									<DebounceInput debounceTimeout={4000} type="text" className="form-control" name="Branch_ID" onChange={this.getValue} placeholder="Branch ID" />
								</div>
								
								<div className="form-group">
									<DebounceInput debounceTimeout={4000} type="text" className="form-control" name="Wip_ID" onChange={this.getValue} placeholder="Wip ID" />
								</div>
								
								<div className="form-group">
									<DebounceInput debounceTimeout={4000} type="text" className="form-control" name="Link_Url" onChange={this.getValue} placeholder="Link Url" />
								</div>
								
								<button type="button" className="btn btn-primary btn-block" onClick={()=> this.workflowInitiate()} > Begin Workflow </button>
							</div>
							</div>
							</div>
							
						</div>
					</div>
				</div>
				
				<div className="modal" id='formRating'>
					<div className="modal-dialog modal-lg modal-sm select-modal">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title">Please provide feedback on anything that could be done to make this form better.</h5>
								<button type="button" className="close" data-dismiss="modal">&times;</button>
							</div>
							<div className="modal-body">
								<textarea name="formDescription" className="form-control" value={this.state.formDescription} onChange={this.getValue}></textarea>
								<div className="form-rating">
								<label> Rating: </label>
								{/* <input type="number" id="formRatingInput" className="form-control" value={this.state.formRating} name="formRating" min="1" max="5" onChange={this.getValue}/> */}
								
								<div className="row">
									<div className="col-md-12">
										<Radio onChange={this.getValue} checked={this.state.formRating === '1'} value="1" name="formRating" size="small" /> Needs a lot of work
									</div>
								</div>
								<div className="row">
									<div className="col-md-12">
										<Radio onChange={this.getValue} checked={this.state.formRating === '2'} value="2" name="formRating" size="small" /> Needs moderate work
									</div>
								</div>
								<div className="row">
									<div className="col-md-12">
										<Radio onChange={this.getValue} checked={this.state.formRating === '3'} value="3" name="formRating" size="small" /> Good enough for 1.0
									</div>
								</div>
								<div className="row">
									<div className="col-md-12">
										<Radio onChange={this.getValue} checked={this.state.formRating === '4'} value="4" name="formRating" size="small" /> Very Good
									</div>
								</div>
								<div className="row">
									<div className="col-md-12">
										<Radio onChange={this.getValue} checked={this.state.formRating === '5'} value="5" name="formRating" size="small" /> Great
									</div>
								</div>
								
								</div>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn btn-primary float-left" data-dismiss="modal" onClick={()=> this.handleSubmitSave()}> Save </button>
								<button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
							</div>
						</div>
					</div>
				</div>
				
				<div className="modal" id={'videoList'}>
					<div className="modal-dialog modal-lg modal-sm select-modal modal-dialog-2">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title">Select a video to insert into note </h5>
								<button type="button" className="close" data-dismiss="modal">&times;</button>
							</div>
							<div className="modal-body video-list-div">
								
								<div className="tag-section">
								<h6 className="modal-title">Limit video list by selecting or removing tags</h6>
								{videoTags.map((val, i) => (
									<div className="v-tag" key={i}><input name={val} type="checkbox" checked={this.state[val] ? true : false}  onChange={this.filterVideoList}/> {val}</div>
								))}
								</div>
								
								<div className="video-section">
								<h6 className="modal-title">Select a video from below and then click Embed to add embed code to the note</h6>
								<div className="video-section-table">
								<table className="table table-bordered">
								<tbody>
								{filterVideo.map((val, i) => (
									<tr key={i}>
										<td className="v-list">{val.name}</td>
										<td className="v-list">{val.description}</td>
										<td className="v-list">{val.tags.join(', ')}</td>
										<td className="v-list">
											<button type="button" className="btn btn-primary btn-embed" onClick={()=>this.previewEmbedCode(val.embedCode)}>Preview</button>
										</td>
										
										<td className="v-list">
											<button type="button" className="btn btn-primary btn-embed" onClick={()=>this.inserEmbedCode(val.embedCode)}>Embed</button>
										</td>
									</tr>
								))}
								</tbody>
								</table>
								</div>
								</div>
								
							</div>
						</div>
					</div>
				</div>
				
				<div className="modal" id={'inlineVideoList'}>
					<div className="modal-dialog modal-lg modal-sm select-modal modal-dialog-2">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title">Select a video to insert! </h5>
								<button type="button" className="close" data-dismiss="modal">&times;</button>
							</div>
							<div className="modal-body video-list-div">
								
								<div className="tag-section">
								<h6 className="modal-title">Limit video list by selecting or removing tags</h6>
								{videoTags.map((val, i) => (
									<div className="v-tag" key={i}><input name={val} type="checkbox" checked={this.state[val] ? true : false}  onChange={this.filterVideoList}/> {val}</div>
								))}
								</div>
								
								<div className="video-section">
								<h6 className="modal-title">Select a video from below and then click Embed to add embed code to the note</h6>
								<div className="video-section-table">
								<table className="table table-bordered">
								<tbody>
								{filterVideo.map((val, i) => (
									<tr key={i}>
										<td className="v-list">{val.name}</td>
										<td className="v-list">{val.description}</td>
										<td className="v-list">{val.tags.join(', ')}</td>
										<td className="v-list">
											<button type="button" className="btn btn-primary btn-embed" onClick={()=>this.previewEmbedCode(val.embedCode)}>Preview</button>
										</td>
										
										<td className="v-list">
											<button type="button" className="btn btn-primary btn-embed" onClick={()=>this.inserInlineEmbedCode(val.embedCode)}>Embed</button>
										</td>
									</tr>
								))}
								</tbody>
								</table>
								</div>
								</div>
								
							</div>
						</div>
					</div>
				</div>
				
				<div className="modal" id={'imageList'}>
					<div className="modal-dialog modal-lg modal-sm select-modal modal-dialog-2">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title">Select an image to insert into the field </h5>
								<button type="button" className="close" data-dismiss="modal">&times;</button>
							</div>
							<div className="modal-body video-list-div">
								
								<div className="tag-section">
								<h6 className="modal-title">Limit image list by selecting or removing tags</h6>
								{imageTags.map((val, i) => (
									<div className="v-tag" key={i}><input name={val} type="checkbox" checked={this.state[val] ? true : false}  onChange={this.filterImageList}/> {val}</div>
								))}
								</div>
								
								<div className="video-section">
								<h6 className="modal-title">Select an image from below and then click Embed to add embed code to the note</h6>
								<div className="video-section-table">
								<table className="table table-bordered">
								<tbody>
								{filterImage.map((val, i) => (
									<tr key={i}>
										<td className="v-list">{val.name}</td>
										<td className="v-list">{val.description}</td>
										<td className="v-list">{val.tags.join(', ')}</td>
										<td className="v-list">
											<button type="button" className="btn btn-primary btn-embed" onClick={()=>this.previewImage(val.url)}>Preview</button>
										</td>
										
										<td className="v-list">
											<button type="button" className="btn btn-primary btn-embed" onClick={()=>this.inserImageUrl(val.url)}>Embed</button>
										</td>
									</tr>
								))}
								</tbody>
								</table>
								</div>
								</div>
								
							</div>
						</div>
					</div>
				</div>
				
				<div className="modal" id={'imageList2'}>
					<div className="modal-dialog modal-lg modal-sm select-modal modal-dialog-2">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title">Select an image to insert into the field </h5>
								<button type="button" className="close" data-dismiss="modal">&times;</button>
							</div>
							<div className="modal-body video-list-div">
								
								<div className="tag-section">
								<h6 className="modal-title">Limit image list by selecting or removing tags</h6>
								{imageTags.map((val, i) => (
									<div className="v-tag" key={i}><input name={val} type="checkbox" checked={this.state[val] ? true : false}  onChange={this.filterImageList}/> {val}</div>
								))}
								</div>
								
								<div className="video-section">
								<h6 className="modal-title">Select an image from below and then click Embed to add embed code to the note</h6>
								<div className="video-section-table">
								<table className="table table-bordered">
								<tbody>
								{filterImage.map((val, i) => (
									<tr key={i}>
										<td className="v-list">{val.name}</td>
										<td className="v-list">{val.description}</td>
										<td className="v-list">{val.tags.join(', ')}</td>
										<td className="v-list">
											<button type="button" className="btn btn-primary btn-embed" onClick={()=>this.previewImage(val.url)}>Preview</button>
										</td>
										
										<td className="v-list">
											<button type="button" className="btn btn-primary btn-embed" onClick={()=>this.inserImageUrlNote(val.url)}>Embed</button>
										</td>
									</tr>
								))}
								</tbody>
								</table>
								</div>
								</div>
								
							</div>
						</div>
					</div>
				</div>
				
				<div className="modal" id={'uploadflyingVideo'}>
					<div className="modal-dialog modal-lg modal-sm select-modal modal-dialog-2">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title">Upload the Video in My Flyes Site</h5>
								<button type="button" className="close" data-dismiss="modal">&times;</button>
							</div>
							<div className="modal-body video-list-div">
							{this.state.FylesVideoPopup ?
								<BasicUploadVideo  getVideoFromApi={this.getVideoFromApi} allVideoTags={this.state.allVideoTags}/>
							:null}
							</div>
						</div>
					</div>
				</div>
				
				<div className="modal video-preview" id={'videoPreview'}>
					<div className="modal-dialog modal-video-pre">
						<div className="modal-content">
							<div id="preView" className="modal-body">
							</div>
						</div>
					</div>
				</div>
				
				<div className="modal video-preview" id={'imagePreview'}>
					<div className="modal-dialog modal-video-pre">
						<div className="modal-content">
							<div id="preImgView" className="modal-body">
							</div>
						</div>
					</div>
				</div>
				
				<div className="modal" id={"editOptionPopup"} role="dialog">
					<div className="modal-dialog modal-lg">
						<div className="modal-content">
						  <div className="modal-header">
							<button type="button" className="close" data-dismiss="modal">&times;</button>
						  </div>
						  <div className="modal-body">
							  <div className="op-input">
									<label> Option: </label>
									<DebounceInput debounceTimeout={4000} type="text" className="form-control" value={this.state.optionKey} name="optionKey" onChange={this.getValue} />
							  </div>
							  <div className="op-input">
									<label> Key Value: </label>
									<DebounceInput debounceTimeout={4000} type="text" className="form-control" value={this.state.optionKeyValue} name="optionKeyValue" onChange={this.getValue}/>
							  </div>
							  {role == 'Administrator' ?
							   <div className="op-input">
									<label> OPIE ENUM: </label>
									<DebounceInput debounceTimeout={4000} type="text" className="form-control" value={this.state.optionKeyEnum} name="optionKeyEnum" onChange={this.getValue}/>
							  </div>
							  :null}
						  </div>
						  <div className="modal-footer">
								<div className="popup-btn-com">
									<button type="button" className="btn btn-primary float-left mr-2" onClick={this.editOptionKeyUpdate} data-dismiss="modal">Save</button>
									<button type="button" className="btn btn-danger float-right" data-dismiss="modal">Close</button>
								</div>
						  </div>
						</div>
					</div>
				</div>
				
				<div className="modal" id={"editOptionPopup2"} role="dialog">
					<div className="modal-dialog modal-lg">
						<div className="modal-content">
						  <div className="modal-header">
							<button type="button" className="close" data-dismiss="modal">&times;</button>
						  </div>
						  <div className="modal-body">
							  <div className="op-input">
									<label> Option: </label>
									<DebounceInput debounceTimeout={4000} type="text" className="form-control" value={this.state.optionKey} name="optionKey" onChange={this.getValue} />
							  </div>
							  {role == 'Administrator' ?
							   <div className="op-input mb-2">
									<label> OPIE ENUM: </label>
									<DebounceInput debounceTimeout={4000} type="text" className="form-control" value={this.state.optionKeyEnum} name="optionKeyEnum" onChange={this.getValue}/>
							  </div>
							  :null}
							  
								{this.state.chooseAnsType == 'Q11b' ?
								<div className="op-input mb-2">
								   <input name="addOpDetails" type="checkbox" checked={this.state.addOpDetails == "Y" ? true : false} value="Y" onChange={this.getValue} /> Add Details
								</div>
								:null}
								{this.state.addOpDetails == "Y" && this.state.chooseAnsType == 'Q11b' ?
									<DebounceInput debounceTimeout={4000} type="text" className="form-control" value={this.state.addOpDetailsTxt} name="addOpDetailsTxt" onChange={this.getValue} />
								:null}
							  
						  </div>
						  <div className="modal-footer">
								<div className="popup-btn-com">
									<button type="button" className="btn btn-primary float-left mr-2" onClick={this.editOptionKeyUpdate2} data-dismiss="modal">Save</button>
									<button type="button" className="btn btn-danger float-right" data-dismiss="modal">Close</button>
								</div>
						  </div>
						</div>
					</div>
				</div>
				
            </div>
        );
    }
}

export default MdsBuilder;